import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import api from "../services/axiosInstance";
import { backendPort } from "../components/Fungsiku";
import { useGlobalOpsi } from "../components/GlobalOpsi";
import { useNotification } from "./NotifPopup";
import { PageKonten9_Pict } from "./Page9_Pict";
import { ShowPic } from "../components/ShowPic";
import { ModalBanShow } from "./Page28_BanShow";
import { ModalCariBanMulti } from "./Page27_Cari";
import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const STOK_ACTIONS = [
  {
    value: "pembelian_baru",
    title: "PEMBELIAN BAN",
    description: "Pencatatan Pengadaan Ban Baru/Bekas untuk Stok Gudang",
    submitLabel: "Simpan Pembelian",
  },
  {
    value: "perubahan_status_ban",
    title: "UBAH STATUS MANUAL",
    description: "Perubahan status ban manual. Status Afkir/Disposal/Untracked wajib persetujuan pusat.",
    submitLabel: "Simpan Perubahan",
  },
  {
    value: "ubah_data_massal",
    title: "UBAH STATUS MASSAL (BULK)",
    description: "Perubahan status ban secara massal menggunakan file excel.",
    submitLabel: "Pilih Ban",
  },
  {
    value: "ubah_profil_ban",
    title: "UBAH PROFIL BAN",
    description: "Ubah merk, ukuran, telapak, dan suplier ban gudang.",
    submitLabel: "Backend menyusul",
  },
  {
    value: "pengiriman_casing",
    title: "PENGIRIMAN BAN KE PABRIK",
    description: "Pencatatan pengiriman ban dari gudang ke pabrik.",
    submitLabel: "Simpan Pengiriman Casing",
  },
  {
    value: "terima_ban_vulkanisir",
    title: "PENGIRIMAN BAN DARI PABRIK",
    description: "Pengiriman ban Vulkanisir/Retread dari pabrik ke gudang cabang.",
    submitLabel: "Simpan Pengiriman Retread",
  },
  {
    value: "perintah_pemindahan_stock",
    title: "PERINTAH PEMINDAHAN STOCK",
    description: "Peritah untuk Cabang agar memindahkan stok ban ke cabang lain.",
    submitLabel: "Simpan Perintah Pemindahan",
  },
  {
    value: "pengiriman_ban_ke_cabang_lain",
    title: "PENGIRIMAN BAN KE CABANG LAIN",
    description: "Pengiriman ban antar cabang berdasarkan perintah pemindahan stok.",
    submitLabel: "Simpan Pengiriman",
  },
  {
    value: "konfirmasi_terima_ban",
    title: "KONFIRMASI TERIMA BAN",
    description: "Konfirmasi Penerimaan Ban oleh Gudang Cabang",
    submitLabel: "Simpan Konfirmasi Terima",
  },
  {
    value: "persetujuan_ubah_status",
    title: "PERSETUJUAN UBAH STATUS",
    description: "Persetujuan atas usulan perubahan status ban, afkir, disposal, dan untracked",
    submitLabel: "Lihat",
  },
];

const MUTASI_STOK_ACTION_VALUES = [
  "pembelian_baru",
  "pengiriman_casing",
  "terima_ban_vulkanisir",
  "perintah_pemindahan_stock",
  "pengiriman_ban_ke_cabang_lain",
  "konfirmasi_terima_ban",
];

const UPDATE_DATA_BAN_ACTION_VALUES = [
  "perubahan_status_ban",
  "ubah_data_massal",
  "ubah_profil_ban",
  "persetujuan_ubah_status",
];
const PUSAT_ONLY_ACTION_VALUES = new Set([
  "pembelian_baru",
  "perintah_pemindahan_stock",
  "terima_ban_vulkanisir",
  "persetujuan_ubah_status",
]);

const EMPTY_PEMBELIAN_BARU = {
  kodeCabang: "",
  nomor: "-",
  tanggal: "",
  noDokumen: "",
  tglDokumen: "",
  qty: "",
  catatan: "",
};

const EMPTY_PENGIRIMAN_CASING = {
  kodeCabang: "",
  nomor: "-",
  tanggal: "",
  noDokumen: "",
  tglDokumen: "",
  qty: "",
  vendor: "",
  catatan: "",
};
const EMPTY_PERINTAH_PEMINDAHAN_STOCK = {
  kodeCabang: "",
  kodeCabangPenerima: "",
  nomor: "-",
  tanggal: "",
  noDokumen: "",
  tglDokumen: "",
  qty: "",
  catatan: "",
};
const EMPTY_TERIMA_BAN_VULKANISIR = {
  kodeCabang: "",
  nomor: "-",
  tanggal: "",
  noDokumen: "",
  tglDokumen: "",
  vendor: "",
  catatan: "",
};
const EMPTY_PENGIRIMAN_BAN_KE_CABANG_LAIN = {
  kodeCabang: "",
  nomor: "",
  tanggal: "",
  catatanPusat: "",
  catatan: "",
};
const EMPTY_KONFIRMASI_TERIMA_BAN = { kodeCabang: "" };
const EMPTY_PERUBAHAN_STATUS_BAN = { kodeCabang: "", nomor: "-", tanggal: "" };
const EMPTY_UBAH_DATA_MASSAL = {
  kodeCabang: "C-1",
  nomor: "-",
  tanggal: "",
  filterCabang: "",
};
const EMPTY_UBAH_PROFIL_BAN = {
  kodeCabang: "C-1",
  nomor: "-",
  tanggal: "",
};

const DEFAULT_VENDOR_OPSI = ["suplier", "suplier2", "suplier3"];
const OPSI_STATUS_BAN_PEMBELIAN = ["NT", "UT", "VT-1", "UV-1", "Casing"];
const OPSI_JENIS_REPAIR_PABRIK = ["Vulkanisir", "Oper Telapak", "Tambal", "Klaim"];
const OPSI_STATUS_RETREAD_CUSTOM = ["Casing", "Afkir"];
const TELAPAK_DEFAULT = "Tidak Diketahui";
const TELAPAK_ADD = "__ADD_TELAPAK__";
const REQ_GROUP_KONFIRMASI_TERIMA_LIST = "page30-konfirmasi-terima-list";
const REQ_GROUP_KONFIRMASI_TERIMA_DETAIL = "page30-konfirmasi-terima-detail";
const REQ_GROUP_PEMBELIAN_SUBMIT = "page30-pembelian-submit";
const REQ_GROUP_CASING_LOAD = "page30-casing-load";
const REQ_GROUP_CASING_SUBMIT = "page30-casing-submit";
const REQ_GROUP_PERINTAH_PINDAH_SUBMIT = "page30-perintah-pindah-submit";
const REQ_GROUP_RETREAD_LOAD = "page30-retread-load";
const REQ_GROUP_RETREAD_SUBMIT = "page30-retread-submit";
const REQ_GROUP_KONFIRMASI_AKSI = "page30-konfirmasi-aksi";
const REQ_GROUP_KONFIRMASI_SUBMIT = "page30-konfirmasi-submit";
const REQ_GROUP_STATUS_MANUAL_SUBMIT = "page30-status-manual-submit";
const REQ_GROUP_STATUS_MASSAL_SUBMIT = "page30-status-massal-submit";
const REQ_GROUP_UBAH_PROFIL_BAN_SUBMIT = "page30-ubah-profil-ban-submit";
const REQ_GROUP_PERSETUJUAN_STATUS_LIST = "page30-persetujuan-status-list";
const REQ_GROUP_PERSETUJUAN_STATUS_DETAIL = "page30-persetujuan-status-detail";
const REQ_GROUP_PERSETUJUAN_STATUS_SUBMIT = "page30-persetujuan-status-submit";
const REQ_GROUP_PENGIRIMAN_CABANG_DELETE = "page30-pengiriman-cabang-delete";
const REQ_GROUP_PENGIRIMAN_CABANG_SUBMIT = "page30-pengiriman-cabang-submit";
const DISABLED_LEGACY_ACTIONS = new Set(["usulan_afkir", "disposal", "usulan_untracked"]);
const CABANG_ALL_VALUE = "ALL";

const buildTodayKey = () => {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

const splitPeriod = (dateKey) => {
  const value = String(dateKey || "");
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const [year, month] = value.split("-");
  return { year, month };
};
const NOMOR_PREVIEW_PLACEHOLDER = "-";
const FORCED_LOCATION_GUDANG_ONLY = Object.freeze(["gudang"]);
const BLOCKED_LOCATION_OTF_ONLY = Object.freeze(["otf"]);
const buildNomorPreviewPlaceholder = ({ kodeCabang, prefix, tanggal }) => {
  const cabang = String(kodeCabang || "").trim().toUpperCase();
  const safePrefix = String(prefix || "WO").trim().toUpperCase() || "WO";
  const period = splitPeriod(tanggal || buildTodayKey());
  if (!cabang || !period?.month || !period?.year) return NOMOR_PREVIEW_PLACEHOLDER;
  return `${cabang}/${safePrefix}/${period.month}/${period.year}/-`;
};
const buildNomorSubmitPlaceholder = ({ kodeCabang, prefix, tanggal }) => {
  const cabang = String(kodeCabang || "").trim().toUpperCase();
  const safePrefix = String(prefix || "WO").trim().toUpperCase() || "WO";
  const period = splitPeriod(tanggal || buildTodayKey());
  if (!cabang || !period?.month || !period?.year) return NOMOR_PREVIEW_PLACEHOLDER;
  return `${cabang}/${safePrefix}/${period.month}/${period.year}/0`;
};

const normalizeKodeCabang = (value) => String(value || "").trim().toUpperCase();
const normalizeNomorKey = (value) => String(value || "").trim().replace(/\/(?:-|0)$/, "");
const sanitizeNoDokumenInput = (value) => String(value || "").replace(/#/g, "");
const hasForbiddenNoDokumenCharacter = (value) => String(value || "").includes("#");

const extractKodeCabangFromNomorMemo = (nomorMemo) => {
  const memo = String(nomorMemo || "").trim().toUpperCase();
  if (!memo) return "";
  const leadingToken = memo.split("/").map((x) => x.trim()).find(Boolean) || "";
  if (!leadingToken) return "";
  return normalizeKodeCabang(leadingToken);
};

const createPembelianBaruRow = (index) => ({
  no: index + 1,
  seriBan: "",
  status: "NT",
  merk: "Bridgestone",
  ukuran: "11,00R22,5",
  td: "16-16-16-16",
  kodeCabangPenerima: "",
  cabangPenerima: "",
  suplier: "",
});

const createPengirimanCasingRow = (index, raw = {}) => ({
  no: index + 1,
  idBan: Number(raw?.idBan || 0),
  seriBan: String(raw?.seriBan || "").trim(),
  status: String(raw?.status || "").trim(),
  place: String(raw?.place || "").trim(),
  kodeCabang: String(raw?.kodeCabang || "").trim(),
  merk: String(raw?.merk || "").trim(),
  ukuran: String(raw?.ukuran || "").trim(),
  cabang: String(raw?.cabang || "").trim(),
  jenisRepair: String(raw?.jenisRepair || OPSI_JENIS_REPAIR_PABRIK[0]).trim() || OPSI_JENIS_REPAIR_PABRIK[0],
  checked: false,
});

const getRepairedStatusOptions = (statusRaw) => {
  const status = String(statusRaw || "").trim().toUpperCase();
  if (/^NT(?:-|$)/.test(status)) return ["UT-1-Repaired"];

  const match = status.match(/^(UT|UV|VT)-(\d+)(?:-.*)?$/);
  if (match?.[1] && match?.[2]) {
    return [`${match[1]}-${Number(match[2])}-Repaired`];
  }

  return ["UT-1-Repaired", "UV-1-Repaired"];
};

const createTerimaVulkanisirRow = (index, raw = {}) => ({
  no: index + 1,
  idBan: Number(raw?.idBan || 0),
  seriBan: String(raw?.seriBan || "").trim(),
  jenisRepair: String(raw?.jenisRepair || "").trim(),
  statusAkhir: String(raw?.statusAkhir || "VT-1").trim() || "VT-1",
  statusBaseOption: String(raw?.statusBaseOption || "VT-1").trim() || "VT-1",
  statusOtOption: String(raw?.statusOtOption || "VT-1-OT").trim() || "VT-1-OT",
  statusRepairedOptions: Array.isArray(raw?.statusRepairedOptions)
    ? raw.statusRepairedOptions.map((value) => String(value || "").trim()).filter(Boolean)
    : getRepairedStatusOptions(raw?.statusRepairedTerakhir),
  telapak: String(raw?.telapak || TELAPAK_DEFAULT).trim() || TELAPAK_DEFAULT,
  ukuran: String(raw?.ukuran || "").trim(),
  td: String(raw?.td || "").trim(),
  merk: String(raw?.merk || "").trim(),
  catatanBan: String(raw?.catatanBan || "").trim(),
  checked: false,
});

const PengirimanCasingTableRow = memo(function PengirimanCasingTableRow({
  row,
  index,
  checked,
  cabangLabel,
  onRepairChange,
  onCheckedChange,
}) {
  return (
    <tr>
      <td>{row.no}</td>
      <td>{row.idBan || "-"}</td>
      <td>{row.seriBan || "-"}</td>
      <td>{row.status || "-"}</td>
      <td>{row.merk || "-"}</td>
      <td>{row.ukuran || "-"}</td>
      <td>{cabangLabel || "-"}</td>
      <td>
        <select
          className="form-select form-select-sm"
          value={row.jenisRepair || OPSI_JENIS_REPAIR_PABRIK[0]}
          onChange={(e) => onRepairChange(index, e.target.value)}
        >
          {OPSI_JENIS_REPAIR_PABRIK.map((opt) => (
            <option key={`repair-opt-${opt}`} value={opt}>{opt}</option>
          ))}
        </select>
      </td>
      <td className="text-center">
        <input
          type="checkbox"
          className="form-check-input"
          checked={checked}
          onChange={(e) => onCheckedChange(index, e.target.checked)}
        />
      </td>
    </tr>
  );
});

const TerimaBanVulkanisirTableRow = memo(function TerimaBanVulkanisirTableRow({
  row,
  originalIndex,
  checked,
  telapakOptions,
  onRowChange,
  onTelapakAdd,
}) {
  return (
    <tr>
      <td>{row.idBan || "-"}</td>
      <td>{row.seriBan || "-"}</td>
      <td>{row.jenisRepair || "-"}</td>
      <td>
        <select
          className="form-select form-select-sm"
          value={row.statusAkhir || "VT-1"}
          onChange={(e) => onRowChange(originalIndex, "statusAkhir", e.target.value)}
        >
          {[row.statusAkhir || "VT-1", row.statusBaseOption || "VT-1", row.statusOtOption || "VT-1-OT", ...OPSI_STATUS_RETREAD_CUSTOM, ...(row.statusRepairedOptions || [])]
            .filter((v, i, arr) => arr.findIndex((x) => String(x).toUpperCase() === String(v).toUpperCase()) === i)
            .map((opt) => (
              <option key={`status-retread-${row.idBan}-${opt}`} value={opt}>
                {opt}
              </option>
            ))}
        </select>
      </td>
      <td>
        <select
          className="form-select form-select-sm"
          value={row.telapak || ""}
          onChange={(e) => {
            const value = String(e.target.value || "").trim();
            if (value === TELAPAK_ADD) {
              onTelapakAdd(originalIndex);
              return;
            }
            onRowChange(originalIndex, "telapak", value || TELAPAK_DEFAULT);
          }}
        >
          {telapakOptions.map((opt) => (
            <option key={`telapak-${row.idBan}-${opt}`} value={opt}>
              {opt === TELAPAK_ADD ? "Tambah Jenis Telapak" : opt}
            </option>
          ))}
        </select>
      </td>
      <td>{row.ukuran || "-"}</td>
      <td>
        <input
          className="form-control form-control-sm"
          value={row.td || ""}
          onChange={(e) => onRowChange(originalIndex, "td", e.target.value)}
        />
      </td>
      <td>{row.merk || "-"}</td>
      <td>
        <input
          className="form-control form-control-sm"
          value={row.catatanBan || ""}
          onChange={(e) => onRowChange(originalIndex, "catatanBan", e.target.value)}
        />
      </td>
      <td className="text-center">
        <input
          type="checkbox"
          className="form-check-input"
          checked={checked}
          onChange={(e) => onRowChange(originalIndex, "checked", e.target.checked)}
        />
      </td>
    </tr>
  );
});

const TD_PATTERN = /^\d+-\d+-\d+-\d+$/;
const isTdValueValid = (value) => {
  const raw = String(value || "").trim();
  if (!TD_PATTERN.test(raw)) return false;
  return raw.split("-").every((part) => {
    const num = Number(part);
    return Number.isFinite(num) && num >= 0 && num <= 16;
  });
};
const parseJsonObject = (value, fallback = {}) => {
  if (value == null || value === "") return { ...(fallback || {}) };
  if (typeof value === "object" && !Array.isArray(value)) return value;
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : { ...(fallback || {}) };
    } catch {
      return { ...(fallback || {}) };
    }
  }
  return { ...(fallback || {}) };
};

const parseLampiranArray = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const sanitizeLampiranItemPayload = (item) => {
  if (!item || typeof item !== "object") return null;
  const isBrowserFile = typeof File !== "undefined" && item.file instanceof File;
  const fileName = isBrowserFile ? String(item.file?.name || "").trim() : String(item.file || "").trim();
  const path = String(item.path || "").trim();
  const name = String(item.name || fileName || "").trim();
  if (!name && !fileName && !path) return null;
  return {
    name,
    file: fileName,
    path,
    type: String(item.type || (isBrowserFile ? item.file?.type : "") || "").trim(),
    size: Number(item.size || (isBrowserFile ? item.file?.size : 0) || 0),
    caption: String(item.caption || "").trim(),
    uploaded_at: item.uploaded_at || null,
  };
};

const formatDateYYYYMMDD = (value) => {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}${m}${day}`;
};

const formatDateDDMMYYYY = (value) => {
  if (!value) return "-";
  const raw = String(value || "").trim();
  const isoMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    const [, y, m, d] = isoMatch;
    return `${d}-${m}-${y}`;
  }
  const dt = new Date(value);
  if (Number.isNaN(dt.getTime())) return "-";
  const d = String(dt.getDate()).padStart(2, "0");
  const m = String(dt.getMonth() + 1).padStart(2, "0");
  const y = dt.getFullYear();
  return `${d}-${m}-${y}`;
};

const normalizeStatusText = (value) => String(value || "").trim().toUpperCase();
const stripSystemNotdoneSuffix = (value) => String(value || "").trim().replace(/_notdone$/i, "");
const normalizeStatusOptionLabel = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  const upper = raw.toUpperCase().replace(/_/g, " ").trim();
  if (upper === "NT" || upper === "UT") return upper;
  if (/^(VT|UT|UV)-\d+(-OT)?$/i.test(raw)) return upper;
  if (upper === "CASING") return "Casing";
  if (upper === "AFKIR") return "Afkir";
  if (upper === "UNTRACKED") return "Untracked";
  if (upper === "DISPOSE" || upper === "DISPOSED") return "Disposed";
  if (upper === "PERLU REPAIR" || upper === "PERLU-REPAIR") return "Perlu Repair";
  if (upper === "PERLU OT" || upper === "PERLU-OT") return "Perlu OT";
  return raw;
};
const isUsulanPendingEvent = (eventValue) => normalizeStatusText(eventValue).startsWith("USUL");
const parseTierStatus = (value, prefix) => {
  const raw = normalizeStatusText(value);
  const m = raw.match(new RegExp(`^${prefix}-(\\d+)(?:-.+)?$`));
  return Number(m?.[1] || 0) || 0;
};
const extractTierSuffix = (value, prefix) => {
  const raw = String(value || "").trim();
  const m = raw.match(new RegExp(`^${prefix}-(\\d+)(-.+)$`, "i"));
  return String(m?.[2] || "").trim();
};
const getStatusChangeOptions = (currentStatusRaw) => {
  const current = normalizeStatusText(currentStatusRaw);
  const alwaysShown = ["Casing", "Afkir", "Untracked", "Disposed", "Perlu Repair", "Perlu OT"];
  const mergeUnique = (arr = []) => {
    const out = [];
    const seen = new Set();
    [...arr, ...alwaysShown].forEach((item) => {
      const val = String(item || "").trim();
      if (!val) return;
      const key = val.toUpperCase();
      if (seen.has(key)) return;
      seen.add(key);
      out.push(val);
    });
    return out;
  };
  if (current === "NT") return mergeUnique(["UT", "VT-1"]);
  if (current === "UT") return mergeUnique(["VT-1"]);
  if (current.startsWith("VT-")) {
    const lvl = Math.max(1, parseTierStatus(current, "VT"));
    const suffix = extractTierSuffix(currentStatusRaw, "VT");
    return mergeUnique([`UV-${lvl}${suffix}`, `VT-${lvl + 1}${suffix}`]);
  }
  if (current.startsWith("UV-")) {
    const lvl = Math.max(1, parseTierStatus(current, "UV"));
    const suffix = extractTierSuffix(currentStatusRaw, "UV");
    return mergeUnique([`VT-${lvl + 1}${suffix}`]);
  }
  if (current === "CASING") return mergeUnique([]);
  if (current.startsWith("AFKIR")) return mergeUnique([]);
  if (current.startsWith("DISPOSED") || current.startsWith("UNTRACKED")) return mergeUnique([]);
  return mergeUnique([]);
};

export function PageKonten30Stok({ authIdentity = {}, globalOpsi, resendToken = 0, actionScope = "all", forcedAction = "", forcedActionKey = "" }) {
  const { showNotif } = useNotification();
  const { manualResyncGlobalOpsi } = useGlobalOpsi();
  const formOrderFileRef = useRef(null);
  const [activeAction, setActiveAction] = useState("");
  const actorNama = String(authIdentity?.nama || "").trim();
  const actorUsername = String(authIdentity?.username || "").trim();
  const actorKodeCabang = String(authIdentity?.kode_cabang || "").trim();
  const actorIsPusat = actorKodeCabang === "C-1";

  const [pembelianBaru, setPembelianBaru] = useState({
    ...EMPTY_PEMBELIAN_BARU,
    kodeCabang: "C-1",
    tanggal: buildTodayKey(),
    tglDokumen: buildTodayKey(),
  });
  const [pembelianBaruRows, setPembelianBaruRows] = useState([]);
  const [attachmentsPembelianBaru, setAttachmentsPembelianBaru] = useState([]);
  const [invalidCaptionIndexesPembelianBaru, setInvalidCaptionIndexesPembelianBaru] = useState([]);
  const [pembelianFormOrderMeta, setPembelianFormOrderMeta] = useState({
    fileName: "",
    parsedAt: "",
    error: "",
    valid: false,
    totalRows: 0,
  });
  const [pembelianValidasiMeta, setPembelianValidasiMeta] = useState({
    validated: false,
    confirmed: false,
    invalidByRowNo: {},
    invalidCount: 0,
    validatedAt: "",
  });
  const [isSubmittingPembelianBaru, setIsSubmittingPembelianBaru] = useState(false);
  const [showPembelianBaruTableScreen, setShowPembelianBaruTableScreen] = useState(false);
  const [readySimpanPembelian, setReadySimpanPembelian] = useState(false);

  const [pengirimanCasing, setPengirimanCasing] = useState({
    ...EMPTY_PENGIRIMAN_CASING,
    kodeCabang: actorIsPusat ? "" : actorKodeCabang,
    tanggal: buildTodayKey(),
    tglDokumen: buildTodayKey(),
  });
  const [pengirimanCasingRows, setPengirimanCasingRows] = useState([]);
  const [initialPengirimanCasingRows, setInitialPengirimanCasingRows] = useState([]);
  const [checkedPengirimanCasingIndexes, setCheckedPengirimanCasingIndexes] = useState(() => new Set());
  const [filterTextPengirimanCasing, setFilterTextPengirimanCasing] = useState("");
  const [showOnlySelectedPengirimanCasing, setShowOnlySelectedPengirimanCasing] = useState(false);
  const [loadingPengirimanCasingRows, setLoadingPengirimanCasingRows] = useState(false);
  const [showPengirimanCasingTableScreen, setShowPengirimanCasingTableScreen] = useState(false);
  const [readySimpanPengirimanCasing, setReadySimpanPengirimanCasing] = useState(false);
  const [isSubmittingPengirimanCasing, setIsSubmittingPengirimanCasing] = useState(false);
  const [attachmentsPengirimanCasing, setAttachmentsPengirimanCasing] = useState([]);
  const [invalidCaptionIndexesPengirimanCasing, setInvalidCaptionIndexesPengirimanCasing] = useState([]);
  const [perintahPemindahanStock, setPerintahPemindahanStock] = useState({
    ...EMPTY_PERINTAH_PEMINDAHAN_STOCK,
    kodeCabang: actorIsPusat ? "" : actorKodeCabang,
    tanggal: buildTodayKey(),
    tglDokumen: buildTodayKey(),
  });
  const [readySimpanPerintahPemindahanStock, setReadySimpanPerintahPemindahanStock] = useState(false);
  const [isSubmittingPerintahPemindahanStock, setIsSubmittingPerintahPemindahanStock] = useState(false);
  const [attachmentsPerintahPemindahanStock, setAttachmentsPerintahPemindahanStock] = useState([]);
  const [invalidCaptionIndexesPerintahPemindahanStock, setInvalidCaptionIndexesPerintahPemindahanStock] = useState([]);
  const [openPerintahPemindahanStockModal, setOpenPerintahPemindahanStockModal] = useState(false);
  const [selectedPerintahPemindahanStockRows, setSelectedPerintahPemindahanStockRows] = useState([]);
  const [selectedPerintahPemindahanStockIds, setSelectedPerintahPemindahanStockIds] = useState([]);
  const [pengirimanBanKeCabangLain, setPengirimanBanKeCabangLain] = useState({
    ...EMPTY_PENGIRIMAN_BAN_KE_CABANG_LAIN,
    kodeCabang: actorIsPusat ? "" : actorKodeCabang,
    tanggal: buildTodayKey(),
  });
  const [pengirimanBanKeCabangLainRows, setPengirimanBanKeCabangLainRows] = useState([]);
  const [pendingNomorPengirimanBanKeCabangLainOptions, setPendingNomorPengirimanBanKeCabangLainOptions] = useState([]);
  const [loadingPengirimanBanKeCabangLainRows, setLoadingPengirimanBanKeCabangLainRows] = useState(false);
  const [attachmentsPengirimanBanKeCabangLainReadOnly, setAttachmentsPengirimanBanKeCabangLainReadOnly] = useState([]);
  const [openDeletePengirimanMutasiModal, setOpenDeletePengirimanMutasiModal] = useState(false);
  const [deletePengirimanMutasiTarget, setDeletePengirimanMutasiTarget] = useState({ id_ban: 0, seri_ban: "", nomor: "" });
  const [isDeletingPengirimanMutasi, setIsDeletingPengirimanMutasi] = useState(false);
  const [attachmentsPengirimanBanKeCabangLain, setAttachmentsPengirimanBanKeCabangLain] = useState([]);
  const [invalidCaptionIndexesPengirimanBanKeCabangLain, setInvalidCaptionIndexesPengirimanBanKeCabangLain] = useState([]);
  const [isSubmittingPengirimanBanKeCabangLain, setIsSubmittingPengirimanBanKeCabangLain] = useState(false);
  const [openPengirimanSebagianModal, setOpenPengirimanSebagianModal] = useState(false);
  const catatanPengirimanSebagianRef = useRef(null);
  const [terimaBanVulkanisir, setTerimaBanVulkanisir] = useState({
    ...EMPTY_TERIMA_BAN_VULKANISIR,
    kodeCabang: actorIsPusat ? "" : actorKodeCabang,
    tanggal: buildTodayKey(),
    tglDokumen: buildTodayKey(),
  });
  const [terimaBanVulkanisirRows, setTerimaBanVulkanisirRows] = useState([]);
  const [initialTerimaBanVulkanisirRows, setInitialTerimaBanVulkanisirRows] = useState([]);
  const [checkedTerimaBanVulkanisirIndexes, setCheckedTerimaBanVulkanisirIndexes] = useState(() => new Set());
  const [terimaBanVulkanisirFilterText, setTerimaBanVulkanisirFilterText] = useState("");
  const [showOnlySelectedTerimaBanVulkanisir, setShowOnlySelectedTerimaBanVulkanisir] = useState(false);
  const [loadingTerimaBanVulkanisirRows, setLoadingTerimaBanVulkanisirRows] = useState(false);
  const [showTerimaBanVulkanisirTableScreen, setShowTerimaBanVulkanisirTableScreen] = useState(false);
  const [readySimpanTerimaBanVulkanisir, setReadySimpanTerimaBanVulkanisir] = useState(false);
  const [isSubmittingTerimaBanVulkanisir, setIsSubmittingTerimaBanVulkanisir] = useState(false);
  const [attachmentsTerimaBanVulkanisir, setAttachmentsTerimaBanVulkanisir] = useState([]);
  const [invalidCaptionIndexesTerimaBanVulkanisir, setInvalidCaptionIndexesTerimaBanVulkanisir] = useState([]);
  const [konfirmasiTerimaBan, setKonfirmasiTerimaBan] = useState({
    ...EMPTY_KONFIRMASI_TERIMA_BAN,
    kodeCabang: actorIsPusat ? "" : actorKodeCabang,
  });
  const [perubahanStatusBan, setPerubahanStatusBan] = useState({
    ...EMPTY_PERUBAHAN_STATUS_BAN,
    kodeCabang: actorIsPusat ? "" : actorKodeCabang,
    tanggal: buildTodayKey(),
  });
  const [ubahDataMassal, setUbahDataMassal] = useState({
    ...EMPTY_UBAH_DATA_MASSAL,
    kodeCabang: actorIsPusat ? "C-1" : actorKodeCabang,
    filterCabang: actorIsPusat ? "" : actorKodeCabang,
    tanggal: buildTodayKey(),
  });
  const [openUbahDataMassalModal, setOpenUbahDataMassalModal] = useState(false);
  const [selectedUbahDataMassalRows, setSelectedUbahDataMassalRows] = useState([]);
  const [selectedUbahDataMassalIds, setSelectedUbahDataMassalIds] = useState([]);
  const [bulkUbahDataMassalFile, setBulkUbahDataMassalFile] = useState(null);
  const [attachmentsUbahDataMassal, setAttachmentsUbahDataMassal] = useState([]);
  const [invalidCaptionIndexesUbahDataMassal, setInvalidCaptionIndexesUbahDataMassal] = useState([]);
  const [isSubmittingUbahDataMassal, setIsSubmittingUbahDataMassal] = useState(false);
  const [ubahProfilBan, setUbahProfilBan] = useState({
    ...EMPTY_UBAH_PROFIL_BAN,
    kodeCabang: actorIsPusat ? "C-1" : actorKodeCabang,
    tanggal: buildTodayKey(),
  });
  const [openUbahProfilBanModal, setOpenUbahProfilBanModal] = useState(false);
  const [selectedUbahProfilBanRows, setSelectedUbahProfilBanRows] = useState([]);
  const [selectedUbahProfilBanIds, setSelectedUbahProfilBanIds] = useState([]);
  const [attachmentsUbahProfilBan, setAttachmentsUbahProfilBan] = useState([]);
  const [invalidCaptionIndexesUbahProfilBan, setInvalidCaptionIndexesUbahProfilBan] = useState([]);
  const [isSubmittingUbahProfilBan, setIsSubmittingUbahProfilBan] = useState(false);
  const [openPerubahanStatusBanModal, setOpenPerubahanStatusBanModal] = useState(false);
  const [selectedPerubahanStatusBanRows, setSelectedPerubahanStatusBanRows] = useState([]);
  const [selectedPerubahanStatusBanIds, setSelectedPerubahanStatusBanIds] = useState([]);
  const [statusChangeByBanId, setStatusChangeByBanId] = useState({});
  const [openStatusBanModal, setOpenStatusBanModal] = useState(false);
  const [statusBanTarget, setStatusBanTarget] = useState(null);
  const [statusBanDraftNext, setStatusBanDraftNext] = useState("");
  const [attachmentsPerubahanStatusBan, setAttachmentsPerubahanStatusBan] = useState([]);
  const [invalidCaptionIndexesPerubahanStatusBan, setInvalidCaptionIndexesPerubahanStatusBan] = useState([]);
  const [statusLampiranPerubahanByBanId, setStatusLampiranPerubahanByBanId] = useState({});
  const [invalidStatusLampiranPerubahanByBanId, setInvalidStatusLampiranPerubahanByBanId] = useState({});
  const [isSubmittingPerubahanStatusBan, setIsSubmittingPerubahanStatusBan] = useState(false);

  const [openBanShowModal, setOpenBanShowModal] = useState(false);
  const [banShowTargetId, setBanShowTargetId] = useState(0);
  const [konfirmasiTerimaRows, setKonfirmasiTerimaRows] = useState([]);
  const [loadingKonfirmasiTerima, setLoadingKonfirmasiTerima] = useState(false);
  const [selectedKonfirmasiRowId, setSelectedKonfirmasiRowId] = useState(0);
  const [persetujuanUbahStatus, setPersetujuanUbahStatus] = useState({
    kodeCabang: actorIsPusat ? "" : actorKodeCabang,
  });
  const [persetujuanUbahStatusRows, setPersetujuanUbahStatusRows] = useState([]);
  const [loadingPersetujuanUbahStatus, setLoadingPersetujuanUbahStatus] = useState(false);
  const [selectedPersetujuanUbahStatusRowId, setSelectedPersetujuanUbahStatusRowId] = useState(0);
  const [openPersetujuanUbahStatusModal, setOpenPersetujuanUbahStatusModal] = useState(false);
  const [loadingDetailPersetujuanUbahStatus, setLoadingDetailPersetujuanUbahStatus] = useState(false);
  const [isSubmittingPersetujuanUbahStatus, setIsSubmittingPersetujuanUbahStatus] = useState(false);
  const [persetujuanUbahStatusDetailRows, setPersetujuanUbahStatusDetailRows] = useState([]);
  const [persetujuanUbahStatusDetailMeta, setPersetujuanUbahStatusDetailMeta] = useState({
    id: 0,
    nomor: "",
    tanggal: "",
    kode_cabang: "",
    nama_cabang: "",
    catatan: "",
    lampiran: [],
  });
  const [keputusanPersetujuanByBanId, setKeputusanPersetujuanByBanId] = useState({});
  const [catatanApprovalByBanId, setCatatanApprovalByBanId] = useState({});
  const [openModalDaftarBanDiterima, setOpenModalDaftarBanDiterima] = useState(false);
  const [loadingDetailKonfirmasi, setLoadingDetailKonfirmasi] = useState(false);
  const [isSubmittingKonfirmasiTerima, setIsSubmittingKonfirmasiTerima] = useState(false);
  const [detailKonfirmasiRows, setDetailKonfirmasiRows] = useState([]);
  const [detailKonfirmasiMeta, setDetailKonfirmasiMeta] = useState({ nomor: "", tanggal: "", kode_cabang: "", jenis: "" });
  const [checkedDetailBanIds, setCheckedDetailBanIds] = useState([]);
  const [attachmentsKonfirmasiTerima, setAttachmentsKonfirmasiTerima] = useState([]);
  const [invalidCaptionIndexesKonfirmasiTerima, setInvalidCaptionIndexesKonfirmasiTerima] = useState([]);
  const [namaUserTerimaBan, setNamaUserTerimaBan] = useState("");
  const [openEditBanTerimaModal, setOpenEditBanTerimaModal] = useState(false);
  const [editBanTerimaDraft, setEditBanTerimaDraft] = useState({
    id_ban: 0,
    seri_lama: "",
    seri_baru: "",
    catatan_perubahan: "",
  });
  const editBanTerimaSeriInputRef = useRef(null);
  const editBanTerimaCatatanInputRef = useRef(null);
  const editBanTerimaDebounceRef = useRef({
    seri: null,
    catatan: null,
  });
  const [openDeleteBanTerimaConfirmModal, setOpenDeleteBanTerimaConfirmModal] = useState(false);
  const [openLampiranModal, setOpenLampiranModal] = useState(false);
  const [selectedLampiranFiles, setSelectedLampiranFiles] = useState([]);
  const [showPicPriorityFromPersetujuan, setShowPicPriorityFromPersetujuan] = useState(false);
  const [showTelapakModalRetread, setShowTelapakModalRetread] = useState(false);
  const [newTelapakRetread, setNewTelapakRetread] = useState("");
  const [savingTelapakRetread, setSavingTelapakRetread] = useState(false);
  const [targetTelapakRowIndex, setTargetTelapakRowIndex] = useState(-1);
  const collectInvalidCaptionIndexes = (items = []) => (
    (Array.isArray(items) ? items : [])
      .map((item, idx) => (String(item?.caption || "").trim() ? -1 : idx))
      .filter((idx) => idx >= 0)
  );
  const getStatusLampiranPerubahanKey = (rowOrId) => {
    const raw = typeof rowOrId === "object" ? rowOrId?.id_ban : rowOrId;
    return String(Number(raw || 0) || "");
  };
  const getStatusLampiranPerubahan = (rowOrId) => {
    const key = getStatusLampiranPerubahanKey(rowOrId);
    return key ? (statusLampiranPerubahanByBanId[key] || []) : [];
  };
  const setStatusLampiranPerubahanForBan = (rowOrId, updater) => {
    const key = getStatusLampiranPerubahanKey(rowOrId);
    if (!key) return;
    setStatusLampiranPerubahanByBanId((prev) => {
      const current = Array.isArray(prev?.[key]) ? prev[key] : [];
      const next = typeof updater === "function" ? updater(current) : updater;
      return { ...(prev || {}), [key]: Array.isArray(next) ? next : [] };
    });
  };
  const clearInvalidStatusLampiranPerubahan = (key) => {
    if (!key) return;
    setInvalidStatusLampiranPerubahanByBanId((prev) => {
      if (!prev?.[key]) return prev;
      const next = { ...(prev || {}) };
      delete next[key];
      return next;
    });
  };
  const validateStatusLampiranPerubahan = (rowOrId, nextStatus) => {
    const key = getStatusLampiranPerubahanKey(rowOrId);
    const list = key ? (statusLampiranPerubahanByBanId[key] || []) : [];
    const invalidCaptions = collectInvalidCaptionIndexes(list);
    const missingRequiredUpload = false;
    return {
      key,
      list,
      invalidCaptions,
      missingRequiredUpload,
      invalid: missingRequiredUpload || invalidCaptions.length > 0,
    };
  };
  const openLampiranPreviewStandarModal = ({ nomor = "-", lampiran = [] }) => {
    const files = (Array.isArray(lampiran) ? lampiran : [])
      .map((item, idx) => ({
        url: resolveLampiranUrl(item),
        caption: (typeof item === "string" ? "" : (item?.caption || item?.name)) || `Lampiran ${idx + 1}`,
        name: (typeof item === "string" ? String(item || "").split("/").pop() : item?.name) || `Lampiran ${idx + 1}`,
        note: `${nomor || ""} - ${((typeof item === "string" ? "" : (item?.caption || item?.name)) || `Lampiran ${idx + 1}`)}`.trim(),
      }))
      .filter((item) => Boolean(item?.url));
    if (!files.length) return;
    setShowPicPriorityFromPersetujuan(false);
    setSelectedLampiranFiles(files);
    setOpenLampiranModal(true);
  };

  const openLampiranPreviewPersetujuanModal = ({ nomor = "-", lampiran = [] }) => {
    const files = (Array.isArray(lampiran) ? lampiran : [])
      .map((item, idx) => ({
        url: resolveLampiranUrl(item),
        caption: (typeof item === "string" ? "" : (item?.caption || item?.name)) || `Lampiran ${idx + 1}`,
        name: (typeof item === "string" ? String(item || "").split("/").pop() : item?.name) || `Lampiran ${idx + 1}`,
        note: `${nomor || ""} - ${((typeof item === "string" ? "" : (item?.caption || item?.name)) || `Lampiran ${idx + 1}`)}`.trim(),
      }))
      .filter((item) => Boolean(item?.url));
    if (!files.length) return;
    setShowPicPriorityFromPersetujuan(true);
    setSelectedLampiranFiles(files);
    setOpenLampiranModal(true);
  };
  const handleCloseShowPic = () => {
    setOpenLampiranModal(false);
    setShowPicPriorityFromPersetujuan(false);
  };

  useEffect(() => {
    if (openLampiranModal && showPicPriorityFromPersetujuan) {
      document.body.classList.add("page30-persetujuan-showpic-priority");
    } else {
      document.body.classList.remove("page30-persetujuan-showpic-priority");
    }
    return () => {
      document.body.classList.remove("page30-persetujuan-showpic-priority");
    };
  }, [openLampiranModal, showPicPriorityFromPersetujuan]);

  const opsiCabang = useMemo(
    () => (Array.isArray(globalOpsi?.opsiCabang) ? globalOpsi.opsiCabang : []),
    [globalOpsi?.opsiCabang]
  );
  const opsiBanMaster = useMemo(
    () => (Array.isArray(globalOpsi?.opsiBan) ? globalOpsi.opsiBan : []),
    [globalOpsi?.opsiBan]
  );
  const opsiMerk = useMemo(
    () => (Array.isArray(globalOpsi?.opsiMerkBan) ? globalOpsi.opsiMerkBan : []),
    [globalOpsi?.opsiMerkBan]
  );
  const opsiUkuran = useMemo(
    () => (Array.isArray(globalOpsi?.opsiUkuran) ? globalOpsi.opsiUkuran : []),
    [globalOpsi?.opsiUkuran]
  );
  const opsiMerkValues = useMemo(
    () => Array.from(new Set(
      (Array.isArray(opsiMerk) ? opsiMerk : [])
        .map((x) => String(x?.nama_merk_ban || "").trim())
        .filter(Boolean)
    )),
    [opsiMerk]
  );
  const opsiUkuranValues = useMemo(
    () => Array.from(new Set(
      (Array.isArray(opsiUkuran) ? opsiUkuran : [])
        .map((x) => String(x?.ukuran || "").trim())
        .filter(Boolean)
    )),
    [opsiUkuran]
  );
  const opsiSuplier = useMemo(() => {
    const raw = Array.isArray(globalOpsi?.opsiSuplier) ? globalOpsi.opsiSuplier : [];
    const normalized = Array.from(
      new Set(
        raw
          .filter((x) => {
            if (typeof x === "string") return true;
            const jenis = String(x?.jenis || "").trim().toLowerCase();
            return jenis === "suplier" || jenis === "all";
          })
          .map((x) => (typeof x === "string" ? x : String(x?.suplier || x?.nama_suplier || x?.supplier || "").trim()))
          .filter(Boolean)
      )
    );
    return normalized.length ? normalized : DEFAULT_VENDOR_OPSI;
  }, [globalOpsi?.opsiSuplier]);
  const opsiSuplierRowsFiltered = useMemo(
    () =>
      (Array.isArray(globalOpsi?.opsiSuplier) ? globalOpsi.opsiSuplier : [])
        .filter((x) => {
          if (!x || typeof x !== "object") return false;
          const jenis = String(x?.jenis || "").trim().toLowerCase();
          return jenis === "suplier" || jenis === "all";
        }),
    [globalOpsi?.opsiSuplier]
  );
  const telapakBySuplierUpper = useMemo(() => {
    const map = new Map();
    opsiSuplierRowsFiltered.forEach((row) => {
      const nama = String(row?.suplier || row?.nama_suplier || row?.supplier || "").trim();
      if (!nama) return;
      const list = String(row?.telapak || "")
        .split("#")
        .map((x) => String(x || "").trim())
        .filter(Boolean);
      map.set(nama.toUpperCase(), Array.from(new Set(list)));
    });
    return map;
  }, [opsiSuplierRowsFiltered]);
  const opsiTelapakTerimaVendor = useMemo(() => {
    const vendor = String(terimaBanVulkanisir.vendor || "").trim().toUpperCase();
    if (!vendor) return [];
    return telapakBySuplierUpper.get(vendor) || [];
  }, [terimaBanVulkanisir.vendor, telapakBySuplierUpper]);
  const opsiTelapakTerimaVendorSelect = useMemo(() => {
    const uniq = Array.from(new Set((opsiTelapakTerimaVendor || []).map((x) => String(x || "").trim()).filter(Boolean)));
    return [TELAPAK_DEFAULT, ...uniq, TELAPAK_ADD];
  }, [opsiTelapakTerimaVendor]);
  const opsiCabangPenerima = useMemo(
    () => (Array.isArray(opsiCabang) ? opsiCabang : [])
      .map((x) => ({
        kode: String(x?.kode_cabang || "").trim(),
        nama: String(x?.nama_cabang || "").trim(),
      }))
      .filter((x) => x.kode && x.nama),
    [opsiCabang]
  );
  const opsiCabangPenerimaNama = useMemo(
    () => Array.from(new Set(opsiCabangPenerima.map((x) => x.nama))).filter(Boolean),
    [opsiCabangPenerima]
  );
  const cabangPenerimaMapByNamaUpper = useMemo(() => {
    const map = new Map();
    opsiCabangPenerima.forEach((x) => {
      map.set(String(x.nama || "").trim().toUpperCase(), x);
    });
    return map;
  }, [opsiCabangPenerima]);
  const cabangPenerimaMapByKodeUpper = useMemo(() => {
    const map = new Map();
    opsiCabangPenerima.forEach((x) => {
      map.set(String(x.kode || "").trim().toUpperCase(), x);
    });
    return map;
  }, [opsiCabangPenerima]);
  const resolveNamaCabang = useCallback((kodeCabang, fallbackNama = "") => {
    const kodeUpper = String(kodeCabang || "").trim().toUpperCase();
    if (!kodeUpper) return String(fallbackNama || "").trim();
    const namaFromGlobal = cabangPenerimaMapByKodeUpper.get(kodeUpper)?.nama;
    if (namaFromGlobal) return String(namaFromGlobal).trim();
    return String(fallbackNama || kodeCabang || "").trim();
  }, [cabangPenerimaMapByKodeUpper]);
  const opsiMtMaster = useMemo(
    () => (Array.isArray(globalOpsi?.opsiMT) ? globalOpsi.opsiMT : []),
    [globalOpsi?.opsiMT]
  );
  const mtNopolByIdMap = useMemo(() => {
    const map = new Map();
    opsiMtMaster.forEach((x) => {
      const idMt = String(x?.id_mt || x?.idMt || "").trim();
      const nopol = String(x?.nopol || "").trim();
      if (!idMt || !nopol) return;
      map.set(idMt, nopol);
    });
    return map;
  }, [opsiMtMaster]);
  const mtIdByNopolUpperMap = useMemo(() => {
    const map = new Map();
    opsiMtMaster.forEach((x) => {
      const idMt = String(x?.id_mt || x?.idMt || "").trim();
      const nopol = String(x?.nopol || "").trim();
      if (!idMt || !nopol) return;
      map.set(nopol.toUpperCase(), idMt);
    });
    return map;
  }, [opsiMtMaster]);
  const formatLokasiUbahMassal = useCallback((placeRaw, kodeCabangRaw = "") => {
    const place = String(placeRaw || "").trim();
    if (!place) return "";
    const lower = place.toLowerCase();
    if (lower.startsWith("gudang#")) {
      const kode = String(place.split("#")[1] || kodeCabangRaw || "").trim().toUpperCase();
      const namaCabang = resolveNamaCabang(kode, kode || "-");
      return `Gudang ${namaCabang}`.trim();
    }
    if (lower.startsWith("pabrik#")) {
      const suplier = String(place.split("#")[1] || "").trim();
      return `Pabrik ${suplier}`.trim();
    }
    if (place.includes("#")) {
      const [idMt, posisi] = place.split("#");
      const idMtTrim = String(idMt || "").trim();
      const posisiTrim = String(posisi || "").trim();
      const nopol = String(mtNopolByIdMap.get(idMtTrim) || idMtTrim || "").trim();
      return posisiTrim ? `${nopol}-${posisiTrim}` : nopol;
    }
    return place;
  }, [mtNopolByIdMap, resolveNamaCabang]);
  const parseLokasiUbahMassalToPlace = useCallback((lokasiRaw, fallbackKodeCabang = "", fallbackNamaCabang = "") => {
    const lokasi = String(lokasiRaw || "").trim();
    if (!lokasi) return "";
    const matchGudang = lokasi.match(/^gudang\s+(.+)$/i);
    if (matchGudang?.[1]) {
      const namaOrKode = String(matchGudang[1] || "").trim();
      const fromNama = cabangPenerimaMapByNamaUpper.get(namaOrKode.toUpperCase());
      const fromKode = cabangPenerimaMapByKodeUpper.get(namaOrKode.toUpperCase());
      const kode = String(
        fromNama?.kode
        || fromKode?.kode
        || fallbackKodeCabang
        || cabangPenerimaMapByNamaUpper.get(String(fallbackNamaCabang || "").trim().toUpperCase())?.kode
        || ""
      ).trim().toUpperCase();
      return kode ? `gudang#${kode}` : lokasi;
    }
    const matchPabrik = lokasi.match(/^pabrik\s+(.+)$/i);
    if (matchPabrik?.[1]) {
      const suplier = String(matchPabrik[1] || "").trim();
      return suplier ? `pabrik#${suplier}` : lokasi;
    }
    const dashIndex = lokasi.lastIndexOf("-");
    if (dashIndex > 0 && dashIndex < (lokasi.length - 1)) {
      const nopol = String(lokasi.slice(0, dashIndex) || "").trim().toUpperCase();
      const posisi = String(lokasi.slice(dashIndex + 1) || "").trim();
      const idMt = String(mtIdByNopolUpperMap.get(nopol) || "").trim();
      if (idMt && posisi) return `${idMt}#${posisi}`;
    }
    return lokasi;
  }, [cabangPenerimaMapByKodeUpper, cabangPenerimaMapByNamaUpper, mtIdByNopolUpperMap]);
  const opsiSuplierPembelian = useMemo(() => {
    const raw = Array.isArray(globalOpsi?.opsiSuplier) ? globalOpsi.opsiSuplier : [];
    const normalized = Array.from(
      new Set(
        raw
          .filter((x) => {
            const jenis = String(x?.jenis || "").trim().toLowerCase();
            return jenis === "suplier" || jenis === "all";
          })
          .map((x) => (typeof x === "string" ? x : String(x?.suplier || x?.nama_suplier || x?.supplier || "").trim()))
          .filter(Boolean)
      )
    );
    if (normalized.length) return normalized;
    return opsiSuplier;
  }, [globalOpsi?.opsiSuplier, opsiSuplier]);
  const suplierPembelianMapUpper = useMemo(() => {
    const map = new Map();
    opsiSuplierPembelian.forEach((x) => {
      map.set(String(x || "").trim().toUpperCase(), String(x || "").trim());
    });
    return map;
  }, [opsiSuplierPembelian]);
  const opsiSeriBanExistingUpper = useMemo(
    () =>
      new Set(
        opsiBanMaster
          .map((x) => String(x?.seri_ban || x?.seriBan || "").trim().toUpperCase())
          .filter(Boolean)
      ),
    [opsiBanMaster]
  );
  const isPusat = actorIsPusat;
  const namaCabangUser = useMemo(() => {
    if (isPusat) return "Pusat";
    const match = (Array.isArray(opsiCabang) ? opsiCabang : []).find(
      (x) => String(x?.kode_cabang || "").trim() === actorKodeCabang
    );
    return String(match?.nama_cabang || actorKodeCabang || "-").trim() || "-";
  }, [actorKodeCabang, isPusat, opsiCabang]);
  const ubahDataMassalKodeCabangEfektif = useMemo(
    () => String(isPusat ? (ubahDataMassal.kodeCabang || "C-1") : actorKodeCabang).trim(),
    [isPusat, ubahDataMassal.kodeCabang, actorKodeCabang]
  );
  const ubahDataMassalCabangInputLabel = useMemo(() => {
    if (!ubahDataMassalKodeCabangEfektif) return "-";
    if (!isPusat) return String(namaCabangUser || ubahDataMassalKodeCabangEfektif).trim();
    return resolveNamaCabang(ubahDataMassalKodeCabangEfektif, "Pusat");
  }, [ubahDataMassalKodeCabangEfektif, isPusat, namaCabangUser]);
  const selectedKonfirmasiRow = useMemo(
    () => konfirmasiTerimaRows.find((x) => Number(x.id) === Number(selectedKonfirmasiRowId)) || null,
    [konfirmasiTerimaRows, selectedKonfirmasiRowId]
  );
  const kodeCabangActorKonfirmasi = useMemo(
    () => normalizeKodeCabang(actorKodeCabang),
    [actorKodeCabang]
  );
  const kodeCabangMemoKonfirmasi = useMemo(
    () => extractKodeCabangFromNomorMemo(detailKonfirmasiMeta?.nomor),
    [detailKonfirmasiMeta?.nomor]
  );
  const canShowTerimaKonfirmasiButton = useMemo(() => {
    const jenisKonfirmasi = String(detailKonfirmasiMeta?.jenis || "").trim().toLowerCase();
    if (jenisKonfirmasi === "mutasi_ban") {
      if (!kodeCabangActorKonfirmasi) return false;
      return normalizeKodeCabang(detailKonfirmasiMeta?.kode_cabang) === kodeCabangActorKonfirmasi;
    }
    if (!kodeCabangMemoKonfirmasi) return true;
    if (!kodeCabangActorKonfirmasi) return false;
    return kodeCabangMemoKonfirmasi === kodeCabangActorKonfirmasi;
  }, [kodeCabangMemoKonfirmasi, kodeCabangActorKonfirmasi, detailKonfirmasiMeta?.jenis, detailKonfirmasiMeta?.kode_cabang]);
  const canEditCatatanPenerimaKonfirmasi = useMemo(() => {
    const jenisKonfirmasi = String(detailKonfirmasiMeta?.jenis || "").trim().toLowerCase();
    if (jenisKonfirmasi === "mutasi_ban") {
      if (!kodeCabangActorKonfirmasi) return false;
      return normalizeKodeCabang(detailKonfirmasiMeta?.kode_cabang) === kodeCabangActorKonfirmasi;
    }
    if (!kodeCabangMemoKonfirmasi) return false;
    if (!kodeCabangActorKonfirmasi) return false;
    return kodeCabangMemoKonfirmasi === kodeCabangActorKonfirmasi;
  }, [kodeCabangMemoKonfirmasi, kodeCabangActorKonfirmasi, detailKonfirmasiMeta?.jenis, detailKonfirmasiMeta?.kode_cabang]);
  const hideAksiColumnKonfirmasiDetail = useMemo(() => (
    isPusat && String(detailKonfirmasiMeta?.jenis || "").trim().toLowerCase() === "mutasi_ban"
  ), [isPusat, detailKonfirmasiMeta?.jenis]);
  const isDetailKonfirmasiMutasiBan = useMemo(() => (
    String(detailKonfirmasiMeta?.jenis || "").trim().toLowerCase() === "mutasi_ban"
  ), [detailKonfirmasiMeta?.jenis]);
  const pengirimKonfirmasiDetailLabel = useMemo(() => (
    String(selectedKonfirmasiRow?.pengirim || "").trim()
  ), [selectedKonfirmasiRow?.pengirim]);

  const todayText = useMemo(
    () =>
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "2-digit",
        month: "long",
        year: "numeric",
      }),
    []
  );

  const visibleActions = useMemo(() => {
    const filterByRole = (list = []) =>
      list.filter((x) => !(PUSAT_ONLY_ACTION_VALUES.has(x.value) && !isPusat));
    if (actionScope === "mutasi_stok") {
      const allowed = new Set(MUTASI_STOK_ACTION_VALUES);
      return filterByRole(STOK_ACTIONS.filter((x) => allowed.has(x.value)));
    }
    if (actionScope === "update_data_ban") {
      const allowed = new Set(UPDATE_DATA_BAN_ACTION_VALUES);
      return filterByRole(STOK_ACTIONS.filter((x) => allowed.has(x.value)));
    }
    return filterByRole(STOK_ACTIONS);
  }, [actionScope, isPusat]);
  const headerMeta = useMemo(() => {
    if (actionScope === "update_data_ban") {
      return {
        title: "Ubah Status Ban",
        subtitle: "Pilih aktivitas perubahan status dan data ban.",
      };
    }
    if (actionScope === "mutasi_stok") {
      return {
        title: "Mutasi Stok Gudang",
        subtitle: "Pilih aktivitas mutasi stok untuk mulai input data.",
      };
    }
    return {
      title: "Aktivitas Inventory",
      subtitle: "Pilih aktivitas inventory untuk mulai input data.",
    };
  }, [actionScope]);

  const selectedAction = visibleActions.find((x) => x.value === activeAction) || null;
  const isUbahProfilBanExpanded = selectedAction?.value === "ubah_profil_ban" && selectedUbahProfilBanRows.length > 0;

  useEffect(() => {
    if (!activeAction) return;
    const visibleSet = new Set(visibleActions.map((x) => x.value));
    if (visibleSet.has(activeAction)) return;
    setActiveAction("");
  }, [activeAction, visibleActions]);
  useEffect(() => {
    const next = String(forcedAction || "").trim();
    if (!next) return;
    const visibleSet = new Set(visibleActions.map((x) => x.value));
    if (!visibleSet.has(next)) return;
    setActiveAction(next);
  }, [forcedAction, visibleActions]);
  useEffect(() => {
    const nextAction = String(forcedAction || "").trim();
    const nextKey = String(forcedActionKey || "").trim();
    if (!isPusat) return;
    if (nextAction !== "pengiriman_ban_ke_cabang_lain") return;
    if (nextKey !== "perintah_mutasi_ban") return;
    setPengirimanBanKeCabangLain((prev) => ({ ...prev, kodeCabang: CABANG_ALL_VALUE }));
  }, [forcedAction, forcedActionKey, isPusat]);
  useEffect(() => {
    const nextAction = String(forcedAction || "").trim();
    const nextKey = String(forcedActionKey || "").trim();
    if (!isPusat) return;
    if (nextAction !== "konfirmasi_terima_ban") return;
    const allowedKeys = new Set([
      "konfirmasi_pembelian_ban",
      "konfirmasi_terima_dari_pabrik",
      "konfirmasi_terima_ban_mutasi",
    ]);
    if (!allowedKeys.has(nextKey)) return;
    setKonfirmasiTerimaBan((prev) => ({ ...prev, kodeCabang: CABANG_ALL_VALUE }));
  }, [forcedAction, forcedActionKey, isPusat]);

  const pembelianBaruStep1Ready = useMemo(() => {
    const qtyNum = Number(pembelianBaru.qty || 0);
    return Boolean(
      String(pembelianBaru.kodeCabang || "").trim() &&
      String(pembelianBaru.nomor || "").trim() &&
      String(pembelianBaru.tanggal || "").trim() &&
      String(pembelianBaru.noDokumen || "").trim() &&
      String(pembelianBaru.tglDokumen || "").trim() &&
      Number.isFinite(qtyNum) &&
      qtyNum > 0
    );
  }, [pembelianBaru]);

  const pengirimanCasingStep1Ready = useMemo(() => {
    return Boolean(
      String(pengirimanCasing.kodeCabang || "").trim() &&
      String(pengirimanCasing.nomor || "").trim() &&
      String(pengirimanCasing.tanggal || "").trim() &&
      String(pengirimanCasing.noDokumen || "").trim() &&
      String(pengirimanCasing.tglDokumen || "").trim() &&
      String(pengirimanCasing.vendor || "").trim()
    );
  }, [pengirimanCasing]);
  const perintahPemindahanStockStep1Ready = useMemo(() => {
    return Boolean(
      String(perintahPemindahanStock.kodeCabang || "").trim() &&
      String(perintahPemindahanStock.kodeCabangPenerima || "").trim() &&
      String(perintahPemindahanStock.kodeCabangPenerima || "").trim() !== String(perintahPemindahanStock.kodeCabang || "").trim() &&
      String(perintahPemindahanStock.nomor || "").trim() &&
      String(perintahPemindahanStock.tanggal || "").trim() &&
      String(perintahPemindahanStock.noDokumen || "").trim() &&
      String(perintahPemindahanStock.tglDokumen || "").trim()
    );
  }, [perintahPemindahanStock]);
  const pengirimanBanKeCabangLainStep1Ready = useMemo(() => {
    return Boolean(
      String(pengirimanBanKeCabangLain.kodeCabang || "").trim()
      && String(pengirimanBanKeCabangLain.nomor || "").trim()
      && String(pengirimanBanKeCabangLain.tanggal || "").trim()
    );
  }, [pengirimanBanKeCabangLain]);
  const isPengirimanBanKeCabangLainSebagian = useMemo(() => {
    const totalRows = pengirimanBanKeCabangLainRows.length;
    const checkedRows = pengirimanBanKeCabangLainRows.filter((x) => Boolean(x?.checked)).length;
    return checkedRows > 0 && checkedRows < totalRows;
  }, [pengirimanBanKeCabangLainRows]);

  const terimaBanVulkanisirStep1Ready = useMemo(
    () =>
      Boolean(
        String(terimaBanVulkanisir.kodeCabang || "").trim() &&
        String(terimaBanVulkanisir.nomor || "").trim() &&
        String(terimaBanVulkanisir.tanggal || "").trim() &&
        String(terimaBanVulkanisir.noDokumen || "").trim() &&
        String(terimaBanVulkanisir.tglDokumen || "").trim() &&
        String(terimaBanVulkanisir.vendor || "").trim()
      ),
    [terimaBanVulkanisir]
  );
  const perubahanStatusBanStep1Ready = useMemo(
    () =>
      Boolean(
        String(perubahanStatusBan.kodeCabang || "").trim() &&
        String(perubahanStatusBan.nomor || "").trim() &&
        String(perubahanStatusBan.tanggal || "").trim()
      ),
    [perubahanStatusBan]
  );
  const ubahDataMassalStep1Ready = useMemo(
    () =>
      Boolean(
        String(ubahDataMassalKodeCabangEfektif || "").trim()
        && String(ubahDataMassal.nomor || "").trim()
        && String(ubahDataMassal.tanggal || "").trim()
      ),
    [ubahDataMassal, ubahDataMassalKodeCabangEfektif]
  );
  const invalidPembelianCabang = selectedAction?.value === "pembelian_baru" && !String(pembelianBaru.kodeCabang || "").trim();
  const invalidPembelianNoDok = selectedAction?.value === "pembelian_baru" && !String(pembelianBaru.noDokumen || "").trim();
  const invalidPembelianTglDok = selectedAction?.value === "pembelian_baru" && !String(pembelianBaru.tglDokumen || "").trim();
  const invalidPembelianQty = selectedAction?.value === "pembelian_baru" && !(Number(pembelianBaru.qty || 0) > 0);
  const invalidPembelianFormOrder = selectedAction?.value === "pembelian_baru" && !pembelianFormOrderMeta.valid;
  const invalidPembelianLampiran = selectedAction?.value === "pembelian_baru" && attachmentsPembelianBaru.length === 0;
  const invalidPengirimanCabang = selectedAction?.value === "pengiriman_casing" && !String(pengirimanCasing.kodeCabang || "").trim();
  const invalidPengirimanNoDok = selectedAction?.value === "pengiriman_casing" && !String(pengirimanCasing.noDokumen || "").trim();
  const invalidPengirimanTglDok = selectedAction?.value === "pengiriman_casing" && !String(pengirimanCasing.tglDokumen || "").trim();
  const invalidPengirimanVendor = selectedAction?.value === "pengiriman_casing" && !String(pengirimanCasing.vendor || "").trim();
  const invalidPengirimanLampiran = selectedAction?.value === "pengiriman_casing" && attachmentsPengirimanCasing.length === 0;
  const invalidPerintahPemindahanStockCabang = selectedAction?.value === "perintah_pemindahan_stock" && !String(perintahPemindahanStock.kodeCabang || "").trim();
  const invalidPerintahPemindahanStockCabangPenerima = selectedAction?.value === "perintah_pemindahan_stock" && (
    !String(perintahPemindahanStock.kodeCabangPenerima || "").trim()
    || String(perintahPemindahanStock.kodeCabangPenerima || "").trim() === String(perintahPemindahanStock.kodeCabang || "").trim()
  );
  const invalidPerintahPemindahanStockNoDok = selectedAction?.value === "perintah_pemindahan_stock" && !String(perintahPemindahanStock.noDokumen || "").trim();
  const invalidPerintahPemindahanStockTglDok = selectedAction?.value === "perintah_pemindahan_stock" && !String(perintahPemindahanStock.tglDokumen || "").trim();
  const invalidPerintahPemindahanStockLampiran = selectedAction?.value === "perintah_pemindahan_stock" && attachmentsPerintahPemindahanStock.length === 0;
  const invalidPengirimanBanKeCabangLainCabang = selectedAction?.value === "pengiriman_ban_ke_cabang_lain" && !String(pengirimanBanKeCabangLain.kodeCabang || "").trim();
  const invalidPengirimanBanKeCabangLainNomor = selectedAction?.value === "pengiriman_ban_ke_cabang_lain" && !String(pengirimanBanKeCabangLain.nomor || "").trim();
  const invalidPengirimanBanKeCabangLainTanggal = selectedAction?.value === "pengiriman_ban_ke_cabang_lain" && !String(pengirimanBanKeCabangLain.tanggal || "").trim();
  const invalidPengirimanBanKeCabangLainLampiran = selectedAction?.value === "pengiriman_ban_ke_cabang_lain" && attachmentsPengirimanBanKeCabangLain.length === 0;
  const isCabangC1 = actorKodeCabang.toUpperCase() === "C-1";
  const invalidTerimaCabang = selectedAction?.value === "terima_ban_vulkanisir" && !String(terimaBanVulkanisir.kodeCabang || "").trim();
  const invalidTerimaNoDok = selectedAction?.value === "terima_ban_vulkanisir" && !String(terimaBanVulkanisir.noDokumen || "").trim();
  const invalidTerimaTglDok = selectedAction?.value === "terima_ban_vulkanisir" && !String(terimaBanVulkanisir.tglDokumen || "").trim();
  const invalidTerimaVendor = selectedAction?.value === "terima_ban_vulkanisir" && !String(terimaBanVulkanisir.vendor || "").trim();
  const invalidTerimaLampiran = selectedAction?.value === "terima_ban_vulkanisir" && attachmentsTerimaBanVulkanisir.length === 0;
  const invalidKonfirmasiTerimaCabang = selectedAction?.value === "konfirmasi_terima_ban" && isPusat && !String(konfirmasiTerimaBan.kodeCabang || "").trim();
  const invalidPerubahanStatusCabang = selectedAction?.value === "perubahan_status_ban" && !String(perubahanStatusBan.kodeCabang || "").trim();

  const selectedPerubahanStatusDisplayRows = useMemo(
    () =>
      selectedPerubahanStatusBanRows.map((row) => {
        const id = Number(row?.id_ban || 0);
        const cfg = statusChangeByBanId[id] || {};
        return {
          ...row,
          id_ban: id,
          statusSaatIni: String(row?.status || "-").trim() || "-",
          statusBaru: String(cfg.nextStatus || "").trim(),
          catatan: String(cfg.catatan || "").trim(),
          done: Boolean(cfg.done),
        };
      }),
    [selectedPerubahanStatusBanRows, statusChangeByBanId]
  );
  const semuaBanSudahDicekPerubahan = useMemo(
    () =>
      selectedPerubahanStatusDisplayRows.length > 0 &&
      selectedPerubahanStatusDisplayRows.every((row) => Boolean(row.done)),
    [selectedPerubahanStatusDisplayRows]
  );
  const canSubmitPerubahanStatusBan = useMemo(
    () =>
      Boolean(
        semuaBanSudahDicekPerubahan &&
        !isSubmittingPerubahanStatusBan
      ),
    [semuaBanSudahDicekPerubahan, isSubmittingPerubahanStatusBan]
  );
  const activePerubahanStatusBanId = useMemo(() => {
    const fromTarget = Number(statusBanTarget?.id_ban || 0);
    if (fromTarget > 0) return fromTarget;
    return Number(selectedPerubahanStatusDisplayRows?.[0]?.id_ban || 0);
  }, [statusBanTarget?.id_ban, selectedPerubahanStatusDisplayRows]);
  const activePerubahanStatusBanCfg = useMemo(
    () => statusChangeByBanId[activePerubahanStatusBanId] || {},
    [statusChangeByBanId, activePerubahanStatusBanId]
  );
  const activePerubahanStatusBanCatatan = String(activePerubahanStatusBanCfg?.catatan || "");
  const activePerubahanStatusBanMeta = useMemo(
    () =>
      selectedPerubahanStatusDisplayRows.find(
        (row) => Number(row?.id_ban || 0) === Number(activePerubahanStatusBanId)
      ) || null,
    [selectedPerubahanStatusDisplayRows, activePerubahanStatusBanId]
  );
  const statusBanOptions = useMemo(
    () => getStatusChangeOptions(statusBanTarget?.statusSaatIni || ""),
    [statusBanTarget?.statusSaatIni]
  );
  const needApprovalStatuses = useMemo(
    () => new Set(["AFKIR", "DISPOSED", "UNTRACKED"]),
    []
  );
  const isPerubahanStatusNeedMemoLampiran = useMemo(
    () => selectedPerubahanStatusDisplayRows.some((row) => {
      const next = normalizeStatusText(row?.statusBaru || "");
      return needApprovalStatuses.has(next) && next !== "AFKIR";
    }),
    [selectedPerubahanStatusDisplayRows, needApprovalStatuses]
  );
  const invalidPerubahanStatusLampiran = selectedAction?.value === "perubahan_status_ban"
    && isPerubahanStatusNeedMemoLampiran
    && attachmentsPerubahanStatusBan.length === 0;
  const selectedPengirimanCasingRows = useMemo(
    () => pengirimanCasingRows
      .filter((row, index) => checkedPengirimanCasingIndexes.has(index) && Number(row?.idBan || 0) > 0)
      .map((row) => ({ ...row, checked: true })),
    [pengirimanCasingRows, checkedPengirimanCasingIndexes]
  );
  const selectedTerimaBanVulkanisirRows = useMemo(
    () => terimaBanVulkanisirRows
      .filter((row, index) => checkedTerimaBanVulkanisirIndexes.has(index) && Number(row?.idBan || 0) > 0)
      .map((row) => ({ ...row, checked: true })),
    [terimaBanVulkanisirRows, checkedTerimaBanVulkanisirIndexes]
  );
  const filteredTerimaBanVulkanisirRows = useMemo(() => {
    const keyword = String(terimaBanVulkanisirFilterText || "").trim().toLowerCase();
    const rowsWithIndex = terimaBanVulkanisirRows.map((row, originalIndex) => ({ row, originalIndex }));
    const selectedFilteredRows = showOnlySelectedTerimaBanVulkanisir
      ? rowsWithIndex.filter(({ originalIndex }) => checkedTerimaBanVulkanisirIndexes.has(originalIndex))
      : rowsWithIndex;
    if (!keyword) return selectedFilteredRows;
    return selectedFilteredRows.filter(({ row }) => {
      const haystack = [
        row?.idBan,
        row?.seriBan,
        row?.jenisRepair,
        row?.statusAkhir,
        row?.statusOtOption,
        row?.telapak,
        row?.ukuran,
        row?.td,
        row?.merk,
        row?.catatanBan,
      ].map((v) => String(v || "").toLowerCase()).join(" ");
      return haystack.includes(keyword);
    });
  }, [
    terimaBanVulkanisirRows,
    terimaBanVulkanisirFilterText,
    showOnlySelectedTerimaBanVulkanisir,
    checkedTerimaBanVulkanisirIndexes,
  ]);
  const terimaBanVulkanisirVendorLabel = useMemo(
    () => String(terimaBanVulkanisir.vendor || "").trim() || "-",
    [terimaBanVulkanisir.vendor]
  );
  const terimaBanVulkanisirCabangLabel = useMemo(() => {
    const kode = String(terimaBanVulkanisir.kodeCabang || "").trim();
    if (!kode) return "-";
    if (!isPusat) return String(namaCabangUser || kode).trim() || kode;
    const match = opsiCabang.find((x) => String(x?.kode_cabang || "").trim() === kode);
    return String(match?.nama_cabang || kode).trim() || kode;
  }, [terimaBanVulkanisir.kodeCabang, isPusat, namaCabangUser, opsiCabang]);

  const handlePilihAction = (value) => {
    if (!value) {
      setActiveAction("");
      return;
    }
    if (DISABLED_LEGACY_ACTIONS.has(String(value || "").trim())) {
      setActiveAction("");
      showNotif("warning", "Aksi ini sudah dinonaktifkan.");
      return;
    }
    setActiveAction(value);

    if (value === "pembelian_baru") {
      setAttachmentsPembelianBaru([]);
      setInvalidCaptionIndexesPembelianBaru([]);
      setShowPembelianBaruTableScreen(false);
      setReadySimpanPembelian(false);
      setPembelianBaru({
        ...EMPTY_PEMBELIAN_BARU,
        kodeCabang: isPusat ? "" : (actorKodeCabang || ""),
        tanggal: buildTodayKey(),
        tglDokumen: buildTodayKey(),
      });
      setPembelianBaruRows([]);
      setPembelianFormOrderMeta({
        fileName: "",
        parsedAt: "",
        error: "",
        valid: false,
        totalRows: 0,
      });
      setPembelianValidasiMeta({
        validated: false,
        confirmed: false,
        invalidByRowNo: {},
        invalidCount: 0,
        validatedAt: "",
      });
      if (formOrderFileRef.current) formOrderFileRef.current.value = "";
    }
    if (value === "konfirmasi_terima_ban") {
      setKonfirmasiTerimaBan({
        ...EMPTY_KONFIRMASI_TERIMA_BAN,
        kodeCabang: actorIsPusat ? "" : actorKodeCabang,
      });
      setKonfirmasiTerimaRows([]);
      setSelectedKonfirmasiRowId(0);
      setOpenModalDaftarBanDiterima(false);
      setDetailKonfirmasiRows([]);
      setDetailKonfirmasiMeta({ nomor: "", tanggal: "", kode_cabang: "" });
      setCheckedDetailBanIds([]);
      setAttachmentsKonfirmasiTerima([]);
      setInvalidCaptionIndexesKonfirmasiTerima([]);
      setNamaUserTerimaBan("");
    }
    if (value === "persetujuan_ubah_status") {
      setPersetujuanUbahStatus({
        kodeCabang: actorIsPusat ? "" : actorKodeCabang,
      });
      setPersetujuanUbahStatusRows([]);
      setSelectedPersetujuanUbahStatusRowId(0);
      setOpenPersetujuanUbahStatusModal(false);
      setPersetujuanUbahStatusDetailRows([]);
      setPersetujuanUbahStatusDetailMeta({
        id: 0,
        nomor: "",
        tanggal: "",
        kode_cabang: "",
        nama_cabang: "",
        catatan: "",
        lampiran: [],
      });
      setKeputusanPersetujuanByBanId({});
      setCatatanApprovalByBanId({});
    }
    if (value === "pengiriman_casing") {
      setShowPengirimanCasingTableScreen(false);
      setReadySimpanPengirimanCasing(false);
      setIsSubmittingPengirimanCasing(false);
      setPengirimanCasing({
        ...EMPTY_PENGIRIMAN_CASING,
        kodeCabang: actorIsPusat ? "" : actorKodeCabang,
        tanggal: buildTodayKey(),
        tglDokumen: buildTodayKey(),
      });
      setPengirimanCasingRows([]);
      setInitialPengirimanCasingRows([]);
      setCheckedPengirimanCasingIndexes(new Set());
      setAttachmentsPengirimanCasing([]);
      setInvalidCaptionIndexesPengirimanCasing([]);
    }
    if (value === "perintah_pemindahan_stock") {
      setReadySimpanPerintahPemindahanStock(false);
      setIsSubmittingPerintahPemindahanStock(false);
      setPerintahPemindahanStock({
        ...EMPTY_PERINTAH_PEMINDAHAN_STOCK,
        kodeCabang: actorIsPusat ? "" : actorKodeCabang,
        tanggal: buildTodayKey(),
        tglDokumen: buildTodayKey(),
      });
      setAttachmentsPerintahPemindahanStock([]);
      setInvalidCaptionIndexesPerintahPemindahanStock([]);
      setSelectedPerintahPemindahanStockRows([]);
      setSelectedPerintahPemindahanStockIds([]);
    }
    if (value === "pengiriman_ban_ke_cabang_lain") {
      setPengirimanBanKeCabangLain({
        ...EMPTY_PENGIRIMAN_BAN_KE_CABANG_LAIN,
        kodeCabang: actorIsPusat ? "" : actorKodeCabang,
        tanggal: buildTodayKey(),
      });
      setPengirimanBanKeCabangLainRows([]);
      setPendingNomorPengirimanBanKeCabangLainOptions([]);
      setAttachmentsPengirimanBanKeCabangLainReadOnly([]);
      setAttachmentsPengirimanBanKeCabangLain([]);
      setInvalidCaptionIndexesPengirimanBanKeCabangLain([]);
      setIsSubmittingPengirimanBanKeCabangLain(false);
      setOpenPengirimanSebagianModal(false);
    }
    if (value === "perubahan_status_ban") {
      setPerubahanStatusBan({
        ...EMPTY_PERUBAHAN_STATUS_BAN,
        kodeCabang: actorIsPusat ? "" : actorKodeCabang,
        tanggal: buildTodayKey(),
      });
      setOpenPerubahanStatusBanModal(false);
      setSelectedPerubahanStatusBanRows([]);
      setSelectedPerubahanStatusBanIds([]);
      setStatusChangeByBanId({});
      setAttachmentsPerubahanStatusBan([]);
      setInvalidCaptionIndexesPerubahanStatusBan([]);
      setStatusLampiranPerubahanByBanId({});
      setInvalidStatusLampiranPerubahanByBanId({});
      setOpenStatusBanModal(false);
      setStatusBanTarget(null);
      setStatusBanDraftNext("");
      setOpenBanShowModal(false);
      setBanShowTargetId(0);
    }
    if (value === "ubah_data_massal") {
      setUbahDataMassal({
        ...EMPTY_UBAH_DATA_MASSAL,
        kodeCabang: actorIsPusat ? "C-1" : actorKodeCabang,
        filterCabang: actorIsPusat ? "" : actorKodeCabang,
        tanggal: buildTodayKey(),
      });
      setOpenUbahDataMassalModal(false);
      setSelectedUbahDataMassalRows([]);
      setSelectedUbahDataMassalIds([]);
      setBulkUbahDataMassalFile(null);
      setAttachmentsUbahDataMassal([]);
      setInvalidCaptionIndexesUbahDataMassal([]);
      setIsSubmittingUbahDataMassal(false);
    }
    if (value === "ubah_profil_ban") {
      setUbahProfilBan({
        ...EMPTY_UBAH_PROFIL_BAN,
        kodeCabang: actorIsPusat ? "C-1" : actorKodeCabang,
        tanggal: buildTodayKey(),
      });
      setOpenUbahProfilBanModal(false);
      setSelectedUbahProfilBanRows([]);
      setSelectedUbahProfilBanIds([]);
      setAttachmentsUbahProfilBan([]);
      setInvalidCaptionIndexesUbahProfilBan([]);
      setIsSubmittingUbahProfilBan(false);
    }
    if (value === "terima_ban_vulkanisir") {
      setShowTerimaBanVulkanisirTableScreen(false);
      setReadySimpanTerimaBanVulkanisir(false);
      setIsSubmittingTerimaBanVulkanisir(false);
      setTerimaBanVulkanisir({
        ...EMPTY_TERIMA_BAN_VULKANISIR,
        kodeCabang: actorIsPusat ? "" : actorKodeCabang,
        tanggal: buildTodayKey(),
        tglDokumen: buildTodayKey(),
      });
      setTerimaBanVulkanisirRows([]);
      setInitialTerimaBanVulkanisirRows([]);
      setCheckedTerimaBanVulkanisirIndexes(new Set());
      setAttachmentsTerimaBanVulkanisir([]);
      setInvalidCaptionIndexesTerimaBanVulkanisir([]);
    }
  };

  useEffect(() => {
    const loadNomorPembelian = async () => {
      if (activeAction !== "pembelian_baru") return;
      const kodeCabang = String(
        pembelianBaru.kodeCabang || (!isPusat ? actorKodeCabang : "")
      ).trim();
      setPembelianBaru((prev) => ({
        ...prev,
        nomor: buildNomorPreviewPlaceholder({
          kodeCabang,
          prefix: "BUY",
          tanggal: pembelianBaru.tanggal,
        }),
      }));
    };
    loadNomorPembelian();
  }, [activeAction, pembelianBaru.kodeCabang, pembelianBaru.tanggal, isPusat, actorKodeCabang, resendToken]);

  useEffect(() => {
    const loadNomorPengirimanCasing = async () => {
      if (activeAction !== "pengiriman_casing") return;
      const kodeCabang = String(
        pengirimanCasing.kodeCabang || (!isPusat ? actorKodeCabang : "")
      ).trim();
      setPengirimanCasing((prev) => ({
        ...prev,
        nomor: buildNomorPreviewPlaceholder({
          kodeCabang,
          prefix: "CASING",
          tanggal: pengirimanCasing.tanggal,
        }),
      }));
    };
    loadNomorPengirimanCasing();
  }, [activeAction, pengirimanCasing.kodeCabang, pengirimanCasing.tanggal, isPusat, actorKodeCabang, resendToken]);

  useEffect(() => {
    const loadNomorPerintahPemindahanStock = async () => {
      if (activeAction !== "perintah_pemindahan_stock") return;
      const kodeCabang = String(
        perintahPemindahanStock.kodeCabang || (!isPusat ? actorKodeCabang : "")
      ).trim();
      setPerintahPemindahanStock((prev) => ({
        ...prev,
        nomor: buildNomorPreviewPlaceholder({
          kodeCabang,
          prefix: "PINDAH",
          tanggal: perintahPemindahanStock.tanggal,
        }),
      }));
    };
    loadNomorPerintahPemindahanStock();
  }, [activeAction, perintahPemindahanStock.kodeCabang, perintahPemindahanStock.tanggal, isPusat, actorKodeCabang, resendToken]);

  useEffect(() => {
    if (activeAction !== "pengiriman_ban_ke_cabang_lain") return;
    setPengirimanBanKeCabangLain((prev) => ({
      ...prev,
      kodeCabang: String(prev?.kodeCabang || (!isPusat ? actorKodeCabang : "")).trim(),
    }));
  }, [activeAction, isPusat, actorKodeCabang, resendToken]);

  useEffect(() => {
    const loadNomorPerubahanStatusBan = async () => {
      if (activeAction !== "perubahan_status_ban") return;
      const kodeCabang = String(
        perubahanStatusBan.kodeCabang || (!isPusat ? actorKodeCabang : "")
      ).trim();
      setPerubahanStatusBan((prev) => ({
        ...prev,
        nomor: buildNomorPreviewPlaceholder({
          kodeCabang,
          prefix: "MEMO",
          tanggal: perubahanStatusBan.tanggal,
        }),
      }));
    };
    loadNomorPerubahanStatusBan();
  }, [activeAction, perubahanStatusBan.kodeCabang, perubahanStatusBan.tanggal, isPusat, actorKodeCabang, resendToken]);

  useEffect(() => {
    const loadNomorUbahDataMassal = async () => {
      if (activeAction !== "ubah_data_massal") return;
      setUbahDataMassal((prev) => ({
        ...prev,
        kodeCabang: ubahDataMassalKodeCabangEfektif,
        filterCabang: isPusat ? prev.filterCabang : actorKodeCabang,
        nomor: buildNomorPreviewPlaceholder({
          kodeCabang: ubahDataMassalKodeCabangEfektif,
          prefix: "MASSAL",
          tanggal: ubahDataMassal.tanggal,
        }),
      }));
    };
    loadNomorUbahDataMassal();
  }, [activeAction, ubahDataMassal.tanggal, ubahDataMassalKodeCabangEfektif, isPusat, actorKodeCabang, resendToken]);

  useEffect(() => {
    const loadNomorTerimaBanVulkanisir = async () => {
      if (activeAction !== "terima_ban_vulkanisir") return;
      const kodeCabang = String(
        terimaBanVulkanisir.kodeCabang || (!isPusat ? actorKodeCabang : "")
      ).trim();
      setTerimaBanVulkanisir((prev) => ({
        ...prev,
        nomor: buildNomorPreviewPlaceholder({
          kodeCabang,
          prefix: "CASING",
          tanggal: terimaBanVulkanisir.tanggal,
        }),
      }));
    };
    loadNomorTerimaBanVulkanisir();
  }, [activeAction, terimaBanVulkanisir.kodeCabang, terimaBanVulkanisir.tanggal, isPusat, actorKodeCabang, resendToken]);


  useEffect(() => {
    if (activeAction !== "pembelian_baru") return;
    if (isPusat) return;
    const kodeCabangUser = actorKodeCabang;
    if (!kodeCabangUser) return;
    setPembelianBaru((prev) => {
      if (String(prev.kodeCabang || "").trim()) return prev;
      return { ...prev, kodeCabang: kodeCabangUser };
    });
  }, [activeAction, isPusat, actorKodeCabang]);

  useEffect(() => {
    if (activeAction !== "pengiriman_casing") return;
    if (isPusat) return;
    const kodeCabangUser = actorKodeCabang;
    if (!kodeCabangUser) return;
    setPengirimanCasing((prev) => {
      if (String(prev.kodeCabang || "").trim()) return prev;
      return { ...prev, kodeCabang: kodeCabangUser };
    });
  }, [activeAction, isPusat, actorKodeCabang]);

  useEffect(() => {
    if (activeAction !== "perubahan_status_ban") return;
    if (isPusat) return;
    const kodeCabangUser = actorKodeCabang;
    if (!kodeCabangUser) return;
    setPerubahanStatusBan((prev) => {
      if (String(prev.kodeCabang || "").trim()) return prev;
      return { ...prev, kodeCabang: kodeCabangUser };
    });
  }, [activeAction, isPusat, actorKodeCabang]);

  useEffect(() => {
    if (activeAction !== "terima_ban_vulkanisir") return;
    if (isPusat) return;
    const kodeCabangUser = actorKodeCabang;
    if (!kodeCabangUser) return;
    setTerimaBanVulkanisir((prev) => {
      if (String(prev.kodeCabang || "").trim()) return prev;
      return { ...prev, kodeCabang: kodeCabangUser };
    });
  }, [activeAction, isPusat, actorKodeCabang]);


  useEffect(() => {
    if (activeAction !== "perubahan_status_ban") return;
    setSelectedPerubahanStatusBanRows([]);
    setSelectedPerubahanStatusBanIds([]);
    setStatusChangeByBanId({});
    setAttachmentsPerubahanStatusBan([]);
    setInvalidCaptionIndexesPerubahanStatusBan([]);
    setStatusLampiranPerubahanByBanId({});
    setInvalidStatusLampiranPerubahanByBanId({});
  }, [activeAction, perubahanStatusBan.kodeCabang]);


  useEffect(() => {
    if (activeAction !== "konfirmasi_terima_ban") return;
    if (isPusat) return;
    const kodeCabangUser = actorKodeCabang;
    if (!kodeCabangUser) return;
    setKonfirmasiTerimaBan((prev) => ({ ...prev, kodeCabang: kodeCabangUser }));
  }, [activeAction, isPusat, actorKodeCabang]);

  useEffect(() => {
    if (activeAction !== "persetujuan_ubah_status") return;
    if (isPusat) return;
    const kodeCabangUser = actorKodeCabang;
    if (!kodeCabangUser) return;
    setPersetujuanUbahStatus((prev) => ({ ...prev, kodeCabang: kodeCabangUser }));
  }, [activeAction, isPusat, actorKodeCabang]);

  useEffect(() => {
    if (activeAction !== "pembelian_baru") return;
    const qtyNum = Number(pembelianBaru.qty || 0);
    const targetLen = Number.isFinite(qtyNum) && qtyNum > 0 ? Math.floor(qtyNum) : 0;
    setPembelianBaruRows(Array.from({ length: targetLen }, (_, idx) => createPembelianBaruRow(idx)));
    setPembelianFormOrderMeta({
      fileName: "",
      parsedAt: "",
      error: "",
      valid: false,
      totalRows: 0,
    });
    setPembelianValidasiMeta({
      validated: false,
      confirmed: false,
      invalidByRowNo: {},
      invalidCount: 0,
      validatedAt: "",
    });
    if (formOrderFileRef.current) formOrderFileRef.current.value = "";
  }, [activeAction, pembelianBaru.qty]);

  const normalizeExcelCellValue = (value) => {
    if (value == null) return "";
    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
      return String(value).trim();
    }
    if (value instanceof Date) {
      const y = value.getFullYear();
      const m = String(value.getMonth() + 1).padStart(2, "0");
      const d = String(value.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    }
    if (typeof value === "object") {
      if (value.text) return String(value.text).trim();
      if (Array.isArray(value.richText)) return value.richText.map((x) => x?.text || "").join("").trim();
      if (value.result != null) return String(value.result).trim();
    }
    return String(value).trim();
  };

  const handleDownloadFormOrder = async () => {
    const qtyNum = Number(pembelianBaru.qty || 0);
    if (!Number.isFinite(qtyNum) || qtyNum <= 0) {
      showNotif("error", "Isi Qty terlebih dahulu.");
      return;
    }
    const merkList = opsiMerkValues.length ? opsiMerkValues : ["Bridgestone"];
    const ukuranList = opsiUkuranValues.length ? opsiUkuranValues : ["11,00R22,5"];
    const cabangList = opsiCabangPenerimaNama.length ? opsiCabangPenerimaNama : ["Pusat"];
    const suplierList = opsiSuplierPembelian.length ? opsiSuplierPembelian : DEFAULT_VENDOR_OPSI;
    const defaultMerk = merkList.includes("Bridgestone") ? "Bridgestone" : merkList[0];
    const defaultUkuran = ukuranList.includes("11,00R22,5") ? "11,00R22,5" : ukuranList[0];
    const selectedCabangKode = String(
      pembelianBaru.kodeCabang || (!isPusat ? actorKodeCabang : "")
    ).trim().toUpperCase();
    const selectedCabangNama = String(
      opsiCabangPenerima.find((x) => String(x?.kode || "").trim().toUpperCase() === selectedCabangKode)?.nama || ""
    ).trim();
    const defaultCabang = selectedCabangNama
      || cabangList.find((x) => String(x || "").trim().toUpperCase() !== "PUSAT")
      || cabangList[0];
    const defaultSuplier = suplierList[0];

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Form Order");
    worksheet.columns = [
      { header: "No", key: "no", width: 8 },
      { header: "Seri Ban", key: "seri_ban", width: 24 },
      { header: "Status", key: "status", width: 12 },
      { header: "Merk", key: "merk", width: 20 },
      { header: "Ukuran", key: "ukuran", width: 16 },
      { header: "TD", key: "td", width: 16 },
      { header: "Cabang Penerima", key: "cabang_penerima", width: 26 },
      { header: "Suplier", key: "suplier", width: 24 },
    ];
    worksheet.views = [{ state: "frozen", ySplit: 1 }];
    const headerRow = worksheet.getRow(1);
    headerRow.font = { bold: true };
    headerRow.alignment = { vertical: "middle", horizontal: "center" };
    headerRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFF2CC" } };

    const listSheet = workbook.addWorksheet("LIST_OPSI");
    OPSI_STATUS_BAN_PEMBELIAN.forEach((v, i) => { listSheet.getCell(`A${i + 1}`).value = v; });
    merkList.forEach((v, i) => { listSheet.getCell(`B${i + 1}`).value = v; });
    ukuranList.forEach((v, i) => { listSheet.getCell(`C${i + 1}`).value = v; });
    cabangList.forEach((v, i) => { listSheet.getCell(`D${i + 1}`).value = v; });
    suplierList.forEach((v, i) => { listSheet.getCell(`E${i + 1}`).value = v; });
    listSheet.state = "hidden";

    for (let i = 0; i < Math.floor(qtyNum); i += 1) {
      const rowNo = i + 2;
      worksheet.getCell(`A${rowNo}`).value = i + 1;
      worksheet.getCell(`C${rowNo}`).value = "NT";
      worksheet.getCell(`D${rowNo}`).value = defaultMerk;
      worksheet.getCell(`E${rowNo}`).value = defaultUkuran;
      worksheet.getCell(`F${rowNo}`).value = "16-16-16-16";
      worksheet.getCell(`G${rowNo}`).value = defaultCabang;
      worksheet.getCell(`H${rowNo}`).value = defaultSuplier;

      worksheet.getCell(`B${rowNo}`).dataValidation = {
        type: "custom",
        allowBlank: false,
        formulae: [`AND(B${rowNo}<>"",ISERROR(SEARCH(" ",B${rowNo})),ISERROR(SEARCH("#",B${rowNo})))`],
        showErrorMessage: true,
        errorTitle: "Seri Ban tidak valid",
        error: "Seri Ban wajib diisi tanpa spasi dan tanpa karakter #.",
      };
      worksheet.getCell(`C${rowNo}`).dataValidation = {
        type: "list",
        allowBlank: false,
        formulae: [`LIST_OPSI!$A$1:$A$${OPSI_STATUS_BAN_PEMBELIAN.length}`],
      };
      worksheet.getCell(`D${rowNo}`).dataValidation = {
        type: "list",
        allowBlank: false,
        formulae: [`LIST_OPSI!$B$1:$B$${merkList.length}`],
      };
      worksheet.getCell(`E${rowNo}`).dataValidation = {
        type: "list",
        allowBlank: false,
        formulae: [`LIST_OPSI!$C$1:$C$${ukuranList.length}`],
      };
      worksheet.getCell(`F${rowNo}`).dataValidation = {
        type: "custom",
        allowBlank: false,
        formulae: [`AND(LEN(F${rowNo})>0,ISNUMBER(--LEFT(F${rowNo},FIND("-",F${rowNo})-1)))`],
      };
      worksheet.getCell(`G${rowNo}`).dataValidation = {
        type: "list",
        allowBlank: false,
        formulae: [`LIST_OPSI!$D$1:$D$${cabangList.length}`],
      };
      worksheet.getCell(`H${rowNo}`).dataValidation = {
        type: "list",
        allowBlank: false,
        formulae: [`LIST_OPSI!$E$1:$E$${suplierList.length}`],
      };
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `FORM_ORDER_PEMBELIAN_${String(pembelianBaru.nomor || "BUY").replace(/[\\/]/g, "_")}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleUploadFormOrderFile = async (e) => {
    const input = e.target;
    const file = input?.files?.[0];
    if (!file) return;
    const qtyNum = Number(pembelianBaru.qty || 0);
    if (!Number.isFinite(qtyNum) || qtyNum <= 0) {
      setPembelianFormOrderMeta({ fileName: "", parsedAt: "", error: "Qty tidak valid.", valid: false, totalRows: 0 });
      setPembelianValidasiMeta({
        validated: false,
        confirmed: false,
        invalidByRowNo: {},
        invalidCount: 0,
        validatedAt: "",
      });
      return;
    }
    try {
      const name = String(file.name || "").toLowerCase();
      if (!(name.endsWith(".xlsx") || name.endsWith(".xls"))) {
        setPembelianFormOrderMeta({ fileName: file.name || "", parsedAt: "", error: "File harus Excel (.xlsx/.xls).", valid: false, totalRows: 0 });
        setPembelianValidasiMeta({
          validated: false,
          confirmed: false,
          invalidByRowNo: {},
          invalidCount: 0,
          validatedAt: "",
        });
        return;
      }
      const merkSet = new Set((opsiMerkValues.length ? opsiMerkValues : ["Bridgestone"]).map((x) => String(x).trim().toUpperCase()));
      const ukuranSet = new Set((opsiUkuranValues.length ? opsiUkuranValues : ["11,00R22,5"]).map((x) => String(x).trim().toUpperCase()));
      const buffer = await file.arrayBuffer();
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(buffer);
      const ws = workbook.worksheets?.[0];
      if (!ws) throw new Error("Worksheet tidak ditemukan.");

      const headers = ["No", "Seri Ban", "Status", "Merk", "Ukuran", "TD", "Cabang Penerima", "Suplier"];
      for (let i = 0; i < headers.length; i += 1) {
        const value = normalizeExcelCellValue(ws.getCell(1, i + 1).value);
        if (value !== headers[i]) throw new Error(`Header kolom ${i + 1} harus '${headers[i]}'.`);
      }

      const parsedRows = [];
      for (let i = 0; i < Math.floor(qtyNum); i += 1) {
        const rowNo = i + 2;
        const seriBan = normalizeExcelCellValue(ws.getCell(rowNo, 2).value);
        const status = normalizeExcelCellValue(ws.getCell(rowNo, 3).value);
        const merk = normalizeExcelCellValue(ws.getCell(rowNo, 4).value);
        const ukuran = normalizeExcelCellValue(ws.getCell(rowNo, 5).value);
        const td = normalizeExcelCellValue(ws.getCell(rowNo, 6).value);
        const cabangPenerimaRaw = normalizeExcelCellValue(ws.getCell(rowNo, 7).value);
        const suplierRaw = normalizeExcelCellValue(ws.getCell(rowNo, 8).value);

        if (!seriBan || /\s/.test(seriBan) || seriBan.includes("#")) throw new Error(`Seri Ban baris ${rowNo} tidak valid.`);
        if (!OPSI_STATUS_BAN_PEMBELIAN.map((x) => x.toUpperCase()).includes(status.toUpperCase())) throw new Error(`Status baris ${rowNo} tidak valid.`);
        if (!merkSet.has(merk.toUpperCase())) throw new Error(`Merk baris ${rowNo} tidak valid.`);
        if (!ukuranSet.has(ukuran.toUpperCase())) throw new Error(`Ukuran baris ${rowNo} tidak valid.`);
        if (!TD_PATTERN.test(td)) throw new Error(`TD baris ${rowNo} harus format angka-angka-angka-angka.`);
        const cabangMatched =
          cabangPenerimaMapByNamaUpper.get(String(cabangPenerimaRaw || "").trim().toUpperCase())
          || cabangPenerimaMapByKodeUpper.get(String(cabangPenerimaRaw || "").trim().toUpperCase());
        if (!cabangMatched) throw new Error(`Cabang Penerima baris ${rowNo} tidak valid.`);
        const suplierCanonical = suplierPembelianMapUpper.get(String(suplierRaw || "").trim().toUpperCase());
        if (!suplierCanonical) throw new Error(`Suplier baris ${rowNo} tidak valid.`);

        parsedRows.push({
          no: i + 1,
          seriBan,
          status,
          merk,
          ukuran,
          td,
          kodeCabangPenerima: String(cabangMatched.kode || "").trim(),
          cabangPenerima: String(cabangMatched.nama || "").trim(),
          suplier: String(suplierCanonical || "").trim(),
        });
      }
      setPembelianBaruRows(parsedRows);
      setPembelianFormOrderMeta({
        fileName: String(file.name || ""),
        parsedAt: new Date().toISOString(),
        error: "",
        valid: true,
        totalRows: parsedRows.length,
      });
      setPembelianValidasiMeta({
        validated: false,
        confirmed: false,
        invalidByRowNo: {},
        invalidCount: 0,
        validatedAt: "",
      });
      showNotif("success", `Form Order valid (${parsedRows.length} baris).`);
    } catch (err) {
      console.error(err);
      setPembelianBaruRows([]);
      setPembelianFormOrderMeta({
        fileName: String(file?.name || ""),
        parsedAt: "",
        error: err?.message || "Gagal membaca Form Order.",
        valid: false,
        totalRows: 0,
      });
      setPembelianValidasiMeta({
        validated: false,
        confirmed: false,
        invalidByRowNo: {},
        invalidCount: 0,
        validatedAt: "",
      });
      showNotif("error", err?.message || "Form Order tidak valid.");
    }
  };

  const handleLihatFormOrder = () => {
    if (!pembelianFormOrderMeta.valid || !pembelianBaruRows.length) {
      showNotif("error", "File Form Order belum valid.");
      return;
    }
    const statusSet = new Set(OPSI_STATUS_BAN_PEMBELIAN.map((x) => String(x || "").trim().toUpperCase()));
    const merkSet = new Set((opsiMerkValues.length ? opsiMerkValues : ["Bridgestone"]).map((x) => String(x || "").trim().toUpperCase()));
    const ukuranSet = new Set((opsiUkuranValues.length ? opsiUkuranValues : ["11,00R22,5"]).map((x) => String(x || "").trim().toUpperCase()));
    const cabangSet = new Set(opsiCabangPenerimaNama.map((x) => String(x || "").trim().toUpperCase()));
    const suplierSet = new Set(opsiSuplierPembelian.map((x) => String(x || "").trim().toUpperCase()));
    const seen = new Map();
    const invalidByRowNo = {};

    pembelianBaruRows.forEach((row, idx) => {
      const rowNo = Number(row?.no || idx + 1);
      const errs = [];
      const seriBan = String(row?.seriBan || "").trim();
      const status = String(row?.status || "").trim();
      const merk = String(row?.merk || "").trim();
      const ukuran = String(row?.ukuran || "").trim();
      const td = String(row?.td || "").trim();
      const cabang = String(row?.cabangPenerima || row?.kodeCabangPenerima || "").trim();
      const suplier = String(row?.suplier || "").trim();

      if (!seriBan || /\s/.test(seriBan) || seriBan.includes("#")) {
        errs.push("Seri Ban wajib diisi tanpa spasi dan tanpa karakter #.");
      }
      const seriUpper = seriBan.toUpperCase();
      if (seriUpper) {
        if (seen.has(seriUpper)) errs.push(`Seri Ban duplikat dengan baris ${seen.get(seriUpper)}.`);
        else seen.set(seriUpper, rowNo);
        if (opsiSeriBanExistingUpper.has(seriUpper)) errs.push("Seri Ban sudah terdaftar pada master ban.");
      }
      if (!statusSet.has(status.toUpperCase())) errs.push("Status tidak sesuai opsi.");
      if (!merkSet.has(merk.toUpperCase())) errs.push("Merk tidak sesuai opsi.");
      if (!ukuranSet.has(ukuran.toUpperCase())) errs.push("Ukuran tidak sesuai opsi.");
      if (!TD_PATTERN.test(td)) errs.push("TD harus format angka-angka-angka-angka.");
      if (!cabangSet.has(cabang.toUpperCase())) errs.push("Cabang Penerima tidak sesuai opsi.");
      if (!suplierSet.has(suplier.toUpperCase())) errs.push("Suplier tidak sesuai opsi (jenis suplier/all).");

      if (errs.length) invalidByRowNo[rowNo] = errs;
    });

    const invalidCount = Object.keys(invalidByRowNo).length;
    setPembelianValidasiMeta({
      validated: true,
      confirmed: false,
      invalidByRowNo,
      invalidCount,
      validatedAt: new Date().toISOString(),
    });
    setShowPembelianBaruTableScreen(true);
    if (invalidCount > 0) {
      showNotif("error", `Ditemukan ${invalidCount} baris tidak valid. Periksa baris berwarna merah.`);
      return;
    }
    showNotif("success", "Seluruh baris valid. Klik 'Konfirmasi Valid' untuk mengaktifkan tombol Simpan.");
  };

  const handleKonfirmasiValidPembelian = () => {
    if (!pembelianValidasiMeta.validated) {
      showNotif("error", "Lakukan validasi terlebih dahulu.");
      return;
    }
    if (Number(pembelianValidasiMeta.invalidCount || 0) > 0) {
      showNotif("error", "Masih ada baris tidak valid.");
      return;
    }
    setPembelianValidasiMeta((prev) => ({ ...prev, confirmed: true }));
    showNotif("success", "Validasi dikonfirmasi. Tombol Simpan sudah aktif.");
  };

  const isAllPengirimanCasingRowsChecked = useMemo(
    () => pengirimanCasingRows.length > 0 && pengirimanCasingRows.every((_, index) => checkedPengirimanCasingIndexes.has(index)),
    [pengirimanCasingRows, checkedPengirimanCasingIndexes]
  );
  const filteredPengirimanCasingRows = useMemo(() => {
    const keyword = String(filterTextPengirimanCasing || "").trim().toLowerCase();
    const indexedRows = pengirimanCasingRows
      .map((row, index) => ({ row, index }))
      .filter(({ row }) => {
        const statusLower = String(row?.status || "").trim().toLowerCase();
        const placeLower = String(row?.place || "").trim().toLowerCase();
        return !statusLower.includes("notdone") && !placeLower.includes("notdone");
      });
    const selectedFilteredRows = showOnlySelectedPengirimanCasing
      ? indexedRows.filter(({ index }) => checkedPengirimanCasingIndexes.has(index))
      : indexedRows;
    if (!keyword) return selectedFilteredRows;
    return selectedFilteredRows.filter(({ row }) => {
      const text = [
        row?.idBan,
        row?.seriBan,
        row?.status,
        row?.place,
        row?.merk,
        row?.ukuran,
        row?.kodeCabang,
        row?.cabang,
        row?.jenisRepair,
      ].map((v) => String(v || "").toLowerCase()).join(" ");
      return text.includes(keyword);
    });
  }, [pengirimanCasingRows, filterTextPengirimanCasing, showOnlySelectedPengirimanCasing, checkedPengirimanCasingIndexes]);

  const toggleCheckAllPengirimanCasingRows = (checked) => {
    setCheckedPengirimanCasingIndexes(() => {
      if (!checked) return new Set();
      return new Set(pengirimanCasingRows.map((_, index) => index));
    });
  };

  const updatePengirimanCasingRowChecked = useCallback((index, checked) => {
    setCheckedPengirimanCasingIndexes((prev) => {
      const next = new Set(prev);
      if (checked) next.add(index);
      else next.delete(index);
      return next;
    });
  }, []);
  const updatePengirimanCasingRow = useCallback((index, field, value) => {
    setPengirimanCasingRows((prev) =>
      prev.map((row, idx) => (idx === index ? { ...row, [field]: value } : row))
    );
  }, []);
  const updatePengirimanCasingRepair = useCallback((index, value) => {
    updatePengirimanCasingRow(index, "jenisRepair", value);
  }, [updatePengirimanCasingRow]);
  const clearPengirimanCasingTable = useCallback(() => {
    setPengirimanCasingRows(initialPengirimanCasingRows.map((row) => ({ ...row })));
    setCheckedPengirimanCasingIndexes(new Set());
    setFilterTextPengirimanCasing("");
    setShowOnlySelectedPengirimanCasing(false);
  }, [initialPengirimanCasingRows]);

  const isAllTerimaBanVulkanisirRowsChecked = useMemo(
    () => terimaBanVulkanisirRows.length > 0 && terimaBanVulkanisirRows.every((_, index) => checkedTerimaBanVulkanisirIndexes.has(index)),
    [terimaBanVulkanisirRows, checkedTerimaBanVulkanisirIndexes]
  );

  const toggleCheckAllTerimaBanVulkanisirRows = (checked) => {
    setCheckedTerimaBanVulkanisirIndexes(() => {
      if (!checked) return new Set();
      return new Set(terimaBanVulkanisirRows.map((_, index) => index));
    });
  };

  const updateTerimaBanVulkanisirRow = useCallback((index, field, value) => {
    if (field === "checked") {
      setCheckedTerimaBanVulkanisirIndexes((prev) => {
        const next = new Set(prev);
        if (value) next.add(index);
        else next.delete(index);
        return next;
      });
      return;
    }
    setTerimaBanVulkanisirRows((prev) =>
      prev.map((row, idx) => (idx === index ? { ...row, [field]: value } : row))
    );
  }, []);
  const openAddTelapakRetreadModal = useCallback((rowIndex) => {
    if (!String(terimaBanVulkanisir.vendor || "").trim()) {
      showNotif("error", "Pilih vendor terlebih dahulu.");
      return;
    }
    setTargetTelapakRowIndex(Number(rowIndex));
    setNewTelapakRetread("");
    setShowTelapakModalRetread(true);
  }, [showNotif, terimaBanVulkanisir.vendor]);
  const clearTerimaBanVulkanisirTable = useCallback(() => {
    setTerimaBanVulkanisirRows(initialTerimaBanVulkanisirRows.map((row) => ({ ...row })));
    setCheckedTerimaBanVulkanisirIndexes(new Set());
    setTerimaBanVulkanisirFilterText("");
    setShowOnlySelectedTerimaBanVulkanisir(false);
  }, [initialTerimaBanVulkanisirRows]);
  const handleSaveTelapakBaruRetread = async () => {
    const supplierKey = String(terimaBanVulkanisir.vendor || "").trim();
    const candidate = String(newTelapakRetread || "").trim();
    if (!supplierKey) {
      showNotif("error", "Pilih vendor terlebih dahulu.");
      return;
    }
    if (!candidate) {
      showNotif("error", "Jenis telapak baru wajib diisi.");
      return;
    }
    const existing = new Set(
      (opsiTelapakTerimaVendorSelect || [])
        .filter((x) => x !== TELAPAK_ADD)
        .map((x) => String(x || "").trim().toLowerCase())
    );
    if (existing.has(candidate.toLowerCase())) {
      if (Number(targetTelapakRowIndex) >= 0) {
        updateTerimaBanVulkanisirRow(Number(targetTelapakRowIndex), "telapak", candidate);
      }
      setShowTelapakModalRetread(false);
      setNewTelapakRetread("");
      setTargetTelapakRowIndex(-1);
      showNotif("success", "Jenis telapak sudah tersedia.");
      return;
    }
    try {
      setSavingTelapakRetread(true);
      await api.post(`${backendPort}/api/master/suplier_telapak_append`, {
        suplier: supplierKey,
        telapak: candidate,
      });
      await manualResyncGlobalOpsi({ force: true, requestGroup: "master-sync" });
      if (Number(targetTelapakRowIndex) >= 0) {
        updateTerimaBanVulkanisirRow(Number(targetTelapakRowIndex), "telapak", candidate);
      }
      setShowTelapakModalRetread(false);
      setNewTelapakRetread("");
      setTargetTelapakRowIndex(-1);
      showNotif("success", "Jenis telapak berhasil ditambahkan.");
    } catch (err) {
      console.error(err);
      showNotif("error", err?.response?.data?.message || "Gagal menambahkan jenis telapak.");
    } finally {
      setSavingTelapakRetread(false);
    }
  };

  const loadTerimaBanVulkanisirRows = async () => {
    const vendor = String(terimaBanVulkanisir.vendor || "").trim();
    const kodeCabangFinal = String(
      terimaBanVulkanisir.kodeCabang || (!isPusat ? actorKodeCabang : "")
    ).trim();
    if (!vendor) {
      setTerimaBanVulkanisirRows([]);
      setInitialTerimaBanVulkanisirRows([]);
      setCheckedTerimaBanVulkanisirIndexes(new Set());
      return;
    }
    setCheckedTerimaBanVulkanisirIndexes(new Set());
    setLoadingTerimaBanVulkanisirRows(true);
    try {
      api.cancelPendingRequests({
        group: REQ_GROUP_RETREAD_LOAD,
        reason: "refresh terima retread rows",
      });
      const pageSize = 200;
      const basePayload = {
        pageSize,
        keyword: "",
        vendor,
        kodeCabang: kodeCabangFinal,
      };
      const fetchPage = async (page) => {
        const { data } = await api.post(`${backendPort}/api/main/load_terima_ban_vulkanisir_candidates`, {
          ...basePayload,
          page,
        }, {
          requestGroup: REQ_GROUP_RETREAD_LOAD,
          timeout: 120000,
        });
        return {
          rows: Array.isArray(data?.rows) ? data.rows : [],
          total: Number(data?.total || 0),
        };
      };

      const getNextStatusRetread = (statusRaw) => {
        const status = String(statusRaw || "").trim().toUpperCase();
        const match = status.match(/^(?:VT|UV)-(\d+)(?:-OT)?$/);
        if (match?.[1]) return `VT-${Number(match[1]) + 1}`;
        return "VT-1";
      };

      const mapRows = (rows) =>
        rows.map((row, idx) => {
          const jenisRepair = String(row?.repair || "").trim();
          const statusBase = getNextStatusRetread(
            row?.status_vtut_terakhir || row?.status_terakhir
          );
          const statusOt = `${statusBase}-OT`;
          const statusDefault = jenisRepair.toUpperCase() === "OPER TELAPAK"
            ? statusOt
            : statusBase;
          return createTerimaVulkanisirRow(idx, {
            idBan: Number(row?.id_ban || 0),
            seriBan: String(row?.seri_ban || "").trim(),
            jenisRepair,
            statusAkhir: statusDefault,
            statusBaseOption: statusBase,
            statusOtOption: statusOt,
            statusRepairedOptions: getRepairedStatusOptions(row?.status_repaired_terakhir),
            telapak: String(row?.telapak_terakhir || "").trim() || TELAPAK_DEFAULT,
            ukuran: String(row?.ukuran || "").trim(),
            td: String(row?.td_terakhir || row?.td || "").trim(),
            merk: String(row?.merk || "").trim(),
            catatanBan: String(row?.catatan || "").trim(),
          });
        });

      const firstPage = await fetchPage(1);
      let allRows = [...firstPage.rows];
      const firstMappedRows = mapRows(allRows);
      setTerimaBanVulkanisirRows(firstMappedRows);
      setInitialTerimaBanVulkanisirRows(firstMappedRows);

      const totalPages = Math.ceil(Number(firstPage.total || 0) / pageSize);
      if (totalPages > 1) {
        const concurrentPages = 4;
        for (let start = 2; start <= totalPages; start += concurrentPages) {
          const pages = [];
          for (let p = start; p < start + concurrentPages && p <= totalPages; p += 1) {
            pages.push(p);
          }
          const chunkResults = await Promise.all(pages.map((p) => fetchPage(p)));
          chunkResults.forEach((chunk) => {
            allRows = [...allRows, ...(Array.isArray(chunk?.rows) ? chunk.rows : [])];
          });
          const mappedRows = mapRows(allRows);
          setTerimaBanVulkanisirRows(mappedRows);
          setInitialTerimaBanVulkanisirRows(mappedRows);
        }
      }
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
      showNotif("error", err?.response?.data?.message || "Gagal memuat data ban retread pabrik.");
      setTerimaBanVulkanisirRows([]);
      setInitialTerimaBanVulkanisirRows([]);
    } finally {
      setLoadingTerimaBanVulkanisirRows(false);
    }
  };

  const loadPengirimanCasingRows = async (kodeCabang) => {
    const cabang = String(kodeCabang || "").trim();
    if (!cabang) {
      setPengirimanCasingRows([]);
      setInitialPengirimanCasingRows([]);
      setCheckedPengirimanCasingIndexes(new Set());
      return;
    }

    setCheckedPengirimanCasingIndexes(new Set());
    setLoadingPengirimanCasingRows(true);
    try {
      api.cancelPendingRequests({
        group: REQ_GROUP_CASING_LOAD,
        reason: "refresh pengiriman casing rows",
      });
      const pageSize = 200;
      const basePayload = {
        pageSize,
        kodeCabang: cabang,
        keyword: "",
        statusFilters: ["CASING", "PERLU REPAIR", "PERLU OT"],
        locationFilters: ["gudang"],
        skipFacet: true,
      };
      const fetchPage = async (page) => {
        const { data } = await api.post(`${backendPort}/api/main/load_ban_bulk_candidates`, {
          ...basePayload,
          page,
        }, {
          requestGroup: REQ_GROUP_CASING_LOAD,
          timeout: 120000,
        });
        return {
          rows: Array.isArray(data?.rows) ? data.rows : [],
          total: Number(data?.total || 0),
        };
      };

      const firstPage = await fetchPage(1);
      let allRows = [...firstPage.rows];
      const mapRows = (rows) => rows.map((row, idx) =>
        createPengirimanCasingRow(idx, {
          idBan: Number(row?.id_ban || 0),
          seriBan: String(row?.seri_ban || "").trim() || "-",
          status: String(row?.status_now || "").trim() || "-",
          place: String(row?.place_now || row?.place || "").trim(),
          kodeCabang: String(row?.kode_cabang || "").trim(),
          merk: String(row?.merk || "").trim() || "-",
          ukuran: String(row?.ukuran || "").trim() || "-",
          cabang: row?.nama_cabang || row?.kode_cabang || cabang,
        })
      );
      const firstMappedRows = mapRows(allRows);
      setPengirimanCasingRows(firstMappedRows);
      setInitialPengirimanCasingRows(firstMappedRows);

      const totalPages = Math.ceil(Number(firstPage.total || 0) / pageSize);
      if (totalPages > 1) {
        const concurrentPages = 4;
        for (let start = 2; start <= totalPages; start += concurrentPages) {
          const pages = [];
          for (let p = start; p < start + concurrentPages && p <= totalPages; p += 1) {
            pages.push(p);
          }
          const chunkResults = await Promise.all(pages.map((p) => fetchPage(p)));
          chunkResults.forEach((chunk) => {
            allRows = [...allRows, ...(Array.isArray(chunk?.rows) ? chunk.rows : [])];
          });
          const mappedRows = mapRows(allRows);
          setPengirimanCasingRows(mappedRows);
          setInitialPengirimanCasingRows(mappedRows);
        }
      }
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
      showNotif("error", err?.response?.data?.message || "Gagal memuat data ban untuk repair/vulkanisir.");
      setPengirimanCasingRows([]);
      setInitialPengirimanCasingRows([]);
    } finally {
      setLoadingPengirimanCasingRows(false);
    }
  };


  const pembelianBaruRowsComplete = useMemo(() => {
    const qtyNum = Number(pembelianBaru.qty || 0);
    return Boolean(
      pembelianFormOrderMeta.valid
      && pembelianValidasiMeta.confirmed
      && Number.isFinite(qtyNum)
      && qtyNum > 0
      && pembelianBaruRows.length === Math.floor(qtyNum)
    );
  }, [pembelianFormOrderMeta.valid, pembelianValidasiMeta.confirmed, pembelianBaruRows.length, pembelianBaru.qty]);
  const canKlikValidasiPembelian = useMemo(() => {
    const qtyNum = Number(pembelianBaru.qty || 0);
    const tanggalValid = /^\d{4}-\d{2}-\d{2}$/.test(String(pembelianBaru.tanggal || "").trim());
    return Boolean(
      pembelianFormOrderMeta.valid
      && String(pembelianFormOrderMeta.fileName || "").trim()
      && String(pembelianBaru.noDokumen || "").trim()
      && tanggalValid
      && Number.isFinite(qtyNum)
      && qtyNum > 0
    );
  }, [
    pembelianFormOrderMeta.valid,
    pembelianFormOrderMeta.fileName,
    pembelianBaru.noDokumen,
    pembelianBaru.tanggal,
    pembelianBaru.qty,
  ]);

  useEffect(() => {
    setReadySimpanPembelian(Boolean(
      pembelianBaruStep1Ready
      && pembelianBaruRowsComplete
      && attachmentsPembelianBaru.length > 0
    ));
  }, [pembelianBaruStep1Ready, pembelianBaruRowsComplete, attachmentsPembelianBaru.length]);

  useEffect(() => {
    if (
      !pengirimanCasingStep1Ready
      || selectedPengirimanCasingRows.length === 0
      || attachmentsPengirimanCasing.length === 0
    ) {
      setReadySimpanPengirimanCasing(false);
    }
  }, [pengirimanCasingStep1Ready, selectedPengirimanCasingRows.length, attachmentsPengirimanCasing.length]);
  useEffect(() => {
    setReadySimpanPerintahPemindahanStock(Boolean(
      perintahPemindahanStockStep1Ready
      && selectedPerintahPemindahanStockIds.length > 0
      && attachmentsPerintahPemindahanStock.length > 0
    ));
  }, [perintahPemindahanStockStep1Ready, selectedPerintahPemindahanStockIds.length, attachmentsPerintahPemindahanStock.length]);

  useEffect(() => {
    if (
      !terimaBanVulkanisirStep1Ready
      || selectedTerimaBanVulkanisirRows.length === 0
      || attachmentsTerimaBanVulkanisir.length === 0
    ) {
      setReadySimpanTerimaBanVulkanisir(false);
    }
  }, [terimaBanVulkanisirStep1Ready, selectedTerimaBanVulkanisirRows.length, attachmentsTerimaBanVulkanisir.length]);

  const handleLanjutkanPengirimanCasing = async () => {
    if (!pengirimanCasingStep1Ready) {
      showNotif("error", "Lengkapi data awal Pengiriman Casing sebelum lanjutkan.");
      return;
    }
    const kodeCabangFinal = String(
      pengirimanCasing.kodeCabang || (!isPusat ? actorKodeCabang : "")
    ).trim();
    if (!kodeCabangFinal) {
      showNotif("error", "Cabang wajib dipilih.");
      return;
    }
    setShowOnlySelectedPengirimanCasing(false);
    setShowPengirimanCasingTableScreen(true);
    await loadPengirimanCasingRows(kodeCabangFinal);
  };

  const handlePilihPengirimanCasing = () => {
    const selected = selectedPengirimanCasingRows;
    if (!selected.length) {
      showNotif("error", "Pilih minimal 1 ban.");
      return;
    }
    setShowPengirimanCasingTableScreen(false);
    setReadySimpanPengirimanCasing(true);
    showNotif("success", `${selected.length} ban berhasil dipilih.`);
  };

  const handleLanjutkanTerimaBanVulkanisir = async () => {
    if (!terimaBanVulkanisirStep1Ready) {
      showNotif("error", "Lengkapi data awal Pengiriman Ban Retread ke Gudang sebelum lanjutkan.");
      return;
    }
    setShowOnlySelectedTerimaBanVulkanisir(false);
    setShowTerimaBanVulkanisirTableScreen(true);
    await loadTerimaBanVulkanisirRows();
  };

  const samakanTerimaBanVulkanisir = (field) => {
    if (!terimaBanVulkanisirRows.length) return;
    const checkedIndexes = terimaBanVulkanisirRows
      .map((_, idx) => (checkedTerimaBanVulkanisirIndexes.has(idx) ? idx : -1))
      .filter((idx) => idx >= 0);
    if (checkedIndexes.length < 2) {
      showNotif("error", "Minimal centang 2 baris untuk aksi Samakan.");
      return;
    }
    const sourceIndex = checkedIndexes[0];
    const sourceValue = String(terimaBanVulkanisirRows[sourceIndex]?.[field] || "").trim();
    if (!sourceValue) {
      showNotif("error", "Isi dulu nilai baris terpilih pertama sebelum menjalankan aksi Samakan.");
      return;
    }
    setTerimaBanVulkanisirRows((prev) =>
      prev.map((row, index) => (checkedTerimaBanVulkanisirIndexes.has(index) ? { ...row, [field]: sourceValue } : row))
    );
  };

  const handleSelesaiPilihTerimaBanVulkanisir = () => {
    if (!selectedTerimaBanVulkanisirRows.length) {
      showNotif("error", "Pilih minimal 1 ban retread.");
      return;
    }
    const invalidStatusRows = selectedTerimaBanVulkanisirRows
      .filter((row) => {
        const status = String(row?.statusAkhir || "").trim();
        const repairedOptions = new Set(
          (Array.isArray(row?.statusRepairedOptions) ? row.statusRepairedOptions : [])
            .map((value) => String(value || "").trim().toUpperCase())
            .filter(Boolean)
        );
        return !status
          || (!/^(VT|UT)-\d+$/i.test(status)
            && !/^VT-\d+-OT$/i.test(status)
            && !OPSI_STATUS_RETREAD_CUSTOM.map((x) => x.toUpperCase()).includes(status.toUpperCase())
            && !repairedOptions.has(status.toUpperCase()));
      })
      .map((row) => row?.idBan || "-");
    if (invalidStatusRows.length) {
      showNotif("error", `Status tidak valid. Periksa id_ban: ${invalidStatusRows.join(", ")}.`);
      return;
    }
    const invalidTelapakRows = selectedTerimaBanVulkanisirRows
      .filter((row) => !String(row?.telapak || "").trim())
      .map((row) => row?.idBan || "-");
    if (invalidTelapakRows.length) {
      showNotif("error", `Jenis telapak wajib diisi. Periksa id_ban: ${invalidTelapakRows.join(", ")}.`);
      return;
    }
    const invalidTdRows = selectedTerimaBanVulkanisirRows
      .map((row) => ({
        idBan: row?.idBan,
        td: String(row?.td || "").trim(),
      }))
      .filter((row) => !TD_PATTERN.test(row.td));
    if (invalidTdRows.length) {
      const invalidLabels = invalidTdRows
        .map((row) => row.idBan || "-")
        .join(", ");
      showNotif(
        "error",
        `Format TD harus angka-angka-angka-angka. Periksa id_ban: ${invalidLabels}.`
      );
      return;
    }
    setShowTerimaBanVulkanisirTableScreen(false);
    setReadySimpanTerimaBanVulkanisir(true);
  };

  const handleSimpanDataTerimaBanVulkanisir = async () => {
    if (!readySimpanTerimaBanVulkanisir || !selectedTerimaBanVulkanisirRows.length) {
      showNotif("error", "Data pengiriman ban retread belum siap disimpan.");
      return;
    }
    if (hasForbiddenNoDokumenCharacter(terimaBanVulkanisir.noDokumen)) {
      showNotif("error", "No. Dokumen tidak boleh mengandung tanda #.");
      return;
    }
    if (!attachmentsTerimaBanVulkanisir.length) {
      showNotif("error", "Upload Dokumen wajib diisi.");
      return;
    }
    const invalidTerimaVulkanisirCaptions = collectInvalidCaptionIndexes(attachmentsTerimaBanVulkanisir);
    if (invalidTerimaVulkanisirCaptions.length > 0) {
      setInvalidCaptionIndexesTerimaBanVulkanisir(invalidTerimaVulkanisirCaptions);
      showNotif("error", "Caption dokumen wajib diisi untuk semua lampiran.");
      return;
    }
    setIsSubmittingTerimaBanVulkanisir(true);
    try {
      const kodeCabangFinal = String(
        terimaBanVulkanisir.kodeCabang || (!isPusat ? actorKodeCabang : "")
      ).trim();
      if (!kodeCabangFinal) {
        showNotif("error", "Cabang wajib dipilih.");
        return;
      }

      const selectedBanIds = Array.from(
        new Set(
          selectedTerimaBanVulkanisirRows
            .map((row) => Number(row?.idBan || 0))
            .filter((idBan) => Number.isFinite(idBan) && idBan > 0)
        )
      );
      if (!selectedBanIds.length) {
        showNotif("error", "Pilih minimal 1 ban retread.");
        return;
      }

      const formData = new FormData();
      formData.append("kode_cabang", kodeCabangFinal);
      formData.append(
        "nomor",
        buildNomorSubmitPlaceholder({
          kodeCabang: kodeCabangFinal,
          prefix: "CASING",
          tanggal: terimaBanVulkanisir.tanggal,
        })
      );
      formData.append("tanggal", String(terimaBanVulkanisir.tanggal || "").trim());
      formData.append("no_dokumen", String(terimaBanVulkanisir.noDokumen || "").trim());
      formData.append("tgl_dokumen", String(terimaBanVulkanisir.tglDokumen || "").trim());
      formData.append("vendor", String(terimaBanVulkanisir.vendor || "").trim());
      formData.append("catatan", String(terimaBanVulkanisir.catatan || "").trim());
      formData.append("selected_ban_ids", JSON.stringify(selectedBanIds));
      formData.append(
        "selected_ban_rows",
        JSON.stringify(
          selectedTerimaBanVulkanisirRows.map((row) => ({
            id_ban: Number(row?.idBan || 0),
            repair: String(row?.jenisRepair || "").trim(),
            status: String(row?.statusAkhir || "").trim(),
            telapak: String(row?.telapak || "").trim(),
            td: String(row?.td || "").trim(),
            catatan_ban: String(row?.catatanBan || "").trim(),
          }))
        )
      );
      formData.append("user", actorNama);

      attachmentsTerimaBanVulkanisir.forEach((item) => {
        if (item?.file instanceof File) formData.append("files", item.file);
        formData.append("captions", item?.caption || "");
      });
      const existingLampiran = attachmentsTerimaBanVulkanisir
        .filter((item) => !(item?.file instanceof File))
        .map((item) => ({
          name: item?.name || "",
          file: item?.db_file || item?.file || "",
          path: item?.path || "",
          type: item?.type || "",
          size: Number(item?.size || 0),
          caption: item?.caption || "",
          uploaded_at: item?.uploaded_at || null,
        }));
      formData.append("existing_lampiran", JSON.stringify(existingLampiran));

      api.cancelPendingRequests({
        group: REQ_GROUP_RETREAD_SUBMIT,
        reason: "submit terima retread",
      });
      const { data } = await api.post(`${backendPort}/api/main/submit_terima_ban_vulkanisir`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        requestGroup: REQ_GROUP_RETREAD_SUBMIT,
        timeout: 120000,
      });
      showNotif("success", data?.message || "Pengiriman ban retread ke gudang berhasil disimpan. Menunggu konfirmasi terima ban.");
      try {
        await manualResyncGlobalOpsi({ requestGroup: "stok-terima-vulkanisir" });
      } catch (refreshErr) {
        console.error(refreshErr);
      }
      handlePilihAction("konfirmasi_terima_ban");
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
      showNotif("error", err?.response?.data?.message || "Gagal menyimpan pengiriman ban retread ke gudang.");
    } finally {
      setIsSubmittingTerimaBanVulkanisir(false);
    }
  };

  useEffect(() => {
    const reloadPengirimanCasingOnResend = async () => {
      if (!resendToken) return;
      if (activeAction !== "pengiriman_casing") return;
      if (!showPengirimanCasingTableScreen) return;
      const kodeCabangFinal = String(
        pengirimanCasing.kodeCabang || (!isPusat ? actorKodeCabang : "")
      ).trim();
      if (!kodeCabangFinal) return;
      await loadPengirimanCasingRows(kodeCabangFinal);
    };
    reloadPengirimanCasingOnResend();
  }, [
    resendToken,
    activeAction,
    showPengirimanCasingTableScreen,
    pengirimanCasing.kodeCabang,
    isPusat,
    actorKodeCabang,
  ]);
  useEffect(() => {
    const reloadTerimaBanVulkanisirOnResend = async () => {
      if (!resendToken) return;
      if (activeAction !== "terima_ban_vulkanisir") return;
      if (!showTerimaBanVulkanisirTableScreen) return;
      await loadTerimaBanVulkanisirRows();
    };
    reloadTerimaBanVulkanisirOnResend();
  }, [
    resendToken,
    activeAction,
    showTerimaBanVulkanisirTableScreen,
    terimaBanVulkanisir.vendor,
    terimaBanVulkanisir.kodeCabang,
    isPusat,
    actorKodeCabang,
  ]);

  const handleSelesaiPilihBanPerubahanStatus = async (rows = [], ids = []) => {
    const normalizedRows = (Array.isArray(rows) ? rows : []).map((row) => ({
      id_ban: Number(row?.id_ban || row?.idBan || 0),
      seri_ban: String(row?.seri_ban || row?.seriBan || "").trim(),
      status: String(row?.status || row?.status_now || "").trim(),
      merk: String(row?.merk || "").trim(),
      place: String(row?.place || row?.place_terakhir || row?.place_now || "").trim(),
      event_terakhir: String(row?.event_terakhir || "").trim(),
    }));
    const rowById = new Map(
      normalizedRows
        .filter((row) => Number.isFinite(row.id_ban) && row.id_ban > 0)
        .map((row) => [Number(row.id_ban), row])
    );
    const incomingIds = Array.from(
      new Set((Array.isArray(ids) ? ids : []).map((x) => Number(x)).filter((x) => Number.isFinite(x) && x > 0))
    );
    const isEligibleManualStatus = (row) => {
      const place = String(row?.place || "").trim().toLowerCase();
      const status = String(row?.status || "").trim().toUpperCase();
      const eventTerakhir = String(row?.event_terakhir || "").trim();
      if (!place && !status) return true;
      const isGudang = place.startsWith("gudang#");
      const isNotDonePlace = place === "gudang#notdone";
      const isAllowedStatus = status === "NT"
        || status === "UT"
        || status.startsWith("VT-")
        || status.startsWith("UV-")
        || status === "CASING"
        || status === "PERLU REPAIR"
        || status === "PERLU OT"
        || status.startsWith("AFKIR");
      const isBlockedStatus = status.startsWith("DISPOSED") || status.startsWith("UNTRACKED");
      const isUsulanPending = isUsulanPendingEvent(eventTerakhir);
      return isGudang && !isNotDonePlace && isAllowedStatus && !isBlockedStatus && !isUsulanPending;
    };
    const normalizedIds = incomingIds.filter((idBan) => isEligibleManualStatus(rowById.get(Number(idBan)) || {}));
    const removedCount = incomingIds.length - normalizedIds.length;

    setSelectedPerubahanStatusBanIds(normalizedIds);
    setStatusChangeByBanId((prev) => {
      const kept = {};
      normalizedIds.forEach((id) => {
        if (prev[id]) kept[id] = prev[id];
      });
      return kept;
    });
    setStatusLampiranPerubahanByBanId((prev) => {
      const kept = {};
      normalizedIds.forEach((id) => {
        if (prev?.[id]) kept[id] = prev[id];
      });
      return kept;
    });
    setInvalidStatusLampiranPerubahanByBanId((prev) => {
      const kept = {};
      normalizedIds.forEach((id) => {
        if (prev?.[id]) kept[id] = prev[id];
      });
      return kept;
    });
    if (!normalizedIds.length) {
      setSelectedPerubahanStatusBanRows([]);
      setAttachmentsPerubahanStatusBan([]);
      setInvalidCaptionIndexesPerubahanStatusBan([]);
      setStatusLampiranPerubahanByBanId({});
      setInvalidStatusLampiranPerubahanByBanId({});
      showNotif("warning", "Tidak ada ban yang memenuhi kriteria Ubah Status Manual.");
      return;
    }

    const basicByBanId = rowById;

    const mappedRows = normalizedIds.map((idBan) => {
      const basic = basicByBanId.get(Number(idBan)) || {};
      return {
        id_ban: idBan,
        seri_ban: String(basic?.seri_ban || "").trim(),
        status: String(basic?.status || basic?.status_now || "-").trim() || "-",
        merk: String(basic?.merk || "-").trim() || "-",
      };
    });
    setSelectedPerubahanStatusBanRows(mappedRows);

    if (removedCount > 0) {
      showNotif("warning", `${removedCount} ban tidak memenuhi kriteria Ubah Status Manual dan tidak disertakan.`);
    }
    showNotif("success", `${normalizedIds.length} ban dipilih.`);
  };

  const handleOpenPilihBanUbahDataMassal = async () => {
    if (!ubahDataMassalStep1Ready) return;
    if (!isPusat) {
      setUbahDataMassal((prev) => ({ ...prev, kodeCabang: actorKodeCabang, filterCabang: actorKodeCabang }));
    }
    setOpenUbahDataMassalModal(true);
  };

  const ubahProfilBanKodeCabangEfektif = useMemo(() => (
    isPusat ? String(ubahProfilBan.kodeCabang || "").trim() : actorKodeCabang
  ), [isPusat, ubahProfilBan.kodeCabang, actorKodeCabang]);

  const ubahProfilBanCabangInputLabel = useMemo(() => {
    const kode = String(ubahProfilBanKodeCabangEfektif || "").trim().toUpperCase();
    if (!kode) return "";
    return cabangPenerimaMapByKodeUpper.get(kode)?.nama || kode;
  }, [ubahProfilBanKodeCabangEfektif, cabangPenerimaMapByKodeUpper]);

  const buildUbahProfilBanNomorPreview = () => {
    return buildNomorPreviewPlaceholder({
      kodeCabang: ubahProfilBanKodeCabangEfektif,
      prefix: "MEMO",
      tanggal: ubahProfilBan.tanggal,
    });
  };

  useEffect(() => {
    if (activeAction !== "ubah_profil_ban") return;
    setUbahProfilBan((prev) => ({
      ...prev,
      kodeCabang: ubahProfilBanKodeCabangEfektif,
      nomor: buildNomorPreviewPlaceholder({
        kodeCabang: ubahProfilBanKodeCabangEfektif,
        prefix: "MEMO",
        tanggal: ubahProfilBan.tanggal,
      }),
    }));
  }, [activeAction, ubahProfilBan.tanggal, ubahProfilBanKodeCabangEfektif, resendToken]);

  const handleOpenPilihBanUbahProfilBan = () => {
    if (!ubahProfilBanKodeCabangEfektif) return;
    if (!isPusat) {
      setUbahProfilBan((prev) => ({ ...prev, kodeCabang: actorKodeCabang }));
    }
    setOpenUbahProfilBanModal(true);
  };

  const handleSelesaiPilihBanUbahProfilBan = (rows = [], ids = []) => {
    const normalizedIds = Array.from(
      new Set((Array.isArray(ids) ? ids : []).map((x) => Number(x)).filter((x) => Number.isFinite(x) && x > 0))
    );
    const rowsById = new Map(
      (Array.isArray(rows) ? rows : [])
        .map((row) => ({
          id_ban: Number(row?.id_ban || 0),
          seri_ban: String(row?.seri_ban || "").trim(),
          merk: String(row?.merk || "").trim(),
          ukuran: String(row?.ukuran || "").trim(),
          telapak: String(row?.telapak || "").trim() || TELAPAK_DEFAULT,
          suplier: String(row?.id_suplier || row?.suplier || "").trim(),
          kode_cabang: String(row?.kode_cabang || "").trim(),
          catatan: String(row?.catatan || "").trim(),
        }))
        .filter((row) => Number.isFinite(row.id_ban) && row.id_ban > 0)
        .map((row) => [row.id_ban, row])
    );
    const prevById = new Map(
      (Array.isArray(selectedUbahProfilBanRows) ? selectedUbahProfilBanRows : [])
        .map((row) => [Number(row?.id_ban || 0), row])
        .filter(([id]) => Number.isFinite(id) && id > 0)
    );
    const mappedRows = normalizedIds.map((idBan) => {
      const base = rowsById.get(Number(idBan)) || prevById.get(Number(idBan)) || {};
      return {
        id_ban: idBan,
        seri_ban: String(base?.seri_ban || "").trim(),
        merk: String(base?.merk || "").trim(),
        ukuran: String(base?.ukuran || "").trim(),
        telapak: String(base?.telapak || "").trim() || TELAPAK_DEFAULT,
        suplier: String(base?.suplier || base?.id_suplier || "").trim(),
        kode_cabang: String(base?.kode_cabang || "").trim(),
        catatan: String(base?.catatan || "").trim(),
      };
    });
    setSelectedUbahProfilBanIds(normalizedIds);
    setSelectedUbahProfilBanRows(mappedRows);
    showNotif("success", `${normalizedIds.length} ban dipilih untuk Ubah Profil Ban.`);
  };

  const updateUbahProfilBanRow = (idBan, field, value) => {
    setSelectedUbahProfilBanRows((prev) => (
      (Array.isArray(prev) ? prev : []).map((row) => {
        if (Number(row?.id_ban || 0) !== Number(idBan || 0)) return row;
        if (field === "suplier") {
          return {
            ...row,
            suplier: String(value || "").trim(),
            telapak: TELAPAK_DEFAULT,
          };
        }
        if (field === "catatan") {
          return { ...row, catatan: String(value ?? "") };
        }
        return { ...row, [field]: String(value || "").trim() };
      })
    ));
  };

  const getUbahProfilTelapakOptions = (suplier) => {
    const key = String(suplier || "").trim().toUpperCase();
    const list = key ? (telapakBySuplierUpper.get(key) || []) : [];
    return [TELAPAK_DEFAULT, ...Array.from(new Set(list.map((x) => String(x || "").trim()).filter(Boolean)))];
  };

  const handleSubmitUbahProfilBan = async () => {
    if (isSubmittingUbahProfilBan) return;
    const kodeCabangSubmit = String(ubahProfilBanKodeCabangEfektif || "").trim();
    if (!kodeCabangSubmit) {
      showNotif("error", "Kode cabang belum valid.");
      return;
    }
    const rowsPayload = (Array.isArray(selectedUbahProfilBanRows) ? selectedUbahProfilBanRows : [])
      .map((row) => ({
        id_ban: Number(row?.id_ban || 0),
        merk: String(row?.merk || "").trim(),
        ukuran: String(row?.ukuran || "").trim(),
        telapak: String(row?.telapak || "").trim(),
        suplier: String(row?.suplier || row?.id_suplier || "").trim(),
        catatan: String(row?.catatan || "").trim(),
      }))
      .filter((row) => Number.isFinite(row.id_ban) && row.id_ban > 0);
    if (!rowsPayload.length) {
      showNotif("error", "Pilih minimal 1 ban untuk diproses.");
      return;
    }
    const invalidCaptionIndexes = collectInvalidCaptionIndexes(attachmentsUbahProfilBan);
    if (attachmentsUbahProfilBan.length > 0 && invalidCaptionIndexes.length > 0) {
      setInvalidCaptionIndexesUbahProfilBan(invalidCaptionIndexes);
      showNotif("error", "Caption dokumen wajib diisi untuk semua lampiran.");
      return;
    }

    try {
      setIsSubmittingUbahProfilBan(true);
      api.cancelPendingRequests({
        group: REQ_GROUP_UBAH_PROFIL_BAN_SUBMIT,
        reason: "submit ubah profil ban",
      });
      const formData = new FormData();
      formData.append("kode_cabang", kodeCabangSubmit);
      formData.append("rows", JSON.stringify(rowsPayload));
      attachmentsUbahProfilBan
        .filter((item) => item?.file instanceof File)
        .forEach((item) => {
          formData.append("files", item.file);
          formData.append("captions", String(item.caption || "").trim());
        });
      const existingLampiran = attachmentsUbahProfilBan
        .filter((item) => !(item?.file instanceof File))
        .map((item) => sanitizeLampiranItemPayload(item))
        .filter(Boolean);
      formData.append("existing_lampiran", JSON.stringify(existingLampiran));
      const { data } = await api.post(`${backendPort}/api/main/submit_ubah_profil_ban`, formData, {
        requestGroup: REQ_GROUP_UBAH_PROFIL_BAN_SUBMIT,
        timeout: 120000,
      });
      showNotif("success", data?.message || "Ubah Profil Ban berhasil diproses.");
      if (Number(data?.data?.changed_ban || 0) > 0) {
        setSelectedUbahProfilBanRows([]);
        setSelectedUbahProfilBanIds([]);
        setAttachmentsUbahProfilBan([]);
        setInvalidCaptionIndexesUbahProfilBan([]);
        setOpenUbahProfilBanModal(false);
        setUbahProfilBan((prev) => ({
          ...prev,
          nomor: buildNomorPreviewPlaceholder({
            kodeCabang: kodeCabangSubmit,
            prefix: "MEMO",
            tanggal: prev.tanggal,
          }),
        }));
      }
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
      showNotif("error", err?.response?.data?.message || "Gagal submit Ubah Profil Ban.");
    } finally {
      setIsSubmittingUbahProfilBan(false);
    }
  };

  const handleSelesaiPilihBanUbahDataMassal = (rows = [], ids = []) => {
    const normalizedIds = Array.from(
      new Set((Array.isArray(ids) ? ids : []).map((x) => Number(x)).filter((x) => Number.isFinite(x) && x > 0))
    );
    const rowsById = new Map(
      (Array.isArray(rows) ? rows : [])
        .map((row) => ({
          id_ban: Number(row?.id_ban || 0),
          seri_ban: String(row?.seri_ban || row?.seriBan || "").trim(),
          status: String(row?.status_now || row?.status || "").trim(),
          kode_cabang: String(row?.kode_cabang || "").trim(),
          place: String(row?.place_now || row?.place || "").trim(),
        }))
        .filter((row) => Number.isFinite(row.id_ban) && row.id_ban > 0)
        .map((row) => [row.id_ban, row])
    );
    const prevById = new Map(
      (Array.isArray(selectedUbahDataMassalRows) ? selectedUbahDataMassalRows : [])
        .map((row) => ({
          id_ban: Number(row?.id_ban || 0),
          seri_ban: String(row?.seri_ban || "").trim(),
          status: String(row?.status || "").trim(),
          kode_cabang: String(row?.kode_cabang || "").trim(),
          place: String(row?.place || "").trim(),
        }))
        .filter((row) => Number.isFinite(row.id_ban) && row.id_ban > 0)
        .map((row) => [row.id_ban, row])
    );
    setSelectedUbahDataMassalIds(normalizedIds);
    const mappedRows = normalizedIds.map((idBan) => {
      const base = rowsById.get(Number(idBan)) || prevById.get(Number(idBan)) || {};
      return {
        id_ban: idBan,
        seri_ban: String(base?.seri_ban || "").trim(),
        status: String(base?.status || "").trim(),
        kode_cabang: String(base?.kode_cabang || "").trim(),
        place: String(base?.place || "").trim(),
      };
    });
    setSelectedUbahDataMassalRows(mappedRows);
    showNotif("success", `${normalizedIds.length} ban dipilih.`);
  };

  const handleDownloadTemplateUbahDataMassal = async () => {
    if (!selectedUbahDataMassalRows.length) {
      showNotif("error", "Pilih minimal 1 ban terlebih dahulu.");
      return;
    }
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("ubah_data_massal");
      worksheet.columns = [
        { header: "no", key: "no", width: 8 },
        { header: "id_ban", key: "id_ban", width: 12 },
        { header: "seri_ban", key: "seri_ban", width: 24 },
        { header: "nama_cabang", key: "nama_cabang", width: 24 },
        { header: "lokasi", key: "lokasi", width: 28 },
        { header: "status_now", key: "status_now", width: 18 },
        { header: "status_then", key: "status_then", width: 18 },
        { header: "catatan", key: "catatan", width: 36 },
      ];
      selectedUbahDataMassalRows.forEach((row, idx) => {
        const kodeCabang = String(row?.kode_cabang || "").trim();
        worksheet.addRow({
          no: idx + 1,
          id_ban: Number(row?.id_ban || 0),
          seri_ban: String(row?.seri_ban || "").trim(),
          nama_cabang: resolveNamaCabang(kodeCabang, kodeCabang || "-"),
          lokasi: formatLokasiUbahMassal(String(row?.place || "").trim(), kodeCabang),
          status_now: String(row?.status || "").trim(),
          status_then: "",
          catatan: "",
        });
      });
      const headerRow = worksheet.getRow(1);
      headerRow.font = { bold: true };
      worksheet.views = [{ state: "frozen", ySplit: 1 }];
      const dataStart = 2;
      const dataEnd = dataStart + selectedUbahDataMassalRows.length - 1;
      for (let rowNum = dataStart; rowNum <= dataEnd; rowNum += 1) {
        const statusNow = String(worksheet.getCell(`F${rowNum}`).value || "").trim().toUpperCase();
        const statusOptions = getStatusChangeOptions(statusNow);
        worksheet.getCell(`G${rowNum}`).dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: [`"${statusOptions.join(",")}"`],
          showErrorMessage: true,
          errorTitle: "Status tidak valid",
          error: "Pilih status sesuai opsi yang tersedia.",
        };
        // Hanya izinkan edit kolom status_then dan catatan pada baris data.
        worksheet.getCell(`A${rowNum}`).protection = { locked: true };
        worksheet.getCell(`B${rowNum}`).protection = { locked: true };
        worksheet.getCell(`C${rowNum}`).protection = { locked: true };
        worksheet.getCell(`D${rowNum}`).protection = { locked: true };
        worksheet.getCell(`E${rowNum}`).protection = { locked: true };
        worksheet.getCell(`F${rowNum}`).protection = { locked: true };
        worksheet.getCell(`G${rowNum}`).protection = { locked: false };
        worksheet.getCell(`H${rowNum}`).protection = { locked: false };
      }
      await worksheet.protect("massal_status_lock", {
        selectLockedCells: true,
        selectUnlockedCells: true,
        formatCells: false,
        formatColumns: false,
        formatRows: false,
        insertColumns: false,
        insertRows: false,
        insertHyperlinks: false,
        deleteColumns: false,
        deleteRows: false,
        sort: false,
        autoFilter: false,
        pivotTables: false,
      });
      const nomorTemplate = String(
        buildNomorSubmitPlaceholder({
          kodeCabang: ubahDataMassalKodeCabangEfektif,
          prefix: "MASSAL",
          tanggal: ubahDataMassal.tanggal,
        })
      ).trim();
      const metaSheet = workbook.addWorksheet("_meta");
      metaSheet.state = "veryHidden";
      metaSheet.getCell("A1").value = "nomor_transaksi";
      metaSheet.getCell("B1").value = nomorTemplate;
      metaSheet.getCell("A2").value = "tanggal";
      metaSheet.getCell("B2").value = String(ubahDataMassal.tanggal || "").trim();
      metaSheet.getCell("A3").value = "generated_at";
      metaSheet.getCell("B3").value = new Date().toISOString();
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      const nomorToken = nomorTemplate.replace(/[^\w.-]+/g, "_");
      a.download = `Template_Ubah_Data_Massal_${nomorToken}_${String(ubahDataMassal.tanggal || buildTodayKey())}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      showNotif("error", "Gagal mengunduh template excel.");
    }
  };

  const handleUploadFileUbahDataMassal = (event) => {
    const file = event?.target?.files?.[0] || null;
    setBulkUbahDataMassalFile(file);
  };

  const handleSubmitUbahStatusMassal = async () => {
    if (isSubmittingUbahDataMassal) return;
    if (!bulkUbahDataMassalFile) {
      showNotif("error", "Pilih file excel terlebih dahulu.");
      return;
    }
    try {
      setIsSubmittingUbahDataMassal(true);
      const workbook = new ExcelJS.Workbook();
      const buffer = await bulkUbahDataMassalFile.arrayBuffer();
      await workbook.xlsx.load(buffer);
      const ws = workbook.worksheets?.[0];
      if (!ws) {
        showNotif("error", "Worksheet tidak ditemukan.");
        return;
      }
      const nomorAktif = String(
        buildNomorSubmitPlaceholder({
          kodeCabang: ubahDataMassalKodeCabangEfektif,
          prefix: "MASSAL",
          tanggal: ubahDataMassal.tanggal,
        })
      ).trim();
      const metaSheet = workbook.getWorksheet("_meta");
      const nomorTemplate = String(metaSheet?.getCell("B1")?.value || "").trim();
      if (nomorTemplate && normalizeNomorKey(nomorTemplate) !== normalizeNomorKey(nomorAktif)) {
        showNotif("error", `File template tidak sesuai nomor transaksi aktif (${nomorAktif}). Silakan download ulang template.`);
        return;
      }

      const headerValues = [];
      ws.getRow(1).eachCell((cell, colNumber) => {
        headerValues[colNumber - 1] = String(cell.value || "").trim().toLowerCase();
      });
      const expectedHeadersWithSeri = ["no", "id_ban", "seri_ban", "nama_cabang", "lokasi", "status_now", "status_then", "catatan"];
      const expectedHeadersNew = ["no", "id_ban", "nama_cabang", "lokasi", "status_now", "status_then", "catatan"];
      const expectedHeadersLegacy = ["no", "id_ban", "kode_cabang", "place", "status_now", "status_then", "catatan"];
      const isHeaderWithSeri = expectedHeadersWithSeri.every((h, idx) => String(headerValues[idx] || "") === h);
      const isHeaderNew = expectedHeadersNew.every((h, idx) => String(headerValues[idx] || "") === h);
      const isHeaderLegacy = expectedHeadersLegacy.every((h, idx) => String(headerValues[idx] || "") === h);
      const headerMismatch = !isHeaderWithSeri && !isHeaderNew && !isHeaderLegacy;
      if (headerMismatch) {
        showNotif("error", "Header file tidak sesuai format Ubah Status Massal.");
        return;
      }

      const rowsPayload = [];
      for (let rowNum = 2; rowNum <= ws.rowCount; rowNum += 1) {
        const row = ws.getRow(rowNum);
        const idBanRaw = String(row.getCell(2).value || "").trim();
        const cabangCol = isHeaderWithSeri ? 4 : 3;
        const lokasiCol = isHeaderWithSeri ? 5 : 4;
        const statusNowCol = isHeaderWithSeri ? 6 : 5;
        const statusThenCol = isHeaderWithSeri ? 7 : 6;
        const catatanCol = isHeaderWithSeri ? 8 : 7;
        const colCabangOrNama = String(row.getCell(cabangCol).value || "").trim();
        const colLokasiOrPlace = String(row.getCell(lokasiCol).value || "").trim();
        const statusNow = String(row.getCell(statusNowCol).value || "").trim();
        const statusThen = String(row.getCell(statusThenCol).value || "").trim();
        const catatan = String(row.getCell(catatanCol).value || "").trim();
        if (!idBanRaw && !statusThen && !catatan) continue;
        const idBan = Number(idBanRaw);
        if (!Number.isFinite(idBan) || idBan <= 0) {
          showNotif("error", `id_ban baris ${rowNum} tidak valid.`);
          return;
        }
        if (!statusThen) {
          showNotif("error", `status_then baris ${rowNum} wajib diisi.`);
          return;
        }
        const namaCabang = (isHeaderWithSeri || isHeaderNew) ? colCabangOrNama : "";
        const kodeCabang = isHeaderLegacy
          ? colCabangOrNama
          : String(
            cabangPenerimaMapByNamaUpper.get(String(namaCabang || "").trim().toUpperCase())?.kode
            || cabangPenerimaMapByKodeUpper.get(String(namaCabang || "").trim().toUpperCase())?.kode
            || ""
          ).trim().toUpperCase();
        if (!isPusat && String(kodeCabang || "").trim().toUpperCase() !== String(actorKodeCabang || "").trim().toUpperCase()) {
          showNotif("error", `Cabang file baris ${rowNum} harus sesuai cabang user (${namaCabangUser}).`);
          return;
        }
        const place = isHeaderLegacy
          ? colLokasiOrPlace
          : parseLokasiUbahMassalToPlace(colLokasiOrPlace, kodeCabang, namaCabang);
        rowsPayload.push({
          id_ban: idBan,
          kode_cabang: kodeCabang,
          place,
          status_now: statusNow,
          status_then: normalizeStatusOptionLabel(statusThen),
          catatan,
        });
      }

      if (!rowsPayload.length) {
        showNotif("error", "Tidak ada baris data valid pada file.");
        return;
      }
      const approvalRowsNeedMemoLampiran = rowsPayload.filter((row) => {
        const next = normalizeStatusText(row?.status_then || "");
        return !isPusat && needApprovalStatuses.has(next) && next !== "AFKIR";
      });
      if (approvalRowsNeedMemoLampiran.length > 0 && attachmentsUbahDataMassal.length === 0) {
        showNotif("error", "Upload dokumen wajib diisi untuk status yang memerlukan persetujuan.");
        return;
      }
      const invalidCaptionIndexes = collectInvalidCaptionIndexes(attachmentsUbahDataMassal);
      if (attachmentsUbahDataMassal.length > 0 && invalidCaptionIndexes.length > 0) {
        setInvalidCaptionIndexesUbahDataMassal(invalidCaptionIndexes);
        showNotif("error", "Caption dokumen wajib diisi untuk semua lampiran.");
        return;
      }

      api.cancelPendingRequests({
        group: REQ_GROUP_STATUS_MASSAL_SUBMIT,
        reason: "submit ubah status massal",
      });
      const formData = new FormData();
      const kodeCabangSubmit = ubahDataMassalKodeCabangEfektif;
      formData.append("kode_cabang", kodeCabangSubmit);
      formData.append("kode_cabang_user", actorKodeCabang);
      formData.append("username_user", actorUsername);
      formData.append("nama_user", actorNama);
      formData.append("tanggal", String(ubahDataMassal.tanggal || "").trim());
      formData.append("nomor", buildNomorSubmitPlaceholder({
        kodeCabang: kodeCabangSubmit,
        prefix: "MASSAL",
        tanggal: ubahDataMassal.tanggal,
      }));
      formData.append("user", actorNama);
      formData.append("rows", JSON.stringify(rowsPayload));
      attachmentsUbahDataMassal
        .filter((item) => item?.file instanceof File)
        .forEach((item) => {
          formData.append("files", item.file);
          formData.append("captions", String(item?.caption || "").trim());
        });
      const existingLampiran = attachmentsUbahDataMassal
        .filter((item) => !(item?.file instanceof File))
        .map((item) => sanitizeLampiranItemPayload(item))
        .filter(Boolean);
      formData.append("existing_lampiran", JSON.stringify(existingLampiran));

      const { data } = await api.post(`${backendPort}/api/main/submit_ubah_status_massal_bulk`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        requestGroup: REQ_GROUP_STATUS_MASSAL_SUBMIT,
        timeout: 120000,
      });
      showNotif("success", data?.message || "Ubah status massal berhasil diproses.");
      try {
        await manualResyncGlobalOpsi({ requestGroup: "stok-ubah-status-massal" });
      } catch (refreshErr) {
        console.error(refreshErr);
      }
      setBulkUbahDataMassalFile(null);
      setSelectedUbahDataMassalRows([]);
      setSelectedUbahDataMassalIds([]);
      setAttachmentsUbahDataMassal([]);
      setInvalidCaptionIndexesUbahDataMassal([]);
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
      showNotif("error", err?.response?.data?.message || "Gagal submit ubah status massal.");
    } finally {
      setIsSubmittingUbahDataMassal(false);
    }
  };

  const handleOpenStatusPerubahanModal = (row) => {
    const id = Number(row?.id_ban || 0);
    if (!id) return;
    const current = String(row?.statusSaatIni || row?.status || "-").trim() || "-";
    const saved = statusChangeByBanId[id] || {};
    setStatusBanTarget({ ...row, id_ban: id, statusSaatIni: current });
    setStatusBanDraftNext(String(saved.nextStatus || "").trim());
    setOpenStatusBanModal(true);
  };

  const handleSaveStatusPerubahanModal = () => {
    const id = Number(statusBanTarget?.id_ban || 0);
    if (!id) return;
    const nextStatus = normalizeStatusOptionLabel(statusBanDraftNext);
    if (!nextStatus) {
      showNotif("error", "Pilih Status Baru terlebih dahulu.");
      return;
    }
    const nextCatatan = String(activePerubahanStatusBanCatatan || "").trim();
    if (!nextCatatan) {
      showNotif("error", "Catatan wajib diisi.");
      return;
    }
    const lampiranValidation = validateStatusLampiranPerubahan(id, nextStatus);
    if (lampiranValidation.invalid) {
      if (lampiranValidation.key) {
        setInvalidStatusLampiranPerubahanByBanId((prev) => ({
          ...(prev || {}),
          [lampiranValidation.key]: lampiranValidation.invalidCaptions.length
            ? lampiranValidation.invalidCaptions
            : [-1],
        }));
      }
      showNotif(
        "error",
        "Caption dokumen wajib diisi untuk lampiran perubahan status."
      );
      return;
    }
    clearInvalidStatusLampiranPerubahan(lampiranValidation.key);
    setStatusChangeByBanId((prev) => ({
      ...prev,
      [id]: {
        ...(prev[id] || {}),
        nextStatus,
        catatan: nextCatatan,
        done: true,
      },
    }));
    setOpenStatusBanModal(false);
  };

  const setPerubahanStatusCatatanById = (idBan, value) => {
    const id = Number(idBan || 0);
    if (!id) return;
    setStatusChangeByBanId((prev) => ({
      ...prev,
      [id]: {
        ...(prev[id] || {}),
        catatan: String(value || ""),
      },
    }));
  };


  const handleOpenPilihBanPerubahanStatus = async () => {
    if (!perubahanStatusBanStep1Ready) return;
    const kodeCabang = String(
      perubahanStatusBan.kodeCabang || (!isPusat ? actorKodeCabang : "")
    ).trim();
    if (!kodeCabang) {
      showNotif("error", "Pilih cabang terlebih dahulu.");
      return;
    }
    setOpenPerubahanStatusBanModal(true);
  };

  const handleSelesaiPilihBanPerintahPemindahanStock = (rows = [], ids = []) => {
    const normalizedIds = Array.from(
      new Set((Array.isArray(ids) ? ids : []).map((x) => Number(x)).filter((x) => Number.isFinite(x) && x > 0))
    );
    const rowById = new Map(
      (Array.isArray(rows) ? rows : [])
        .map((row) => ({
          id_ban: Number(row?.id_ban || 0),
          seri_ban: String(row?.seri_ban || "").trim(),
          status: String(row?.status || row?.status_now || "-").trim() || "-",
          merk: String(row?.merk || "-").trim() || "-",
        }))
        .filter((row) => Number.isFinite(row.id_ban) && row.id_ban > 0)
        .map((row) => [row.id_ban, row])
    );

    setSelectedPerintahPemindahanStockIds(normalizedIds);
    if (!normalizedIds.length) {
      setSelectedPerintahPemindahanStockRows([]);
      showNotif("warning", "Tidak ada ban yang dipilih.");
      return;
    }

    const mappedRows = normalizedIds.map((idBan) => {
      const basic = rowById.get(Number(idBan)) || {};
      return {
        id_ban: idBan,
        seri_ban: String(basic?.seri_ban || "").trim(),
        status: String(basic?.status || "-").trim() || "-",
        merk: String(basic?.merk || "-").trim() || "-",
      };
    });
    setSelectedPerintahPemindahanStockRows(mappedRows);
    showNotif("success", `${normalizedIds.length} ban dipilih.`);
  };

  const handleOpenPilihBanPerintahPemindahanStock = async () => {
    if (!perintahPemindahanStockStep1Ready) return;
    const kodeCabang = String(
      perintahPemindahanStock.kodeCabang || (!isPusat ? actorKodeCabang : "")
    ).trim();
    if (!kodeCabang) {
      showNotif("error", "Pilih cabang pengirim terlebih dahulu.");
      return;
    }
    if (!String(perintahPemindahanStock.kodeCabangPenerima || "").trim()) {
      showNotif("error", "Pilih cabang penerima terlebih dahulu.");
      return;
    }
    setOpenPerintahPemindahanStockModal(true);
  };

  useEffect(() => {
    if (activeAction !== "perubahan_status_ban") return;
    if (!selectedPerubahanStatusDisplayRows.length) {
      setStatusBanTarget(null);
      return;
    }
    const targetId = Number(statusBanTarget?.id_ban || 0);
    const stillExists = selectedPerubahanStatusDisplayRows.some(
      (row) => Number(row?.id_ban || 0) === targetId
    );
    if (stillExists) return;
    const firstRow = selectedPerubahanStatusDisplayRows[0];
    setStatusBanTarget({
      ...firstRow,
      id_ban: Number(firstRow?.id_ban || 0),
      statusSaatIni: String(firstRow?.statusSaatIni || firstRow?.status || "-").trim() || "-",
    });
  }, [activeAction, selectedPerubahanStatusDisplayRows, statusBanTarget?.id_ban]);

  const handleSimpanPerubahanStatusBan = async () => {
    if (isSubmittingPerubahanStatusBan) return;
    if (!perubahanStatusBanStep1Ready) {
      showNotif("error", "Lengkapi data cabang, nomor, dan tanggal memo terlebih dahulu.");
      return;
    }
    if (!selectedPerubahanStatusDisplayRows.length) {
      showNotif("error", "Pilih minimal 1 ban untuk diproses.");
      return;
    }
    if (!semuaBanSudahDicekPerubahan) {
      showNotif("error", "Lengkapi perubahan status pada seluruh baris ban terlebih dahulu.");
      return;
    }

    const kodeCabangSubmit = String(
      perubahanStatusBan.kodeCabang || (!isPusat ? actorKodeCabang : "")
    ).trim();
    if (!kodeCabangSubmit) {
      showNotif("error", "Kode cabang belum valid.");
      return;
    }

    const rowsPayload = selectedPerubahanStatusDisplayRows.map((row) => {
      const idBan = Number(row?.id_ban || 0);
      const config = statusChangeByBanId[idBan] || {};
      return {
        id_ban: idBan,
        status_baru: normalizeStatusOptionLabel(config?.nextStatus || row?.statusBaru || ""),
        catatan_ban: String(config?.catatan || row?.catatan || "").trim(),
        lampiran: [],
      };
    }).filter((item) => Number.isFinite(item.id_ban) && item.id_ban > 0);

    const invalidStatusRow = rowsPayload.find((row) => !String(row.status_baru || "").trim());
    if (invalidStatusRow) {
      showNotif("error", `Status baru untuk id_ban ${invalidStatusRow.id_ban} belum dipilih.`);
      return;
    }
    const invalidCatatanRow = rowsPayload.find((row) => !String(row.catatan_ban || "").trim());
    if (invalidCatatanRow) {
      showNotif("error", `Catatan untuk id_ban ${invalidCatatanRow.id_ban} wajib diisi.`);
      return;
    }
    if (isPerubahanStatusNeedMemoLampiran && attachmentsPerubahanStatusBan.length === 0) {
      showNotif("error", "Upload Dokumen wajib diisi untuk status yang memerlukan persetujuan.");
      return;
    }
    const invalidPerubahanStatusCaptions = collectInvalidCaptionIndexes(attachmentsPerubahanStatusBan);
    if (invalidPerubahanStatusCaptions.length > 0) {
      setInvalidCaptionIndexesPerubahanStatusBan(invalidPerubahanStatusCaptions);
      showNotif("error", "Caption dokumen wajib diisi untuk semua lampiran.");
      return;
    }
    const invalidStatusLampiranByBanId = {};
    rowsPayload.forEach((row) => {
      const validation = validateStatusLampiranPerubahan(row.id_ban, row.status_baru);
      if (validation.invalid && validation.key) {
        invalidStatusLampiranByBanId[validation.key] = validation.invalidCaptions.length
          ? validation.invalidCaptions
          : [-1];
      }
    });
    if (Object.keys(invalidStatusLampiranByBanId).length > 0) {
      setInvalidStatusLampiranPerubahanByBanId(invalidStatusLampiranByBanId);
      showNotif("error", "Caption dokumen wajib diisi untuk lampiran perubahan status.");
      return;
    }

    try {
      setIsSubmittingPerubahanStatusBan(true);
      api.cancelPendingRequests({
        group: REQ_GROUP_STATUS_MANUAL_SUBMIT,
        reason: "submit ubah status manual",
      });
      const formData = new FormData();
      formData.append("kode_cabang", kodeCabangSubmit);
      formData.append("kode_cabang_user", actorKodeCabang);
      formData.append("username_user", actorUsername);
      formData.append("nama_user", actorNama);
      formData.append("tanggal", String(perubahanStatusBan.tanggal || "").trim());
      formData.append("nomor", buildNomorSubmitPlaceholder({
        kodeCabang: kodeCabangSubmit,
        prefix: "MEMO",
        tanggal: perubahanStatusBan.tanggal,
      }));
      formData.append("check_validasi", "true");
      formData.append("user", actorNama);
      formData.append("rows", JSON.stringify(rowsPayload));
      const lampiranBaru = attachmentsPerubahanStatusBan.filter((item) => item?.file instanceof File);
      lampiranBaru.forEach((item) => {
        formData.append("files", item.file);
        formData.append("captions", String(item?.caption || "").trim());
      });
      rowsPayload.forEach((row) => {
        const key = getStatusLampiranPerubahanKey(row.id_ban);
        if (!key) return;
        (statusLampiranPerubahanByBanId[key] || []).forEach((item) => {
          if (!(item?.file instanceof File)) return;
          formData.append("status_files", item.file);
          formData.append("status_captions", String(item?.caption || "").trim());
          formData.append("status_id_ban", key);
        });
      });
      const existingLampiran = attachmentsPerubahanStatusBan
        .filter((item) => !(item?.file instanceof File))
        .map((item) => sanitizeLampiranItemPayload(item))
        .filter(Boolean);
      formData.append("existing_lampiran", JSON.stringify(existingLampiran));
      const { data } = await api.post(`${backendPort}/api/main/submit_perubahan_status_ban`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        requestGroup: REQ_GROUP_STATUS_MANUAL_SUBMIT,
        timeout: 120000,
      });
      showNotif("success", data?.message || "Perubahan status ban berhasil disimpan.");
      try {
        await manualResyncGlobalOpsi({ requestGroup: "stok-perubahan-status-ban" });
      } catch (refreshErr) {
        console.error(refreshErr);
      }
      handlePilihAction("perubahan_status_ban");
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
      showNotif("error", err?.response?.data?.message || "Gagal submit perubahan status ban.");
    } finally {
      setIsSubmittingPerubahanStatusBan(false);
    }
  };

  const submitPengirimanCasing = async () => {
    if (!pengirimanCasingStep1Ready) {
      showNotif("error", "Lengkapi data tahap awal Pengiriman Ban ke Pabrik.");
      return;
    }
    if (hasForbiddenNoDokumenCharacter(pengirimanCasing.noDokumen)) {
      showNotif("error", "No. Dokumen tidak boleh mengandung tanda #.");
      return;
    }
    if (!selectedPengirimanCasingRows.length) {
      showNotif("error", "Pilih minimal 1 ban untuk dikirim.");
      return;
    }
    const invalidRepair = selectedPengirimanCasingRows.find(
      (row) => !OPSI_JENIS_REPAIR_PABRIK.includes(String(row?.jenisRepair || "").trim())
    );
    if (invalidRepair) {
      showNotif("error", `Jenis Repair belum valid untuk id_ban ${invalidRepair?.idBan || "-"}.`);
      return;
    }
    if (!attachmentsPengirimanCasing.length) {
      showNotif("error", "Upload Dokumen wajib diisi.");
      return;
    }
    const invalidPengirimanCasingCaptions = collectInvalidCaptionIndexes(attachmentsPengirimanCasing);
    if (invalidPengirimanCasingCaptions.length > 0) {
      setInvalidCaptionIndexesPengirimanCasing(invalidPengirimanCasingCaptions);
      showNotif("error", "Caption dokumen wajib diisi untuk semua lampiran.");
      return;
    }

    setIsSubmittingPengirimanCasing(true);
    try {
      const kodeCabangFinal = String(
        pengirimanCasing.kodeCabang || (!isPusat ? actorKodeCabang : "")
      ).trim();
      if (!kodeCabangFinal) {
        showNotif("error", "Cabang wajib dipilih.");
        return;
      }

      const formData = new FormData();
      formData.append("kode_cabang", kodeCabangFinal);
      formData.append(
        "nomor",
        buildNomorSubmitPlaceholder({
          kodeCabang: kodeCabangFinal,
          prefix: "CASING",
          tanggal: pengirimanCasing.tanggal,
        })
      );
      formData.append("tanggal", String(pengirimanCasing.tanggal || "").trim());
      formData.append("no_dokumen", String(pengirimanCasing.noDokumen || "").trim());
      formData.append("tgl_dokumen", String(pengirimanCasing.tglDokumen || "").trim());
      formData.append("vendor", String(pengirimanCasing.vendor || "").trim());
      formData.append("catatan", String(pengirimanCasing.catatan || "").trim());
      formData.append(
        "detail_ban",
        JSON.stringify(
          selectedPengirimanCasingRows.map((row, idx) => ({
            no: idx + 1,
            id_ban: Number(row?.idBan || 0),
            seri_ban: String(row?.seriBan || "").trim(),
            repair: String(row?.jenisRepair || "").trim(),
          }))
        )
      );
      formData.append("user", actorNama);

      attachmentsPengirimanCasing.forEach((item) => {
        if (item?.file instanceof File) formData.append("files", item.file);
        formData.append("captions", item?.caption || "");
      });
      const existingLampiran = attachmentsPengirimanCasing
        .filter((item) => !(item?.file instanceof File))
        .map((item) => ({
          name: item?.name || "",
          file: item?.db_file || item?.file || "",
          path: item?.path || "",
          type: item?.type || "",
          size: Number(item?.size || 0),
          caption: item?.caption || "",
          uploaded_at: item?.uploaded_at || null,
        }));
      formData.append("existing_lampiran", JSON.stringify(existingLampiran));

      api.cancelPendingRequests({
        group: REQ_GROUP_CASING_SUBMIT,
        reason: "submit pengiriman casing",
      });
      const { data } = await api.post(`${backendPort}/api/main/submit_pengiriman_casing`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        requestGroup: REQ_GROUP_CASING_SUBMIT,
        timeout: 120000,
      });
      showNotif("success", data?.message || "Pengiriman ban ke pabrik berhasil disimpan.");
      handlePilihAction("pengiriman_casing");
      Promise.resolve()
        .then(() => manualResyncGlobalOpsi({ requestGroup: "stok-pengiriman-casing" }))
        .catch((refreshErr) => {
          console.error(refreshErr);
        });
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
      showNotif("error", err?.response?.data?.message || "Gagal menyimpan Pengiriman Ban ke Pabrik.");
    } finally {
      setIsSubmittingPengirimanCasing(false);
    }
  };

  const submitPerintahPemindahanStock = async () => {
    if (isSubmittingPerintahPemindahanStock) return;
    if (!perintahPemindahanStockStep1Ready) {
      showNotif("error", "Lengkapi data tahap awal Perintah Pemindahan Stock.");
      return;
    }
    if (hasForbiddenNoDokumenCharacter(perintahPemindahanStock.noDokumen)) {
      showNotif("error", "No. Dokumen tidak boleh mengandung tanda #.");
      return;
    }
    if (!selectedPerintahPemindahanStockIds.length) {
      showNotif("error", "Pilih minimal 1 ban untuk perintah pemindahan.");
      return;
    }
    if (!attachmentsPerintahPemindahanStock.length) {
      showNotif("error", "Upload Dokumen wajib diisi.");
      return;
    }
    const invalidPerintahPindahCaptions = collectInvalidCaptionIndexes(attachmentsPerintahPemindahanStock);
    if (invalidPerintahPindahCaptions.length > 0) {
      setInvalidCaptionIndexesPerintahPemindahanStock(invalidPerintahPindahCaptions);
      showNotif("error", "Caption dokumen wajib diisi untuk semua lampiran.");
      return;
    }
    if (String(perintahPemindahanStock.kodeCabangPenerima || "").trim() === String(perintahPemindahanStock.kodeCabang || "").trim()) {
      showNotif("error", "Cabang Penerima tidak boleh sama dengan Cabang Pengirim.");
      return;
    }
    setIsSubmittingPerintahPemindahanStock(true);
    try {
      const kodeCabangFinal = String(
        perintahPemindahanStock.kodeCabang || (!isPusat ? actorKodeCabang : "")
      ).trim();
      const kodeCabangPenerimaFinal = String(perintahPemindahanStock.kodeCabangPenerima || "").trim();
      if (!kodeCabangFinal) {
        showNotif("error", "Cabang Pengirim wajib dipilih.");
        return;
      }
      if (!kodeCabangPenerimaFinal) {
        showNotif("error", "Cabang Penerima wajib dipilih.");
        return;
      }
      if (kodeCabangFinal === kodeCabangPenerimaFinal) {
        showNotif("error", "Cabang Penerima tidak boleh sama dengan Cabang Pengirim.");
        return;
      }

      const formData = new FormData();
      formData.append("kode_cabang", kodeCabangFinal);
      formData.append("kode_cabang_penerima", kodeCabangPenerimaFinal);
      formData.append(
        "nomor",
        buildNomorSubmitPlaceholder({
          kodeCabang: kodeCabangFinal,
          prefix: "PINDAH",
          tanggal: perintahPemindahanStock.tanggal,
        })
      );
      formData.append("tanggal", String(perintahPemindahanStock.tanggal || "").trim());
      formData.append("no_dokumen", String(perintahPemindahanStock.noDokumen || "").trim());
      formData.append("tgl_dokumen", String(perintahPemindahanStock.tglDokumen || "").trim());
      formData.append("catatan", String(perintahPemindahanStock.catatan || "").trim());
      formData.append(
        "detail_ban",
        JSON.stringify(
          selectedPerintahPemindahanStockRows.map((row, idx) => ({
            no: idx + 1,
            id_ban: Number(row?.id_ban || row?.idBan || 0),
            seri_ban: String(row?.seri_ban || row?.seriBan || "").trim(),
            status: String(row?.status || "").trim(),
          }))
        )
      );
      formData.append("user", actorNama);

      attachmentsPerintahPemindahanStock.forEach((item) => {
        if (item?.file instanceof File) formData.append("files", item.file);
        formData.append("captions", item?.caption || "");
      });
      const existingLampiran = attachmentsPerintahPemindahanStock
        .filter((item) => !(item?.file instanceof File))
        .map((item) => ({
          name: item?.name || "",
          file: item?.db_file || item?.file || "",
          path: item?.path || "",
          type: item?.type || "",
          size: Number(item?.size || 0),
          caption: item?.caption || "",
          uploaded_at: item?.uploaded_at || null,
        }));
      formData.append("existing_lampiran", JSON.stringify(existingLampiran));

      api.cancelPendingRequests({
        group: REQ_GROUP_PERINTAH_PINDAH_SUBMIT,
        reason: "submit perintah pemindahan stock",
      });
      const { data } = await api.post(`${backendPort}/api/main/submit_perintah_pemindahan_stock`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        requestGroup: REQ_GROUP_PERINTAH_PINDAH_SUBMIT,
        timeout: 120000,
      });
      showNotif("success", data?.message || "Perintah pemindahan stock berhasil disimpan.");
      handlePilihAction("perintah_pemindahan_stock");
      Promise.resolve()
        .then(() => manualResyncGlobalOpsi({ requestGroup: "stok-perintah-pemindahan-stock" }))
        .catch((refreshErr) => {
          console.error(refreshErr);
        });
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
      showNotif("error", err?.response?.data?.message || "Gagal menyimpan Perintah Pemindahan Stock.");
    } finally {
      setIsSubmittingPerintahPemindahanStock(false);
    }
  };

  const submitPengirimanBanKeCabangLain = async (options = {}) => {
    if (isSubmittingPengirimanBanKeCabangLain) return;
    if (!pengirimanBanKeCabangLainStep1Ready) {
      showNotif("error", "Data awal Pengiriman Ban ke Cabang Lain belum lengkap.");
      return;
    }
    const checkedRows = pengirimanBanKeCabangLainRows.filter((x) => Boolean(x?.checked));
    if (!checkedRows.length) {
      showNotif("error", "Pilih minimal 1 baris data ban.");
      return;
    }
    const isPengirimanSebagian = checkedRows.length < pengirimanBanKeCabangLainRows.length;
    if (isPengirimanSebagian && options?.partialConfirmed !== true) {
      setOpenPengirimanSebagianModal(true);
      return;
    }
    if (isPengirimanSebagian && !String(pengirimanBanKeCabangLain.catatan || "").trim()) {
      showNotif("error", "Catatan wajib diisi untuk pengiriman sebagian.");
      requestAnimationFrame(() => catatanPengirimanSebagianRef.current?.focus());
      return;
    }
    const invalidPengirimanCabangLainCaptions = collectInvalidCaptionIndexes(attachmentsPengirimanBanKeCabangLain);
    if (invalidPengirimanCabangLainCaptions.length > 0) {
      setInvalidCaptionIndexesPengirimanBanKeCabangLain(invalidPengirimanCabangLainCaptions);
      showNotif("error", "Caption dokumen wajib diisi untuk semua lampiran.");
      return;
    }
    setIsSubmittingPengirimanBanKeCabangLain(true);
    try {
      const kodeCabangFinal = String(
        pengirimanBanKeCabangLain.kodeCabang || (!isPusat ? actorKodeCabang : "")
      ).trim();
      if (!kodeCabangFinal) {
        showNotif("error", "Cabang Pengirim wajib dipilih.");
        return;
      }
      const resolvedKodeCabangFinal = kodeCabangFinal.toUpperCase() === CABANG_ALL_VALUE
        ? (() => {
            const uniqueCabang = [...new Set(
              checkedRows.map((row) => String(row?.kode_cabang || "").trim()).filter(Boolean)
            )];
            if (uniqueCabang.length !== 1) return "";
            return uniqueCabang[0];
          })()
        : kodeCabangFinal;
      if (!resolvedKodeCabangFinal) {
        showNotif("error", "Mode Semua Cabang membutuhkan data pending dari 1 Cabang Pengirim yang sama.");
        return;
      }
      const formData = new FormData();
      formData.append("kode_cabang", resolvedKodeCabangFinal);
      formData.append("nomor_perintah", String(pengirimanBanKeCabangLain.nomor || "").trim());
      formData.append("tanggal", String(pengirimanBanKeCabangLain.tanggal || "").trim());
      formData.append("catatan", String(pengirimanBanKeCabangLain.catatan || "").trim());
      formData.append("user", actorNama);
      formData.append(
        "selected_rows",
        JSON.stringify(
          checkedRows.map((row) => ({
            id_ban: Number(row?.id_ban || 0),
            seri_ban: String(row?.seri_ban || "").trim(),
          }))
        )
      );
      const lampiranBaru = attachmentsPengirimanBanKeCabangLain.filter((item) => item?.file instanceof File);
      lampiranBaru.forEach((item) => {
        formData.append("files", item.file);
        formData.append("captions", String(item?.caption || "").trim());
      });
      const existingLampiran = attachmentsPengirimanBanKeCabangLain
        .filter((item) => !(item?.file instanceof File))
        .map((item) => ({
          name: String(item?.name || item?.fileName || "").trim(),
          file: String(item?.file || "").trim(),
          path: String(item?.path || "").trim(),
          type: String(item?.type || "").trim(),
          size: Number(item?.size || 0),
          caption: String(item?.caption || "").trim(),
          uploaded_at: item?.uploaded_at || null,
        }));
      formData.append("existing_lampiran", JSON.stringify(existingLampiran));
      api.cancelPendingRequests({
        group: REQ_GROUP_PENGIRIMAN_CABANG_SUBMIT,
        reason: "submit pengiriman ban ke cabang lain",
      });
      const { data } = await api.post(`${backendPort}/api/main/submit_pengiriman_ban_ke_cabang_lain`, formData, {
        requestGroup: REQ_GROUP_PENGIRIMAN_CABANG_SUBMIT,
        timeout: 120000,
      });
      showNotif("success", data?.message || "Pengiriman ban ke cabang lain berhasil disimpan.");
      setAttachmentsPengirimanBanKeCabangLain([]);
      setInvalidCaptionIndexesPengirimanBanKeCabangLain([]);
      setPengirimanBanKeCabangLain((prev) => ({ ...prev, catatan: "" }));
      await loadPengirimanBanKeCabangLainRows({
        kodeCabangInput: kodeCabangFinal,
        nomorInput: "",
      });
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
      showNotif("error", err?.response?.data?.message || "Gagal submit pengiriman ban ke cabang lain.");
    } finally {
      setIsSubmittingPengirimanBanKeCabangLain(false);
    }
  };

  const submitPembelianBaru = async () => {
    if (!pembelianBaruStep1Ready) {
      showNotif("error", "Lengkapi data tahap awal Pembelian Ban Baru.");
      return;
    }
    if (hasForbiddenNoDokumenCharacter(pembelianBaru.noDokumen)) {
      showNotif("error", "No. Dokumen tidak boleh mengandung tanda #.");
      return;
    }
    if (!pembelianBaruRowsComplete) {
      showNotif("error", "Lengkapi tabel profil ban sesuai qty.");
      return;
    }
    if (!attachmentsPembelianBaru.length) {
      showNotif("error", "Upload Dokumen wajib diisi.");
      return;
    }
    const invalidPembelianCaptions = collectInvalidCaptionIndexes(attachmentsPembelianBaru);
    if (invalidPembelianCaptions.length > 0) {
      setInvalidCaptionIndexesPembelianBaru(invalidPembelianCaptions);
      showNotif("error", "Caption dokumen wajib diisi untuk semua lampiran.");
      return;
    }

    setIsSubmittingPembelianBaru(true);
    try {
      const kodeCabangFinal = String(
        pembelianBaru.kodeCabang || (!isPusat ? actorKodeCabang : "")
      ).trim();
      if (!kodeCabangFinal) {
        showNotif("error", "Cabang Penerima wajib dipilih.");
        return;
      }
      const formData = new FormData();
      formData.append("kode_cabang", kodeCabangFinal);
      formData.append(
        "nomor",
        buildNomorSubmitPlaceholder({
          kodeCabang: kodeCabangFinal,
          prefix: "BUY",
          tanggal: pembelianBaru.tanggal,
        })
      );
      formData.append("tanggal", String(pembelianBaru.tanggal || "").trim());
      formData.append("no_dokumen", String(pembelianBaru.noDokumen || "").trim());
      formData.append("tgl_dokumen", String(pembelianBaru.tglDokumen || "").trim());
      formData.append("qty", String(Number(pembelianBaru.qty || 0)));
      formData.append("vendor", "PUSAT");
      formData.append("catatan", String(pembelianBaru.catatan || "").trim());
      formData.append(
        "detail_ban",
        JSON.stringify(
          pembelianBaruRows.map((row, idx) => ({
            no: idx + 1,
            seri_ban: String(row.seriBan || "").trim(),
            status: String(row.status || "").trim(),
            merk: String(row.merk || "").trim(),
            ukuran: String(row.ukuran || "").trim(),
            td: String(row.td || "").trim(),
            kode_cabang_penerima: String(row.kodeCabangPenerima || "").trim(),
            suplier: String(row.suplier || "").trim(),
            harga: 0,
          }))
        )
      );
      formData.append("user", actorNama);

      attachmentsPembelianBaru.forEach((item) => {
        if (item?.file instanceof File) formData.append("files", item.file);
        formData.append("captions", item?.caption || "");
      });
      const existingLampiran = attachmentsPembelianBaru
        .filter((item) => !(item?.file instanceof File))
        .map((item) => ({
          name: item?.name || "",
          file: item?.db_file || item?.file || "",
          path: item?.path || "",
          type: item?.type || "",
          size: Number(item?.size || 0),
          caption: item?.caption || "",
          uploaded_at: item?.uploaded_at || null,
        }));
      formData.append("existing_lampiran", JSON.stringify(existingLampiran));

      api.cancelPendingRequests({
        group: REQ_GROUP_PEMBELIAN_SUBMIT,
        reason: "submit pembelian baru",
      });
      const { data } = await api.post(`${backendPort}/api/main/submit_pembelian_ban`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        requestGroup: REQ_GROUP_PEMBELIAN_SUBMIT,
        timeout: 120000,
      });
      showNotif("success", data?.message || "Pembelian ban berhasil disimpan.");
      try {
        await manualResyncGlobalOpsi({ requestGroup: "stok-pembelian-ban" });
      } catch (refreshErr) {
        console.error(refreshErr);
      }
      handlePilihAction("pembelian_baru");
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
      showNotif("error", err?.response?.data?.message || "Gagal memproses Pembelian Ban Baru.");
    } finally {
      setIsSubmittingPembelianBaru(false);
    }
  };

  const resolveLampiranUrl = (item) => {
    if (typeof item === "string") {
      const raw = String(item || "").trim();
      if (!raw) return "";
      if (raw.startsWith("http")) return raw;
      if (raw.startsWith("/")) return `${backendPort}${raw}`;
      return `${backendPort}/uploads/dokumen/${raw}`;
    }
    const rawPath = String(item?.path || item?.url || "").trim();
    if (rawPath) {
      return String(rawPath).startsWith("http") ? rawPath : `${backendPort}${rawPath}`;
    }
    const rawFile = String(item?.file || item?.db_file || "").trim();
    if (rawFile && rawFile !== "[object Object]") {
      return String(rawFile).startsWith("http") ? rawFile : `${backendPort}/uploads/dokumen/${rawFile}`;
    }
    return "";
  };

  const countValidLampiran = (list) =>
    (Array.isArray(list) ? list : [])
      .map((item) => resolveLampiranUrl(item))
      .filter(Boolean)
      .length;

  const openLampiran = (row) => {
    const listLampiran = Array.isArray(row?.lampiran) ? row.lampiran : [];
    const files = listLampiran
      .map((item, idx) => ({
        url: resolveLampiranUrl(item),
        caption: (typeof item === "string" ? "" : (item?.caption || item?.name)) || `Lampiran ${idx + 1}`,
        name: (typeof item === "string" ? String(item || "").split("/").pop() : item?.name) || `Lampiran ${idx + 1}`,
        note: `${row?.nomor || ""} - ${((typeof item === "string" ? "" : (item?.caption || item?.name)) || `Lampiran ${idx + 1}`)}`.trim(),
      }))
      .filter((item) => Boolean(item?.url));
    if (!files.length) return;
    setSelectedLampiranFiles(files);
    setOpenLampiranModal(true);
  };

  const openLampiranPersetujuan = (item, idx = 0) => {
    const isStringItem = typeof item === "string";
    const rawString = isStringItem ? String(item || "").trim() : "";
    const rawPath = isStringItem ? rawString : String(item?.path || item?.url || "").trim();
    const rawFile = isStringItem ? "" : String(item?.file || item?.db_file || "").trim();
    const fileUrl = rawPath
      ? (String(rawPath).startsWith("http") ? rawPath : (String(rawPath).startsWith("/") ? `${backendPort}${rawPath}` : `${backendPort}/uploads/dokumen/${rawPath}`))
      : (rawFile ? (String(rawFile).startsWith("http") ? rawFile : `${backendPort}/uploads/dokumen/${rawFile}`) : "");
    if (!fileUrl) return;
    const fileName = (isStringItem ? rawString.split("/").pop() : String(item?.name || "").trim()) || `Lampiran ${idx + 1}`;
    const caption = (isStringItem ? "" : String(item?.caption || "").trim()) || fileName;
    const fileObj = {
      url: fileUrl,
      caption,
      name: fileName,
      note: `${persetujuanUbahStatusDetailMeta?.nomor || ""} - ${caption}`.trim(),
    };
    setSelectedLampiranFiles([fileObj]);
    setOpenLampiranModal(true);
  };

  const loadKonfirmasiTerima = async (kodeCabangInput = "") => {
    const rawKodeCabang = String(kodeCabangInput || "").trim();
    const kodeCabang = rawKodeCabang.toUpperCase() === CABANG_ALL_VALUE ? "" : rawKodeCabang;
    try {
      setLoadingKonfirmasiTerima(true);
      api.cancelPendingRequests({
        group: REQ_GROUP_KONFIRMASI_TERIMA_LIST,
        reason: "refresh konfirmasi terima list",
      });
      const { data } = await api.post(`${backendPort}/api/main/load_konfirmasi_terima_ban_list`, {
        kodeCabang,
      }, {
        requestGroup: REQ_GROUP_KONFIRMASI_TERIMA_LIST,
        timeout: 120000,
      });
      const mapped = (Array.isArray(data) ? data : []).map((row) => {
        const reffObj = parseJsonObject(row?.reff, {});
        const dokumenRaw = String(reffObj?.dokumen ?? reffObj?.documen ?? "").trim();
        const dokumenParts = dokumenRaw.split("#");
        const pengirim = String(row?.pengirim || "").trim();
        const pengirimHasMore = Number(row?.pengirim_has_more || 0) === 1;
        return {
          id: Number(row?.id || 0),
          nomor: String(row?.nomor || "").trim(),
          tanggalMemo: String(row?.tanggal || "").trim(),
          kodeCabang: String(row?.kode_cabang || "").trim(),
          noDokumen: String(dokumenParts?.[0] || "").trim(),
          tglDokumen: String(dokumenParts?.[1] || "").trim(),
          qty: Number(row?.qty || 0),
          qtyPending: Number(row?.qty_pending || 0),
          pengirim,
          pengirimHasMore,
          lampiran: parseLampiranArray(row?.lampiran),
        };
      });
      setKonfirmasiTerimaRows(mapped);
      setSelectedKonfirmasiRowId(0);
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
      showNotif("error", err?.response?.data?.message || "Gagal memuat data konfirmasi terima ban.");
      setKonfirmasiTerimaRows([]);
      setSelectedKonfirmasiRowId(0);
    } finally {
      setLoadingKonfirmasiTerima(false);
    }
  };

  const loadPengirimanBanKeCabangLainRows = async ({ kodeCabangInput = "", nomorInput = "" } = {}) => {
    const kodeCabang = String(kodeCabangInput || "").trim();
    if (!kodeCabang) {
      setPengirimanBanKeCabangLainRows([]);
      setPendingNomorPengirimanBanKeCabangLainOptions([]);
      setAttachmentsPengirimanBanKeCabangLainReadOnly([]);
      setPengirimanBanKeCabangLain((prev) => ({ ...prev, nomor: "", tanggal: "", catatanPusat: "" }));
      return;
    }
    try {
      setLoadingPengirimanBanKeCabangLainRows(true);
      const { data } = await api.post(`${backendPort}/api/main/load_pengiriman_ban_ke_cabang_lain_pending`, {
        kodeCabang,
        nomor: String(nomorInput || "").trim(),
      }, { timeout: 30000 });
      const options = Array.isArray(data?.options) ? data.options : [];
      const selectedValid = Boolean(data?.selected_valid);
      const selectedNomor = String(data?.selected_nomor || "").trim();
      const record = data?.record || null;
      const rowData = Array.isArray(data?.rows) ? data.rows : [];
      setPendingNomorPengirimanBanKeCabangLainOptions(options);

      if (!selectedValid || !selectedNomor || !record) {
        setPengirimanBanKeCabangLainRows([]);
        setAttachmentsPengirimanBanKeCabangLainReadOnly([]);
        setPengirimanBanKeCabangLain((prev) => ({
          ...prev,
          nomor: selectedNomor,
          tanggal: "",
          catatanPusat: "",
        }));
        return;
      }

      const flatRows = rowData.map((item) => ({
        recordId: Number(record?.id || 0),
        nomor: String(record?.nomor || selectedNomor).trim(),
        nomor_dokumen: String(item?.dokumen || "").trim().replace(/#/g, " tgl "),
        id_ban: Number(item?.id_ban || 0),
        seri_ban: String(item?.seri_ban || "").trim(),
        status: String(item?.status || "").trim(),
        kode_cabang: String(item?.kode_cabang || "").trim(),
        cabang_penerima: resolveNamaCabang(item?.kode_cabang_penerima, item?.kode_cabang_penerima || "-"),
        catatan_pusat: String(item?.catatan_pusat || "").trim(),
        checked: false,
      })).filter((x) => Number(x?.id_ban || 0) > 0);
      const lampiran = parseLampiranArray(record?.lampiran);
      const catatanPusat = String(record?.catatan_pusat || "").trim();
      setPengirimanBanKeCabangLainRows(flatRows);
      setAttachmentsPengirimanBanKeCabangLainReadOnly(lampiran);
      setPengirimanBanKeCabangLain((prev) => ({
        ...prev,
        nomor: selectedNomor,
        tanggal: String(record?.tanggal || "").slice(0, 10),
        catatanPusat,
      }));
    } catch (err) {
      console.error(err);
      setPengirimanBanKeCabangLainRows([]);
      setPendingNomorPengirimanBanKeCabangLainOptions([]);
      setAttachmentsPengirimanBanKeCabangLainReadOnly([]);
      showNotif("error", err?.response?.data?.message || "Gagal memuat data Pengiriman Ban ke Cabang Lain.");
    } finally {
      setLoadingPengirimanBanKeCabangLainRows(false);
    }
  };

  const toggleCheckedPengirimanBanKeCabangLain = (index, checked) => {
    setPengirimanBanKeCabangLainRows((prev) => prev.map((row, idx) => (
      idx === index ? { ...row, checked: Boolean(checked) } : row
    )));
  };
  const toggleAllCheckedPengirimanBanKeCabangLain = (checked) => {
    setPengirimanBanKeCabangLainRows((prev) => prev.map((row) => ({ ...row, checked: Boolean(checked) })));
  };
  const askDeletePengirimanMutasiRow = (row) => {
    const idBan = Number(row?.id_ban || 0);
    const nomor = String(row?.nomor || pengirimanBanKeCabangLain.nomor || "").trim();
    if (!idBan || !nomor) {
      showNotif("error", "Data baris tidak valid untuk dihapus.");
      return;
    }
    setDeletePengirimanMutasiTarget({
      id_ban: idBan,
      seri_ban: String(row?.seri_ban || "").trim(),
      nomor,
    });
    setOpenDeletePengirimanMutasiModal(true);
  };
  const handleConfirmDeletePengirimanMutasiRow = async () => {
    if (isDeletingPengirimanMutasi) return;
    const idBan = Number(deletePengirimanMutasiTarget?.id_ban || 0);
    const nomor = String(deletePengirimanMutasiTarget?.nomor || "").trim();
    if (!idBan || !nomor) return;
    setIsDeletingPengirimanMutasi(true);
    try {
      api.cancelPendingRequests({
        group: REQ_GROUP_PENGIRIMAN_CABANG_DELETE,
        reason: "hapus item perintah mutasi ban",
      });
      const { data } = await api.post(`${backendPort}/api/main/delete_perintah_mutasi_ban_item`, {
        id_ban: idBan,
        nomor,
      }, {
        requestGroup: REQ_GROUP_PENGIRIMAN_CABANG_DELETE,
        timeout: 30000,
      });
      showNotif("success", data?.message || "Perintah mutasi ban berhasil dihapus.");
      setOpenDeletePengirimanMutasiModal(false);
      setDeletePengirimanMutasiTarget({ id_ban: 0, seri_ban: "", nomor: "" });
      await loadPengirimanBanKeCabangLainRows({
        kodeCabangInput: pengirimanBanKeCabangLain.kodeCabang || (!isPusat ? actorKodeCabang : ""),
        nomorInput: pengirimanBanKeCabangLain.nomor,
      });
    } catch (err) {
      if (api.isCanceledError(err)) return;
      showNotif("error", err?.response?.data?.message || "Gagal menghapus perintah mutasi ban.");
    } finally {
      setIsDeletingPengirimanMutasi(false);
    }
  };

  const loadPersetujuanUbahStatus = async (kodeCabangInput = "") => {
    const kodeCabang = String(kodeCabangInput || "").trim();
    try {
      setLoadingPersetujuanUbahStatus(true);
      api.cancelPendingRequests({
        group: REQ_GROUP_PERSETUJUAN_STATUS_LIST,
        reason: "refresh persetujuan ubah status list",
      });
      const { data } = await api.post(`${backendPort}/api/main/load_persetujuan_ubah_status_list`, {
        kodeCabang,
      }, {
        requestGroup: REQ_GROUP_PERSETUJUAN_STATUS_LIST,
        timeout: 120000,
      });
      const mapped = (Array.isArray(data) ? data : []).map((row) => {
        const eventRaw = String(row?.jenis || "").trim();
        return {
          id: Number(row?.id || 0),
          nomor: String(row?.nomor || "").trim(),
          tanggal: row?.tanggal || null,
          kodeCabang: String(row?.kode_cabang || "").trim(),
          cabangPengusul: resolveNamaCabang(row?.kode_cabang, row?.nama_cabang || row?.kode_cabang || "-"),
          event: eventRaw.replace(/^usul_?/i, "usul ").replace(/_/g, " ").trim(),
          jenisRaw: eventRaw,
          qty: Number(row?.qty || 0),
        };
      });
      setPersetujuanUbahStatusRows(mapped);
      setSelectedPersetujuanUbahStatusRowId(0);
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
      showNotif("error", err?.response?.data?.message || "Gagal memuat data persetujuan ubah status.");
      setPersetujuanUbahStatusRows([]);
      setSelectedPersetujuanUbahStatusRowId(0);
    } finally {
      setLoadingPersetujuanUbahStatus(false);
    }
  };

  useEffect(() => {
    if (activeAction !== "konfirmasi_terima_ban") return;
    const kodeCabangPilihan = String(konfirmasiTerimaBan.kodeCabang || "").trim();
    if (isPusat && !kodeCabangPilihan) {
      setKonfirmasiTerimaRows([]);
      setSelectedKonfirmasiRowId(0);
      return;
    }
    const kodeCabangEfektif = String(
      kodeCabangPilihan || (!isPusat ? actorKodeCabang : "")
    ).trim();
    if (!kodeCabangEfektif) {
      setKonfirmasiTerimaRows([]);
      setSelectedKonfirmasiRowId(0);
      return;
    }
    loadKonfirmasiTerima(kodeCabangEfektif);
  }, [activeAction, konfirmasiTerimaBan.kodeCabang, isPusat, actorKodeCabang, resendToken]);

  useEffect(() => {
    if (activeAction !== "persetujuan_ubah_status") return;
    const kodeCabangEfektif = String(
      persetujuanUbahStatus.kodeCabang || (!isPusat ? actorKodeCabang : "")
    ).trim();
    loadPersetujuanUbahStatus(kodeCabangEfektif);
  }, [activeAction, persetujuanUbahStatus.kodeCabang, isPusat, actorKodeCabang, resendToken]);

  useEffect(() => {
    if (activeAction !== "pengiriman_ban_ke_cabang_lain") return;
    const kodeCabangEfektif = String(
      pengirimanBanKeCabangLain.kodeCabang || (!isPusat ? actorKodeCabang : "")
    ).trim();
    loadPengirimanBanKeCabangLainRows({
      kodeCabangInput: kodeCabangEfektif,
      nomorInput: pengirimanBanKeCabangLain.nomor,
    });
  }, [activeAction, pengirimanBanKeCabangLain.kodeCabang, pengirimanBanKeCabangLain.nomor, isPusat, actorKodeCabang, resendToken]);

  const loadDetailKonfirmasiTerima = async ({ recordId, openModal = true, suppressErrorToast = false } = {}) => {
    const targetRecordId = Number(recordId || selectedKonfirmasiRowId || 0);
    if (!targetRecordId) return;
    try {
      setLoadingDetailKonfirmasi(true);
      api.cancelPendingRequests({
        group: REQ_GROUP_KONFIRMASI_TERIMA_DETAIL,
        reason: "refresh konfirmasi terima detail",
      });
      const { data } = await api.post(`${backendPort}/api/main/load_konfirmasi_terima_ban_detail`, {
        recordId: targetRecordId,
      }, {
        requestGroup: REQ_GROUP_KONFIRMASI_TERIMA_DETAIL,
        timeout: 120000,
      });
      const mappedRows = (Array.isArray(data?.rows) ? data.rows : []).map((item) => ({
        id_ban: Number(item?.id_ban || 0),
        seri_ban: String(item?.seri_ban || "").trim(),
        seri_input: String(item?.seri_ban || "").trim(),
        catatan_perubahan: "",
        catatan_penerima: String(item?.catatan_penerima || "").trim(),
        kode_cabang: String(item?.kode_cabang || "").trim(),
        kode_cabang_penerima_mutasi: String(item?.kode_cabang_penerima_mutasi || "").trim(),
        nama_cabang: resolveNamaCabang(item?.kode_cabang, item?.nama_cabang),
        ukuran: String(item?.ukuran || "").trim(),
        status: String(item?.status || "").trim(),
        merk: String(item?.merk || "").trim(),
	        suplier: String(item?.suplier || "").trim(),
	        place: String(item?.place || "").trim(),
	        td: String(item?.td || "").trim(),
	        is_confirmed: Number(item?.is_confirmed || 0) === 1,
	      }));
      setDetailKonfirmasiRows(mappedRows);
      setDetailKonfirmasiMeta({
        nomor: String(data?.record?.nomor || "").trim(),
        tanggal: String(data?.record?.tanggal || "").trim(),
        kode_cabang: String(data?.record?.kode_cabang || "").trim(),
        jenis: String(data?.record?.jenis || "").trim(),
      });
      setCheckedDetailBanIds([]);
      const lampiranExisting = parseLampiranArray(data?.record?.lampiran).map((item) => {
        if (typeof item === "string") {
          const raw = String(item || "").trim();
          return {
            name: raw.split("/").pop() || raw,
            file: raw.startsWith("/") ? "" : raw,
            path: raw.startsWith("/") || raw.startsWith("http") ? raw : "",
            type: "",
            size: 0,
            caption: "",
            uploaded_at: null,
          };
        }
        return {
          name: String(item?.name || "").trim(),
          file: String(item?.file || "").trim(),
          path: String(item?.path || "").trim(),
          type: String(item?.type || "").trim(),
          size: Number(item?.size || 0),
          caption: String(item?.caption || "").trim(),
          uploaded_at: item?.uploaded_at || null,
        };
      }).filter((item) => Boolean(resolveLampiranUrl(item)));
      setAttachmentsKonfirmasiTerima(lampiranExisting);
      setInvalidCaptionIndexesKonfirmasiTerima([]);
      setNamaUserTerimaBan(String(actorNama));
      setOpenEditBanTerimaModal(false);
      setOpenDeleteBanTerimaConfirmModal(false);
      if (openModal) setOpenModalDaftarBanDiterima(true);
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
      if (!suppressErrorToast) {
        showNotif("error", err?.response?.data?.message || "Gagal memuat daftar ban yang diterima.");
      }
    } finally {
      setLoadingDetailKonfirmasi(false);
    }
  };

  const handleLihatKonfirmasiTerima = async () => {
    if (!selectedKonfirmasiRowId) {
      showNotif("error", "Pilih satu baris data terlebih dahulu.");
      return;
    }
    await loadDetailKonfirmasiTerima({ recordId: selectedKonfirmasiRowId, openModal: true });
  };

  useEffect(() => {
    const reloadDetailKonfirmasiOnResend = async () => {
      if (!resendToken) return;
      if (activeAction !== "konfirmasi_terima_ban") return;
      if (!openModalDaftarBanDiterima) return;
      if (!selectedKonfirmasiRowId) return;
      await loadDetailKonfirmasiTerima({
        recordId: selectedKonfirmasiRowId,
        openModal: false,
        suppressErrorToast: true,
      });
    };
    reloadDetailKonfirmasiOnResend();
  }, [
    resendToken,
    activeAction,
    openModalDaftarBanDiterima,
    selectedKonfirmasiRowId,
  ]);

  const updateKonfirmasiRowRadio = (rowId) => {
    setSelectedKonfirmasiRowId(Number(rowId || 0));
  };

  const updatePersetujuanUbahStatusRowRadio = (rowId) => {
    setSelectedPersetujuanUbahStatusRowId(Number(rowId || 0));
  };


  const loadDetailPersetujuanUbahStatus = async ({
    recordId,
    openModal = true,
    suppressErrorToast = false,
  } = {}) => {
    const targetRecordId = Number(recordId || selectedPersetujuanUbahStatusRowId || 0);
    if (!targetRecordId) return;
    try {
      setLoadingDetailPersetujuanUbahStatus(true);
      api.cancelPendingRequests({
        group: REQ_GROUP_PERSETUJUAN_STATUS_DETAIL,
        reason: "refresh persetujuan ubah status detail",
      });
      const { data } = await api.post(`${backendPort}/api/main/load_persetujuan_ubah_status_detail`, {
        recordId: targetRecordId,
      }, {
        requestGroup: REQ_GROUP_PERSETUJUAN_STATUS_DETAIL,
        timeout: 120000,
      });
      const rows = (Array.isArray(data?.rows) ? data.rows : []).map((row) => ({
        id_ban: Number(row?.id_ban || 0),
        seri_ban: String(row?.seri_ban || "").trim(),
        merk: String(row?.merk || "").trim(),
        ukuran: String(row?.ukuran || "").trim(),
        statusSaatIni: String(row?.status_saat_ini || "").trim(),
        statusUsulan: String(row?.status_usulan || "").trim(),
        catatanCabang: String(row?.catatan_cabang || "").trim(),
        place: String(row?.place || "").trim(),
      }));
      setPersetujuanUbahStatusDetailRows(rows);
      setPersetujuanUbahStatusDetailMeta({
        id: Number(data?.record?.id || targetRecordId || 0),
        nomor: String(data?.record?.nomor || "").trim(),
        tanggal: String(data?.record?.tanggal || "").trim(),
        kode_cabang: String(data?.record?.kode_cabang || "").trim(),
        nama_cabang: resolveNamaCabang(data?.record?.kode_cabang, data?.record?.nama_cabang || data?.record?.kode_cabang),
        catatan: String(data?.record?.catatan || "").trim(),
        lampiran: parseLampiranArray(data?.record?.lampiran),
      });
      const defaultKeputusan = {};
      const defaultCatatanApproval = {};
      rows.forEach((row) => {
        const id = Number(row?.id_ban || 0);
        if (!id) return;
        defaultKeputusan[id] = "approved";
        defaultCatatanApproval[id] = "";
      });
      setKeputusanPersetujuanByBanId(defaultKeputusan);
      setCatatanApprovalByBanId(defaultCatatanApproval);
      if (openModal) setOpenPersetujuanUbahStatusModal(true);
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
      if (!suppressErrorToast) {
        showNotif("error", err?.response?.data?.message || "Gagal memuat detail persetujuan memo.");
      }
    } finally {
      setLoadingDetailPersetujuanUbahStatus(false);
    }
  };

  const handleLihatPersetujuanUbahStatus = async () => {
    if (!selectedPersetujuanUbahStatusRowId) {
      showNotif("error", "Pilih satu baris data terlebih dahulu.");
      return;
    }
    const row = persetujuanUbahStatusRows.find(
      (x) => Number(x?.id || 0) === Number(selectedPersetujuanUbahStatusRowId)
    );
    if (!row) {
      showNotif("error", "Data usulan tidak ditemukan.");
      return;
    }
    await loadDetailPersetujuanUbahStatus({ recordId: row.id, openModal: true });
  };

  const updateKeputusanPersetujuanBan = (idBan, keputusan) => {
    const id = Number(idBan || 0);
    if (!id) return;
    const val = String(keputusan || "").trim().toLowerCase();
    if (val !== "approved" && val !== "reject") return;
    setKeputusanPersetujuanByBanId((prev) => ({
      ...prev,
      [id]: val,
    }));
  };
  const updateCatatanApprovalPersetujuanBan = (idBan, value) => {
    const id = Number(idBan || 0);
    if (!id) return;
    setCatatanApprovalByBanId((prev) => ({
      ...prev,
      [id]: String(value || ""),
    }));
  };

  const canSubmitPersetujuanUbahStatus = useMemo(() => {
    if (isSubmittingPersetujuanUbahStatus || loadingDetailPersetujuanUbahStatus) return false;
    if (!persetujuanUbahStatusDetailRows.length) return false;
    return persetujuanUbahStatusDetailRows.every((row) => {
      const id = Number(row?.id_ban || 0);
      const keputusan = String(keputusanPersetujuanByBanId[id] || "").trim().toLowerCase();
      return keputusan === "approved" || keputusan === "reject";
    });
  }, [
    isSubmittingPersetujuanUbahStatus,
    loadingDetailPersetujuanUbahStatus,
    persetujuanUbahStatusDetailRows,
    keputusanPersetujuanByBanId,
  ]);

  const handleSubmitPersetujuanUbahStatus = async () => {
    if (!canSubmitPersetujuanUbahStatus) {
      showNotif("error", "Lengkapi keputusan approval/reject pada semua baris ban.");
      return;
    }
    const recordId = Number(
      persetujuanUbahStatusDetailMeta?.id
      || selectedPersetujuanUbahStatusRowId
      || 0
    );
    if (!recordId) {
      showNotif("error", "Record memo approval tidak valid.");
      return;
    }
    const keputusanPayload = persetujuanUbahStatusDetailRows.map((row) => {
      const id = Number(row?.id_ban || 0);
      return {
        id_ban: id,
        keputusan: String(keputusanPersetujuanByBanId[id] || "").trim().toLowerCase(),
        catatan_approval: String(catatanApprovalByBanId[id] || "").trim(),
      };
    }).filter((x) => Number.isFinite(x.id_ban) && x.id_ban > 0);

    try {
      setIsSubmittingPersetujuanUbahStatus(true);
      api.cancelPendingRequests({
        group: REQ_GROUP_PERSETUJUAN_STATUS_SUBMIT,
        reason: "submit persetujuan ubah status",
      });
      const { data } = await api.post(`${backendPort}/api/main/submit_persetujuan_ubah_status`, {
        recordId,
        keputusan: keputusanPayload,
        user: actorNama,
      }, {
        requestGroup: REQ_GROUP_PERSETUJUAN_STATUS_SUBMIT,
        timeout: 120000,
      });
      showNotif("success", data?.message || "Persetujuan memo usulan berhasil disimpan.");
      setOpenPersetujuanUbahStatusModal(false);
      setPersetujuanUbahStatusDetailRows([]);
      setSelectedPersetujuanUbahStatusRowId(0);
      setKeputusanPersetujuanByBanId({});
      setCatatanApprovalByBanId({});
      const kodeCabangEfektif = String(
        persetujuanUbahStatus.kodeCabang || (!isPusat ? actorKodeCabang : "")
      ).trim();
      await loadPersetujuanUbahStatus(kodeCabangEfektif);
      try {
        await manualResyncGlobalOpsi({ requestGroup: "stok-persetujuan-ubah-status" });
      } catch (refreshErr) {
        console.error(refreshErr);
      }
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
      showNotif("error", err?.response?.data?.message || "Gagal submit persetujuan usulan.");
    } finally {
      setIsSubmittingPersetujuanUbahStatus(false);
    }
  };

  useEffect(() => {
    const reloadDetailPersetujuanOnResend = async () => {
      if (!resendToken) return;
      if (activeAction !== "persetujuan_ubah_status") return;
      if (!openPersetujuanUbahStatusModal) return;
      if (!selectedPersetujuanUbahStatusRowId) return;
      await loadDetailPersetujuanUbahStatus({
        recordId: selectedPersetujuanUbahStatusRowId,
        openModal: false,
        suppressErrorToast: true,
      });
    };
    reloadDetailPersetujuanOnResend();
  }, [
    resendToken,
    activeAction,
    openPersetujuanUbahStatusModal,
    selectedPersetujuanUbahStatusRowId,
  ]);

  const isDetailBanSelectable = (row) => {
    if (Number(row?.is_confirmed || 0) === 1 || row?.is_confirmed === true) {
      return false;
    }
    const seriAktif = String(row?.seri_input || row?.seri_ban || "").trim().toUpperCase();
    const seriValid = !seriAktif.startsWith("BUY#");
    return seriValid && isTdValueValid(row?.td);
  };

  const getDetailBanSelectError = (row) => {
    if (Number(row?.is_confirmed || 0) === 1 || row?.is_confirmed === true) {
      return "Baris tidak bisa dipilih karena sudah dikonfirmasi.";
    }
    const seriAktif = String(row?.seri_input || row?.seri_ban || "").trim().toUpperCase();
    if (seriAktif.startsWith("BUY#")) return "Baris tidak bisa dipilih karena No Seri belum valid.";
    if (!isTdValueValid(row?.td)) return "Baris tidak bisa dipilih karena TD belum valid.";
    return "Baris tidak lolos validasi pemilihan.";
  };

  const selectableDetailBanIds = useMemo(
    () =>
      detailKonfirmasiRows
        .filter((row) => isDetailBanSelectable(row))
        .map((row) => Number(row?.id_ban || 0))
        .filter((id) => Number.isFinite(id) && id > 0),
    [detailKonfirmasiRows]
  );

  const isAllSelectableDetailChecked = useMemo(() => {
    if (!selectableDetailBanIds.length) return false;
    const checkedSet = new Set(checkedDetailBanIds.map((x) => Number(x)));
    return selectableDetailBanIds.every((id) => checkedSet.has(id));
  }, [selectableDetailBanIds, checkedDetailBanIds]);

  useEffect(() => {
    const allowed = new Set(selectableDetailBanIds);
    setCheckedDetailBanIds((prev) => prev.filter((id) => allowed.has(Number(id))));
  }, [selectableDetailBanIds]);

  const toggleDetailBanChecked = (idBan, checked) => {
    const id = Number(idBan || 0);
    if (!id) return;
    setCheckedDetailBanIds((prev) => {
      const set = new Set(prev.map((x) => Number(x)));
      if (checked) set.add(id);
      else set.delete(id);
      return Array.from(set);
    });
  };

  const handleToggleDetailBanSelect = (row, checked) => {
    if (checked && !isDetailBanSelectable(row)) {
      showNotif("error", getDetailBanSelectError(row));
      return;
    }
    toggleDetailBanChecked(row?.id_ban, checked);
  };

  const handleToggleAllDetailBanSelect = (checked) => {
    if (checked) {
      if (!selectableDetailBanIds.length) {
        showNotif("error", "0 baris valid untuk dipilih.");
        return;
      }
      setCheckedDetailBanIds(selectableDetailBanIds);
      showNotif("success", `${selectableDetailBanIds.length} baris data dipilih.`);
      return;
    }
    const selectableSet = new Set(selectableDetailBanIds);
    setCheckedDetailBanIds((prev) => prev.filter((id) => !selectableSet.has(Number(id))));
    showNotif("info", "0 baris data dipilih.");
  };

  const updateDetailSeriBan = (idBan, value) => {
    const targetId = Number(idBan || 0);
    setDetailKonfirmasiRows((prev) =>
      prev.map((row) => {
        if (Number(row.id_ban) !== targetId) return row;
        const canEdit = String(row.seri_ban || "").toUpperCase().startsWith("BUY#");
        if (!canEdit) return row;
        return { ...row, seri_input: String(value || "").trimStart() };
      })
    );
  };
  const updateDetailTdBan = (idBan, value) => {
    const targetId = Number(idBan || 0);
    setDetailKonfirmasiRows((prev) =>
      prev.map((row) => {
        if (Number(row.id_ban) !== targetId) return row;
        if (Number(row?.is_confirmed || 0) === 1 || row?.is_confirmed === true) return row;
        return { ...row, td: String(value || "").trimStart() };
      })
    );
  };

  const updateDetailCatatanPenerima = (idBan, value) => {
    const targetId = Number(idBan || 0);
    setDetailKonfirmasiRows((prev) =>
      prev.map((row) => {
        if (Number(row.id_ban) !== targetId) return row;
        return { ...row, catatan_penerima: String(value || "").trimStart() };
      })
    );
  };

  const openActionEditBanTerima = (row) => {
    const idBan = Number(row?.id_ban || 0);
    if (!idBan) return;
    const seriAktif = String(row?.seri_input || row?.seri_ban || "").trim();
    setEditBanTerimaDraft({
      id_ban: idBan,
      seri_lama: String(row?.seri_ban || "").trim(),
      seri_baru: seriAktif,
      catatan_perubahan: String(row?.catatan_perubahan || "").trim(),
    });
    setOpenEditBanTerimaModal(true);
  };

  const scheduleEditBanTerimaField = (field, value) => {
    const isSeriField = field === "seri_baru";
    const timerKey = isSeriField ? "seri" : "catatan";
    if (editBanTerimaDebounceRef.current[timerKey]) {
      clearTimeout(editBanTerimaDebounceRef.current[timerKey]);
    }
    editBanTerimaDebounceRef.current[timerKey] = setTimeout(() => {
      setEditBanTerimaDraft((prev) => ({ ...prev, [field]: value }));
    }, 500);
  };

  const getEditBanTerimaLiveValues = () => {
    const seriLive = String(editBanTerimaSeriInputRef.current?.value || editBanTerimaDraft?.seri_baru || "").trim();
    const catatanLive = String(editBanTerimaCatatanInputRef.current?.value || editBanTerimaDraft?.catatan_perubahan || "").trim();
    return {
      seriBaru: seriLive,
      catatan: catatanLive,
    };
  };

  const canSaveEditBanTerima = useMemo(() => {
    const seriLama = String(editBanTerimaDraft?.seri_lama || "").trim();
    const seriBaru = String(editBanTerimaDraft?.seri_baru || "").trim();
    const catatan = String(editBanTerimaDraft?.catatan_perubahan || "").trim();
    return seriBaru !== "" && seriBaru !== seriLama && catatan !== "";
  }, [editBanTerimaDraft]);

  const handleSaveEditBanTerima = async () => {
    const { seriBaru, catatan } = getEditBanTerimaLiveValues();
    const seriLama = String(editBanTerimaDraft?.seri_lama || "").trim();
    if (!seriBaru || seriBaru === seriLama || !catatan) {
      showNotif("error", "Catatan perubahan seri/penghapusan ban wajib diisi");
      return;
    }
    const targetId = Number(editBanTerimaDraft?.id_ban || 0);
    if (!targetId || !selectedKonfirmasiRowId) return;
    setEditBanTerimaDraft((prev) => ({ ...prev, seri_baru: seriBaru, catatan_perubahan: catatan }));
    // Tutup modal aksi langsung setelah klik.
    setOpenDeleteBanTerimaConfirmModal(false);
    setOpenEditBanTerimaModal(false);
    // Optimistic update agar modal induk langsung terasa berubah.
    setDetailKonfirmasiRows((prev) =>
      prev.map((row) => (
        Number(row?.id_ban || 0) === targetId
          ? { ...row, seri_input: seriBaru, catatan_perubahan: catatan }
          : row
      ))
    );
    try {
      api.cancelPendingRequests({
        group: REQ_GROUP_KONFIRMASI_AKSI,
        reason: "aksi edit konfirmasi",
      });
      await api.post(`${backendPort}/api/main/aksi_konfirmasi_terima_ban_item`, {
        recordId: Number(selectedKonfirmasiRowId),
        id_ban: targetId,
        aksi: "edit no seri",
        seri_baru: seriBaru,
        catatan_perubahan: catatan,
        user: actorNama,
        kode_cabang_actor: actorKodeCabang,
      }, {
        requestGroup: REQ_GROUP_KONFIRMASI_AKSI,
        timeout: 30000,
      });
      showNotif("success", "Perubahan No Seri berhasil disimpan.");
      await loadDetailKonfirmasiTerima({
        recordId: selectedKonfirmasiRowId,
        openModal: false,
        suppressErrorToast: false,
      });
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
      showNotif("error", err?.response?.data?.message || "Gagal menyimpan perubahan No Seri.");
      await loadDetailKonfirmasiTerima({
        recordId: selectedKonfirmasiRowId,
        openModal: false,
        suppressErrorToast: true,
      });
    }
  };

  const handleConfirmDeleteBanTerima = async () => {
    const targetId = Number(editBanTerimaDraft?.id_ban || 0);
    if (!targetId || !selectedKonfirmasiRowId) return;
    const { catatan } = getEditBanTerimaLiveValues();
    if (!catatan) {
      showNotif("error", "Catatan perubahan seri/penghapusan ban wajib diisi");
      return;
    }
    setEditBanTerimaDraft((prev) => ({ ...prev, catatan_perubahan: catatan }));
    // Tutup modal aksi langsung setelah klik.
    setOpenDeleteBanTerimaConfirmModal(false);
    setOpenEditBanTerimaModal(false);
    // Optimistic update agar modal induk langsung terasa berubah.
    setDetailKonfirmasiRows((prev) => prev.filter((row) => Number(row?.id_ban || 0) !== targetId));
    setCheckedDetailBanIds((prev) => prev.filter((id) => Number(id) !== targetId));
    try {
      api.cancelPendingRequests({
        group: REQ_GROUP_KONFIRMASI_AKSI,
        reason: "aksi hapus konfirmasi",
      });
      const currentRecordId = Number(selectedKonfirmasiRowId);
      const { data } = await api.post(`${backendPort}/api/main/aksi_konfirmasi_terima_ban_item`, {
        recordId: Number(selectedKonfirmasiRowId),
        id_ban: targetId,
        aksi: "hapus",
        catatan_perubahan: catatan,
        user: actorNama,
        kode_cabang_actor: actorKodeCabang,
      }, {
        requestGroup: REQ_GROUP_KONFIRMASI_AKSI,
        timeout: 30000,
      });
      showNotif("success", "Ban berhasil dihapus dari daftar pembelian.");
      const kodeCabangReload = String(
        konfirmasiTerimaBan.kodeCabang || (!isPusat ? actorKodeCabang : "")
      ).trim();
      if (isPusat || kodeCabangReload) {
        await loadKonfirmasiTerima(kodeCabangReload);
      }
      const statusRecord = String(data?.data?.status_record || "").trim().toLowerCase();
      if (statusRecord === "done") {
        setOpenModalDaftarBanDiterima(false);
        setSelectedKonfirmasiRowId(0);
        setDetailKonfirmasiRows([]);
        setCheckedDetailBanIds([]);
        return;
      }
      await loadDetailKonfirmasiTerima({
        recordId: currentRecordId,
        openModal: false,
        suppressErrorToast: false,
      });
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
      showNotif("error", err?.response?.data?.message || "Gagal menghapus ban.");
      await loadDetailKonfirmasiTerima({
        recordId: selectedKonfirmasiRowId,
        openModal: false,
        suppressErrorToast: true,
      });
    }
  };

  useEffect(() => () => {
    if (editBanTerimaDebounceRef.current.seri) clearTimeout(editBanTerimaDebounceRef.current.seri);
    if (editBanTerimaDebounceRef.current.catatan) clearTimeout(editBanTerimaDebounceRef.current.catatan);
  }, []);

  const handleDownloadKonfirmasiTerima = () => {
    if (!detailKonfirmasiRows.length) {
      showNotif("error", "Data detail ban masih kosong.");
      return;
    }
    try {
      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });
      const marginX = 10;
      const tanggalMemo = formatDateYYYYMMDD(detailKonfirmasiMeta?.tanggal);
      const nomorMemo = String(detailKonfirmasiMeta?.nomor || "-").trim();
      const cabangLabel = String(
        resolveNamaCabang(
          detailKonfirmasiRows?.[0]?.kode_cabang,
          detailKonfirmasiRows?.[0]?.nama_cabang
        )
        || detailKonfirmasiMeta?.kode_cabang
        || "-"
      ).trim();

      doc.setFontSize(12);
      doc.text("DAFTAR BAN YANG DITERIMA", marginX, 12);
      doc.setFontSize(9);
      doc.text(`No. Memo : ${nomorMemo}`, marginX, 18);
      doc.text(`Tanggal Memo : ${tanggalMemo}`, marginX + 65, 18);
      doc.text(`Cabang : ${cabangLabel}`, marginX + 130, 18);

      const rows = detailKonfirmasiRows.map((row, idx) => ([
        String(idx + 1),
        String(row?.id_ban || "-"),
        String(row?.seri_input || row?.seri_ban || "-"),
        String(row?.td || "-"),
        String(row?.status || "-"),
        String(row?.merk || "-"),
        String(row?.ukuran || "-"),
        String(resolveNamaCabang(row?.kode_cabang, row?.nama_cabang) || row?.kode_cabang || "-"),
        String(row?.suplier || "-"),
        row?.is_confirmed ? "Ya" : "Tidak",
      ]));

      autoTable(doc, {
        startY: 22,
        margin: { left: marginX, right: marginX },
        theme: "grid",
        head: [[
          "No",
          "ID Ban",
          "No. Seri",
          "TD",
          "Status",
          "Merk",
          "Ukuran",
          "Cabang",
          "Suplier",
          "Confirmed",
        ]],
        body: rows,
        styles: {
          fontSize: 8,
          cellPadding: 1.8,
          overflow: "linebreak",
          valign: "middle",
        },
        headStyles: {
          fillColor: [15, 45, 92],
          textColor: [255, 255, 255],
          fontStyle: "bold",
        },
        columnStyles: {
          0: { halign: "center", cellWidth: 10 },
          1: { halign: "center", cellWidth: 16 },
          2: { cellWidth: 48 },
          3: { halign: "center", cellWidth: 22 },
          4: { halign: "center", cellWidth: 18 },
          5: { cellWidth: 31 },
          6: { halign: "center", cellWidth: 22 },
          7: { cellWidth: 38 },
          8: { cellWidth: 44 },
          9: { halign: "center", cellWidth: 18 },
        },
        didDrawPage: (data) => {
          const pageCount = doc.getNumberOfPages();
          doc.setFontSize(8);
          doc.text(`Halaman ${data.pageNumber} / ${pageCount}`, data.settings.margin.left, doc.internal.pageSize.height - 6);
        },
      });

      const safeNomor = nomorMemo.replace(/[^\w.-]+/g, "_");
      const safeTgl = String(tanggalMemo || "").replace(/[^\d]+/g, "");
      doc.save(`daftar-ban-diterima_${safeNomor || "memo"}_${safeTgl || "tanggal"}.pdf`);
      showNotif("success", "PDF berhasil diunduh.");
    } catch (err) {
      console.error(err);
      showNotif("error", "Gagal membuat PDF.");
    }
  };

  const handleTerimaKonfirmasiBan = () => {
    const submit = async () => {
      if (isSubmittingKonfirmasiTerima) return;
      if (!canShowTerimaKonfirmasiButton) {
        showNotif("error", "Cabang pada nomor memo tidak sesuai dengan cabang aktif.");
        return;
      }
      const rowsForSubmit = isPusat
        ? detailKonfirmasiRows.filter((row) => isDetailBanSelectable(row))
        : detailKonfirmasiRows.filter((row) => checkedDetailBanIds.includes(Number(row?.id_ban || 0)));
      if (!rowsForSubmit.length) {
        showNotif("error", isPusat
          ? "Belum ada ban valid untuk diproses. Perbaiki No Seri atau hapus ban yang tidak valid."
          : "Pilih minimal 1 ban yang akan dikonfirmasi.");
        return;
      }
      if (isPusat) {
        const invalidLeft = detailKonfirmasiRows.some((row) => !isDetailBanSelectable(row));
        if (invalidLeft) {
          showNotif("error", "Masih ada ban tidak valid. Perbaiki lewat aksi edit atau hapus dari daftar.");
          return;
        }
      }
      if (!String(namaUserTerimaBan || "").trim()) {
        showNotif("error", "Nama User wajib diisi.");
        return;
      }
      const invalidKonfirmasiCaptions = collectInvalidCaptionIndexes(attachmentsKonfirmasiTerima);
      if (invalidKonfirmasiCaptions.length > 0) {
        setInvalidCaptionIndexesKonfirmasiTerima(invalidKonfirmasiCaptions);
        showNotif("error", "Caption dokumen wajib diisi untuk semua lampiran.");
        return;
      }

      const kodeCabangSubmit = String(
        detailKonfirmasiMeta.kode_cabang
        || selectedKonfirmasiRow?.kodeCabang
        || konfirmasiTerimaBan.kodeCabang
        || (!isPusat ? actorKodeCabang : "")
      ).trim();
      if (!kodeCabangSubmit) {
        showNotif("error", "Kode cabang tidak ditemukan.");
        return;
      }

      try {
        setIsSubmittingKonfirmasiTerima(true);
        const selectedBanRows = rowsForSubmit
          .map((row) => ({
            id_ban: Number(row?.id_ban || 0),
            seri_ban: String(row?.seri_input || row?.seri_ban || "").trim(),
            td: String(row?.td || "").trim(),
            catatan_perubahan: String(row?.catatan_perubahan || "").trim(),
            catatan_penerima: String(row?.catatan_penerima || "").trim(),
          }))
          .filter((row) => Number.isFinite(row.id_ban) && row.id_ban > 0);
        const payload = {
          recordId: Number(selectedKonfirmasiRowId),
          kode_cabang: kodeCabangSubmit,
          selected_ban_ids: selectedBanRows.map((x) => Number(x.id_ban)).filter((x) => Number.isFinite(x) && x > 0),
          selected_ban_rows: selectedBanRows,
          user: actorNama,
          nama_user_input: String(namaUserTerimaBan || "").trim(),
          kode_cabang_actor: actorKodeCabang,
        };
        const formData = new FormData();
        formData.append("recordId", String(payload.recordId));
        formData.append("kode_cabang", payload.kode_cabang);
        formData.append("selected_ban_ids", JSON.stringify(payload.selected_ban_ids));
        formData.append("selected_ban_rows", JSON.stringify(payload.selected_ban_rows));
        formData.append("user", payload.user);
        formData.append("nama_user_input", payload.nama_user_input);
        formData.append("kode_cabang_actor", payload.kode_cabang_actor);
        const lampiranBaru = attachmentsKonfirmasiTerima.filter((item) => item?.file instanceof File);
        lampiranBaru.forEach((item) => {
          formData.append("files", item.file);
          formData.append("captions", item?.caption || "");
        });
        const existingLampiran = attachmentsKonfirmasiTerima
          .filter((item) => !(item?.file instanceof File))
          .map((item) => ({
            name: item?.name || "",
            file: item?.db_file || item?.file || "",
            path: item?.path || "",
            type: item?.type || "",
            size: Number(item?.size || 0),
            caption: item?.caption || "",
            uploaded_at: item?.uploaded_at || null,
          }));
        formData.append("existing_lampiran", JSON.stringify(existingLampiran));
        api.cancelPendingRequests({
          group: REQ_GROUP_KONFIRMASI_SUBMIT,
          reason: "submit konfirmasi terima ban",
        });
        const { data } = await api.post(`${backendPort}/api/main/submit_konfirmasi_terima_ban`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
          requestGroup: REQ_GROUP_KONFIRMASI_SUBMIT,
          timeout: 120000,
        });
        showNotif("success", data?.message || "Konfirmasi terima ban berhasil disimpan.");

        setOpenModalDaftarBanDiterima(false);
        setCheckedDetailBanIds([]);
        setAttachmentsKonfirmasiTerima([]);
        setInvalidCaptionIndexesKonfirmasiTerima([]);

        const kodeCabangReload = String(
          konfirmasiTerimaBan.kodeCabang || (!isPusat ? actorKodeCabang : "")
        ).trim();
        if (isPusat || kodeCabangReload) {
          await loadKonfirmasiTerima(kodeCabangReload);
        }
      } catch (err) {
        if (api.isCanceledError(err)) return;
        console.error(err);
        showNotif("error", err?.response?.data?.message || "Gagal submit konfirmasi terima ban.");
      } finally {
        setIsSubmittingKonfirmasiTerima(false);
      }
    };
    submit();
  };

  return (
    <div className="container-fluid px-0 page30-table-theme page16-wo2-table-theme page16-wo-elegant-theme">
      <ShowPic
        open={openLampiranModal}
        onClose={handleCloseShowPic}
        row={{ catatan: selectedLampiranFiles?.[0]?.caption || "" }}
        backendPort={backendPort}
        token=""
        onUploadSuccess={() => {}}
        readOnly={true}
        customTitle="Lampiran Dokumen"
        customNote={selectedLampiranFiles?.[0]?.caption || ""}
        customFileUrl={selectedLampiranFiles?.[0]?.url || null}
        customFiles={selectedLampiranFiles}
      />
      <ModalCariBanMulti
        open={openPerubahanStatusBanModal}
        onClose={() => setOpenPerubahanStatusBanModal(false)}
        onSubmit={handleSelesaiPilihBanPerubahanStatus}
        showNotif={showNotif}
        globalOpsi={globalOpsi}
        kodeCabang={perubahanStatusBan.kodeCabang}
        title="Pilih Ban - Perubahan Status BAN"
        subtitle="Pilih ban untuk Ubah Status Manual. Hanya ban yang memenuhi kriteria yang akan disertakan."
        initialSelectedIds={selectedPerubahanStatusBanIds}
        initialSelectedRows={selectedPerubahanStatusBanRows}
        enrichFields={["merk", "event_terakhir"]}
        forcedLocationFilters={FORCED_LOCATION_GUDANG_ONLY}
        disableLocationFilterControls={true}
        blockedLocationFilters={BLOCKED_LOCATION_OTF_ONLY}
      />
      <ModalCariBanMulti
        open={openUbahDataMassalModal}
        onClose={() => setOpenUbahDataMassalModal(false)}
        onSubmit={handleSelesaiPilihBanUbahDataMassal}
        showNotif={showNotif}
        globalOpsi={globalOpsi}
        kodeCabang={isPusat ? ubahDataMassal.filterCabang : actorKodeCabang}
        title="Pilih Ban - Ubah Data Massal (Bulk)"
        subtitle="Pilih ban untuk perubahan data massal."
        initialSelectedIds={selectedUbahDataMassalIds}
        initialSelectedRows={selectedUbahDataMassalRows}
        forcedLocationFilters={FORCED_LOCATION_GUDANG_ONLY}
        disableLocationFilterControls={true}
        blockedLocationFilters={BLOCKED_LOCATION_OTF_ONLY}
      />
      <ModalCariBanMulti
        open={openUbahProfilBanModal}
        onClose={() => setOpenUbahProfilBanModal(false)}
        onSubmit={handleSelesaiPilihBanUbahProfilBan}
        showNotif={showNotif}
        globalOpsi={globalOpsi}
        kodeCabang={ubahProfilBanKodeCabangEfektif}
        title="Pilih Ban - Ubah Profil Ban"
        subtitle="Pilih ban untuk perubahan profil ban."
        initialSelectedIds={selectedUbahProfilBanIds}
        initialSelectedRows={selectedUbahProfilBanRows}
        forcedLocationFilters={FORCED_LOCATION_GUDANG_ONLY}
        disableLocationFilterControls={true}
        blockedLocationFilters={BLOCKED_LOCATION_OTF_ONLY}
        enrichFields={["merk", "ukuran", "id_suplier", "telapak"]}
      />
      <ModalCariBanMulti
        open={openPerintahPemindahanStockModal}
        onClose={() => setOpenPerintahPemindahanStockModal(false)}
        onSubmit={handleSelesaiPilihBanPerintahPemindahanStock}
        showNotif={showNotif}
        globalOpsi={globalOpsi}
        kodeCabang={perintahPemindahanStock.kodeCabang}
        title="Pilih Ban - Perintah Pemindahan Stock"
        subtitle="Pilih ban untuk dipindahkan ke cabang lain."
        initialSelectedIds={selectedPerintahPemindahanStockIds}
        initialSelectedRows={selectedPerintahPemindahanStockRows}
        forcedLocationFilters={FORCED_LOCATION_GUDANG_ONLY}
        disableLocationFilterControls={true}
        blockedLocationFilters={BLOCKED_LOCATION_OTF_ONLY}
      />
      <ModalBanShow
        open={openBanShowModal}
        onClose={() => setOpenBanShowModal(false)}
        globalOpsi={globalOpsi}
        idBan={banShowTargetId}
      />
      {showTelapakModalRetread && (
        <>
          <div className="modal-backdrop fade show" />
          <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Tambah Jenis Telapak</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowTelapakModalRetread(false)}
                    disabled={savingTelapakRetread}
                  />
                </div>
                <div className="modal-body">
                  <label className="form-label">Jenis Telapak Baru</label>
                  <input
                    className="form-control"
                    value={newTelapakRetread}
                    maxLength={60}
                    onChange={(e) => setNewTelapakRetread(String(e.target.value || "").replaceAll("#", "").replace(/\s+/g, ""))}
                    placeholder="Input jenis telapak baru"
                    disabled={savingTelapakRetread}
                  />
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => setShowTelapakModalRetread(false)}
                    disabled={savingTelapakRetread}
                  >
                    Batal
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSaveTelapakBaruRetread}
                    disabled={savingTelapakRetread}
                  >
                    {savingTelapakRetread ? "Menyimpan..." : "Simpan"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {openPersetujuanUbahStatusModal && (
        <>
          <div className="modal-backdrop fade show" />
          <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
            <div className="modal-dialog modal-xl modal-dialog-scrollable" role="document">
              <div className="modal-content page30-persetujuan-modal">
                <div className="modal-header page30-persetujuan-modal-header">
                  <h5 className="modal-title">Persetujuan Memo Ubah Status</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setOpenPersetujuanUbahStatusModal(false)}
                    disabled={isSubmittingPersetujuanUbahStatus}
                  />
                </div>
                <div className="modal-body">
                  <div className="row g-2 mb-3">
                    <div className="col-12 col-lg-4">
                      <label className="form-label">No. Memo</label>
                      <input className="form-control" value={persetujuanUbahStatusDetailMeta?.nomor || "-"} readOnly />
                    </div>
                    <div className="col-12 col-lg-3">
                      <label className="form-label">Tanggal Memo</label>
                      <input className="form-control" value={formatDateDDMMYYYY(persetujuanUbahStatusDetailMeta?.tanggal)} readOnly />
                    </div>
                    <div className="col-12 col-lg-3">
                      <label className="form-label">Cabang</label>
                      <input className="form-control" value={persetujuanUbahStatusDetailMeta?.nama_cabang || "-"} readOnly />
                    </div>
                    <div className="col-12 col-lg-2 d-flex align-items-end">
                      {Array.isArray(persetujuanUbahStatusDetailMeta?.lampiran)
                        && persetujuanUbahStatusDetailMeta.lampiran.length > 0 ? (
                        <button
                          type="button"
                          className="btn btn-sm page16-gradient-btn text-white w-100"
                          onClick={() => openLampiranPreviewPersetujuanModal({
                            nomor: persetujuanUbahStatusDetailMeta?.nomor || "-",
                            lampiran: persetujuanUbahStatusDetailMeta?.lampiran || [],
                          })}
                        >
                          {`Lihat Lampiran (${persetujuanUbahStatusDetailMeta.lampiran.length})`}
                        </button>
                      ) : (
                        <div className="small text-muted">Tidak ada lampiran.</div>
                      )}
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-sm table-bordered align-middle page30-persetujuan-detail-table table-theme-uniform">
                      <thead>
                        <tr>
                          <th style={{ width: 70 }} className="text-center">No.</th>
                          <th style={{ width: 110 }} className="text-center">ID Ban</th>
                          <th>No. Seri</th>
                          <th style={{ width: 200 }}>Status</th>
                          <th style={{ width: 240 }}>Catatan Cabang</th>
                          <th style={{ width: 240 }}>Catatan Approval</th>
                          <th style={{ width: 190 }}>Keputusan</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loadingDetailPersetujuanUbahStatus && (
                          <tr>
                            <td colSpan={7} className="text-center text-muted">Memuat detail memo...</td>
                          </tr>
                        )}
                        {!loadingDetailPersetujuanUbahStatus && persetujuanUbahStatusDetailRows.length === 0 && (
                          <tr>
                            <td colSpan={7} className="text-center text-muted">Belum ada detail ban.</td>
                          </tr>
                        )}
                        {!loadingDetailPersetujuanUbahStatus && persetujuanUbahStatusDetailRows.map((row, idx) => {
                          const idBan = Number(row?.id_ban || 0);
                          const keputusan = String(keputusanPersetujuanByBanId[idBan] || "approved").toLowerCase();
                          return (
                            <tr key={`persetujuan-detail-${idBan || idx + 1}`}>
                              <td className="text-center">{idx + 1}</td>
                              <td className="text-center">{idBan || "-"}</td>
                              <td>
                                <div className="fw-semibold">{row?.seri_ban || "-"}</div>
                                {/*<small className="text-muted">{row?.merk || "-"}</small>*/}
                              </td>
                              <td>{`${stripSystemNotdoneSuffix(row?.statusSaatIni) || "-"} -> ${stripSystemNotdoneSuffix(row?.statusUsulan) || "-"}`}</td>
                              <td>{row?.catatanCabang || "-"}</td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  placeholder="Catatan approval (opsional)"
                                  value={String(catatanApprovalByBanId[idBan] || "")}
                                  onChange={(e) => updateCatatanApprovalPersetujuanBan(idBan, e.target.value)}
                                  disabled={isSubmittingPersetujuanUbahStatus}
                                />
                              </td>
                              <td>
                                <div className="d-flex gap-2">
                                  <button
                                    type="button"
                                    className={`btn btn-sm ${keputusan === "approved" ? "btn-success" : "btn-outline-success"}`}
                                    onClick={() => updateKeputusanPersetujuanBan(idBan, "approved")}
                                    disabled={isSubmittingPersetujuanUbahStatus}
                                  >
                                    Approve
                                  </button>
                                  <button
                                    type="button"
                                    className={`btn btn-sm ${keputusan === "reject" ? "btn-danger" : "btn-outline-danger"}`}
                                    onClick={() => updateKeputusanPersetujuanBan(idBan, "reject")}
                                    disabled={isSubmittingPersetujuanUbahStatus}
                                  >
                                    Reject
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => setOpenPersetujuanUbahStatusModal(false)}
                    disabled={isSubmittingPersetujuanUbahStatus}
                  >
                    Tutup
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSubmitPersetujuanUbahStatus}
                    disabled={!canSubmitPersetujuanUbahStatus}
                  >
                    {isSubmittingPersetujuanUbahStatus ? "Menyimpan..." : "Simpan Persetujuan"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {openStatusBanModal && (
        <>
          <div className="modal-backdrop fade show" />
          <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
            <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Perubahan Status Ban</h5>
                  <button type="button" className="btn-close" onClick={() => setOpenStatusBanModal(false)} />
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <div className="small text-muted mb-1">{`Ban: ${statusBanTarget?.id_ban || "-"} | ${statusBanTarget?.seri_ban || "-"}`}</div>
                  </div>
                  <div className="mb-3">
                    <div className="small text-muted mb-1">Status Saat Ini</div>
                    <div className="fw-semibold">{statusBanTarget?.statusSaatIni || "-"}</div>
                  </div>
                  <div className="d-flex flex-wrap gap-2 mb-3">
                    {statusBanOptions.map((opt) => (
                      <button
                        key={`status-opt-${opt}`}
                        type="button"
                        className={`btn btn-sm ${statusBanDraftNext === opt ? "btn-primary" : "btn-outline-primary"}`}
                        onClick={() => setStatusBanDraftNext(opt)}
                      >
                        {opt}
                      </button>
                    ))}
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Catatan</label>
                    <textarea
                      rows={2}
                      className={`form-control ${!String(activePerubahanStatusBanCatatan || "").trim() ? "field-required-invalid" : ""}`}
                      placeholder="Catatan perubahan status (wajib)."
                      value={activePerubahanStatusBanCatatan}
                      onChange={(e) => setPerubahanStatusCatatanById(statusBanTarget?.id_ban, e.target.value)}
                    />
                  </div>
                  <div className="small text-muted">{`Status Terpilih: ${statusBanDraftNext || "-"}`}</div>
                  {(() => {
                    const selectedIsAfkir = normalizeStatusText(statusBanDraftNext) === "AFKIR";
                    const lampiranKey = getStatusLampiranPerubahanKey(statusBanTarget);
                    const lampiranStatus = getStatusLampiranPerubahan(statusBanTarget);
                    const invalidIndexesRaw = invalidStatusLampiranPerubahanByBanId[lampiranKey] || [];
                    const invalidCaptionIndexes = invalidIndexesRaw.filter((idx) => idx >= 0);
                    const isInvalidLampiran = invalidCaptionIndexes.length > 0;
                    return (
                      <div className={`card page16-soft-card mt-3 ${isInvalidLampiran ? "border-warning" : "border-primary-subtle"}`}>
                        <div className="card-body">
                          <div className="d-flex justify-content-center mb-2">
                            <span>{selectedIsAfkir ? "Upload BA Analisa (opsional)" : "Upload Dokumen (opsional)"}</span>
                          </div>
                          <PageKonten9_Pict
                            attachments={lampiranStatus}
                            setAttachments={(updater) => {
                              setStatusLampiranPerubahanForBan(statusBanTarget, updater);
                              clearInvalidStatusLampiranPerubahan(lampiranKey);
                            }}
                            bisaInput={true}
                            uploadInputClassName=""
                            invalidCaptionIndexes={invalidCaptionIndexes}
                            onCaptionChange={() => {
                              clearInvalidStatusLampiranPerubahan(lampiranKey);
                            }}
                          />
                        </div>
                      </div>
                    );
                  })()}
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-outline-secondary" onClick={() => setOpenStatusBanModal(false)}>
                    Tutup
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-warning"
                    onClick={() => {
                      setStatusBanDraftNext("");
                      clearInvalidStatusLampiranPerubahan(getStatusLampiranPerubahanKey(statusBanTarget));
                    }}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSaveStatusPerubahanModal}
                    disabled={!String(statusBanDraftNext || "").trim() || !String(activePerubahanStatusBanCatatan || "").trim()}
                  >
                    Selesai
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {openEditBanTerimaModal && isPusat && (
        <>
          <div className="modal-backdrop fade show" style={{ zIndex: 1060 }} />
          <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true" style={{ zIndex: 1065 }}>
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Aksi Ban Diterima</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setOpenEditBanTerimaModal(false)}
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Nomor Seri</label>
                    <input
                      type="text"
                      className="form-control"
                      key={`edit-seri-${editBanTerimaDraft.id_ban}`}
                      defaultValue={editBanTerimaDraft.seri_baru}
                      ref={editBanTerimaSeriInputRef}
                      placeholder="Input nomor seri ban"
                      onChange={(e) => scheduleEditBanTerimaField("seri_baru", e.target.value)}
                    />
                    <small className="text-muted">{`Seri lama: ${editBanTerimaDraft.seri_lama || "-"}`}</small>
                  </div>
                  <div>
                    <label className="form-label">Catatan Perubahan</label>
                    <textarea
                      rows={3}
                      className={`form-control ${!String(editBanTerimaDraft?.catatan_perubahan || "").trim() ? "field-required-invalid" : ""}`}
                      placeholder="Wajib diisi.."
                      key={`edit-catatan-${editBanTerimaDraft.id_ban}`}
                      defaultValue={editBanTerimaDraft.catatan_perubahan}
                      ref={editBanTerimaCatatanInputRef}
                      onChange={(e) => scheduleEditBanTerimaField("catatan_perubahan", e.target.value)}
                    />
                  </div>
                </div>
                <div className="modal-footer justify-content-between">
                  <button
                    type="button"
                    className="btn btn-outline-danger"
                    onClick={() => setOpenDeleteBanTerimaConfirmModal(true)}
                  >
                    Hapus Ban Ini
                  </button>
                  <div className="d-flex gap-2">
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => setOpenEditBanTerimaModal(false)}
                    >
                      Batal
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleSaveEditBanTerima}
                    >
                      Simpan
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {openDeleteBanTerimaConfirmModal && isPusat && (
        <>
          <div className="modal-backdrop fade show" style={{ zIndex: 1070 }} />
          <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true" style={{ zIndex: 1075 }}>
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Konfirmasi Hapus Ban</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setOpenDeleteBanTerimaConfirmModal(false)}
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  Anda akan menghapus ban ini dari pembelian. Lanjutkan?
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => setOpenDeleteBanTerimaConfirmModal(false)}
                  >
                    Batal
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleConfirmDeleteBanTerima}
                  >
                    Hapus
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {openDeletePengirimanMutasiModal && isCabangC1 && (
        <>
          <div className="modal-backdrop fade show" style={{ zIndex: 1070 }} />
          <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true" style={{ zIndex: 1075 }}>
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Konfirmasi Hapus</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setOpenDeletePengirimanMutasiModal(false)}
                    aria-label="Close"
                    disabled={isDeletingPengirimanMutasi}
                  />
                </div>
                <div className="modal-body">
                  {`Anda akan menghapus perintah mutasi stok ban seri ${deletePengirimanMutasiTarget?.seri_ban || "-"}`}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => setOpenDeletePengirimanMutasiModal(false)}
                    disabled={isDeletingPengirimanMutasi}
                  >
                    Batal
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleConfirmDeletePengirimanMutasiRow}
                    disabled={isDeletingPengirimanMutasi}
                  >
                    {isDeletingPengirimanMutasi ? "Memproses..." : "Lanjutkan"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {openPengirimanSebagianModal && !isCabangC1 && (
        <>
          <div className="modal-backdrop fade show" />
          <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Pengiriman Sebagian</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setOpenPengirimanSebagianModal(false)}
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  Beberapa ban tidak dikirim sesuai perintah pengiriman. Jelaskan alasannya pada kolom catatan (wajib).
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => setOpenPengirimanSebagianModal(false)}
                  >
                    Batal
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      setOpenPengirimanSebagianModal(false);
                      submitPengirimanBanKeCabangLain({ partialConfirmed: true });
                    }}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {openModalDaftarBanDiterima && (
        <>
          <div className="modal-backdrop fade show" />
          <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
            <div className="modal-dialog modal-xl modal-dialog-scrollable" role="document">
              <div className="modal-content">
                <div className="modal-header position-relative pe-5">
                  <h5 className="modal-title">DAFTAR BAN YANG DITERIMA</h5>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center justify-content-center"
                    style={{
                      width: 32,
                      height: 32,
                      lineHeight: 1,
                      borderRadius: 8,
                      padding: 0,
                      position: "absolute",
                      top: 10,
                      right: 12,
                    }}
                    aria-label="Close"
                    onClick={() => setOpenModalDaftarBanDiterima(false)}
                  >
                    <i className="fa fa-times" aria-hidden="true" />
                  </button>
                </div>
                <div className="modal-body">
                  <div className="small text-muted mb-2">
                    {`No. Memo: ${detailKonfirmasiMeta.nomor || "-"} | Tanggal Memo: ${formatDateYYYYMMDD(detailKonfirmasiMeta.tanggal)}`}
                  </div>
	                  <div className="border rounded p-2" style={{ maxHeight: 360, overflowY: "auto", overflowX: "auto" }}>
                    <table className="table table-sm align-middle mb-0 table-theme-uniform">
                      <thead className="table-light">
	                        <tr>
	                          <th style={{ width: 60 }}>No.</th>
	                          <th>No Seri</th>
	                          <th style={{ width: 150 }}>TD</th>
	                          <th style={{ width: 110 }}>Status</th>
	                          <th>Merk</th>
                          <th style={{ width: 140 }}>Ukuran</th>
                          <th style={{ width: 140 }}>Cabang</th>
                          <th style={{ width: 160 }}>Pengirim</th>
                          <th style={{ width: 220 }}>Catatan</th>
                          {!hideAksiColumnKonfirmasiDetail && (
                            <th style={{ width: 90 }} className="text-center">
                              {isPusat ? (
                                "AKSI"
                              ) : (
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={isAllSelectableDetailChecked}
                                  onChange={(e) => handleToggleAllDetailBanSelect(Boolean(e.target.checked))}
                                  title="Pilih semua item yang valid"
                                />
                              )}
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {loadingDetailKonfirmasi && (
                          <tr>
	                            <td colSpan={hideAksiColumnKonfirmasiDetail ? 9 : 10} className="text-center text-muted">Memuat data ban...</td>
                          </tr>
                        )}
                        {!loadingDetailKonfirmasi && detailKonfirmasiRows.length === 0 && (
                          <tr>
	                            <td colSpan={hideAksiColumnKonfirmasiDetail ? 9 : 10} className="text-center text-muted">Data ban tidak ditemukan.</td>
                          </tr>
                        )}
                        {!loadingDetailKonfirmasi && detailKonfirmasiRows.map((row, idx) => (
                          <tr key={`detail-terima-ban-${row.id_ban || idx + 1}`}>
                            <td>{idx + 1}</td>
                            <td>
                              <div className="d-flex align-items-center gap-1 flex-nowrap" style={{ minWidth: 0 }}>
                                {isPusat ? (
                                  <span className="flex-grow-1 text-truncate" title={row.seri_input || "-"}>
                                    {row.seri_input || "-"}
                                  </span>
                                ) : (
                                  <input
                                    value={row.seri_input || ""}
                                    disabled={!String(row.seri_ban || "").toUpperCase().startsWith("BUY#")}
                                    onChange={(e) => updateDetailSeriBan(row.id_ban, e.target.value)}
                                    className={
                                      String(row.seri_ban || "").toUpperCase().startsWith("BUY#")
                                        ? "flex-grow-1 border rounded-2 px-2 py-1"
                                        : "flex-grow-1 border-0 bg-transparent px-0 py-0"
                                    }
                                    style={{
                                      fontSize: "0.9rem",
                                      outline: "none",
                                      boxShadow: "none",
                                      minWidth: 0,
                                    }}
                                  />
                                )}
                                {row.is_confirmed && (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width="18"
                                    height="18"
                                    style={{ flex: "0 0 auto", display: "block" }}
                                    aria-label="Sudah konfirmasi"
                                  >
                                    <path
                                      fill="#16a34a"
                                      d="M12 2a10 10 0 1 0 10 10A10.01 10.01 0 0 0 12 2Zm-1 14-4-4 1.41-1.41L11 13.17l4.59-4.58L17 10Z"
                                    />
                                  </svg>
                                )}
                              </div>
	                            </td>
	                            <td>
	                              <input
	                                type="text"
	                                className={`form-control form-control-sm ${!isTdValueValid(row?.td) ? "field-required-invalid" : ""}`}
	                                placeholder="0-0-0-0"
	                                value={row.td || ""}
	                                disabled={isPusat || !canShowTerimaKonfirmasiButton || Boolean(row.is_confirmed)}
	                                onChange={(e) => updateDetailTdBan(row.id_ban, e.target.value)}
	                              />
	                            </td>
	                            <td>{row.status || "-"}</td>
                            <td>{row.merk || "-"}</td>
                            <td>{row.ukuran || "-"}</td>
                            <td>
                              {isDetailKonfirmasiMutasiBan
                                ? (resolveNamaCabang(row.kode_cabang_penerima_mutasi, row.kode_cabang_penerima_mutasi || "-") || row.kode_cabang_penerima_mutasi || "-")
                                : (resolveNamaCabang(row.kode_cabang, row.nama_cabang) || row.kode_cabang || "-")}
                            </td>
                            <td>
                              {isDetailKonfirmasiMutasiBan
                                ? (pengirimKonfirmasiDetailLabel || "-")
                                : (row.suplier || "-")}
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Catatan penerima..."
                                value={row.catatan_penerima || ""}
                                disabled={!canEditCatatanPenerimaKonfirmasi}
                                onChange={(e) => updateDetailCatatanPenerima(row.id_ban, e.target.value)}
                              />
                            </td>
                            {!hideAksiColumnKonfirmasiDetail && (
                              <td className="text-center">
                                {isPusat ? (
                                  <button
                                    type="button"
                                    className={`btn btn-sm p-0 border-0 bg-transparent ${row.is_confirmed ? "text-muted" : "text-primary"}`}
                                    onClick={() => openActionEditBanTerima(row)}
                                    title={row.is_confirmed ? "Ban sudah dikonfirmasi, tidak bisa diedit." : "Aksi baris ban"}
                                    disabled={Boolean(row.is_confirmed)}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 24 24"
                                      width="16"
                                      height="16"
                                      aria-hidden="true"
                                    >
                                      <path
                                        fill="currentColor"
                                        d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zm2.92 2.33H5v-.92l8.06-8.06.92.92L5.92 19.58zM20.71 7.04a1.003 1.003 0 000-1.42L18.37 3.29a1.003 1.003 0 00-1.42 0l-1.83 1.83 3.75 3.75 1.84-1.83z"
                                      />
                                    </svg>
                                  </button>
                                ) : (
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={checkedDetailBanIds.includes(Number(row.id_ban))}
                                    onChange={(e) => handleToggleDetailBanSelect(row, e.target.checked)}
                                    disabled={!isDetailBanSelectable(row)}
                                    title={!isDetailBanSelectable(row) ? getDetailBanSelectError(row) : "Pilih baris ini"}
                                  />
                                )}
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {canShowTerimaKonfirmasiButton && (
                    <>
                      <div className="card page16-soft-card mt-3">
                        <div className="card-body">
                          <div className="fw-semibold mb-2">Upload Dokumen Pendukung (Jika Perlu)</div>
                          <PageKonten9_Pict
                            attachments={attachmentsKonfirmasiTerima}
                            setAttachments={setAttachmentsKonfirmasiTerima}
                            bisaInput={true}
                            bisaHapus={isPusat}
                            invalidCaptionIndexes={invalidCaptionIndexesKonfirmasiTerima}
                            onCaptionChange={() => setInvalidCaptionIndexesKonfirmasiTerima([])}
                          />
                        </div>
                      </div>

                      <div className="card page16-soft-card mt-3">
                        <div className="card-body">
                          <div className="row g-2">
                            <div className="col-12 col-lg-9 d-flex align-items-center">
                              <span className="fw-semibold">Petugas Input</span>
                            </div>
                            <div className="col-12 col-lg-3">
                              <input
                                className="form-control"
                                placeholder="Nama User"
                                value={namaUserTerimaBan}
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-danger" onClick={handleDownloadKonfirmasiTerima}>
                    Download
                  </button>
                  {canShowTerimaKonfirmasiButton && (
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleTerimaKonfirmasiBan}
                      disabled={isSubmittingKonfirmasiTerima}
                    >
                      {isSubmittingKonfirmasiTerima ? "Memproses..." : "TERIMA"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="page16-header d-flex justify-content-between align-items-start flex-wrap gap-2 mb-4">
        <div>
          <h3 className="page16-title">{headerMeta.title}</h3>
        </div>
      </div>

      <div className="row g-4">
        {showPembelianBaruTableScreen && selectedAction?.value === "pembelian_baru" ? (
          <div className="col-12">
            <div className="page16-panel-form panel-accent-default">
              <div className="d-flex justify-content-between align-items-start mb-3 border-bottom pb-3">
                <div>
                  <p className="page16-panel-label mb-1">Detail Aktivitas</p>
                  <h4 className="page16-panel-title mb-1">Preview Form Order Pembelian</h4>
                  <p className="text-muted small mb-0">Data ditampilkan dari file Form Order yang sudah diupload (readonly).</p>
                </div>
                <div className="d-flex gap-2">
                  {pembelianValidasiMeta.validated
                    && Number(pembelianValidasiMeta.invalidCount || 0) === 0
                    && !pembelianValidasiMeta.confirmed && (
                      <button
                        type="button"
                        className="btn btn-sm btn-success"
                        onClick={handleKonfirmasiValidPembelian}
                      >
                        Konfirmasi Valid
                      </button>
                    )}
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary page16-panel-close"
                    onClick={() => setShowPembelianBaruTableScreen(false)}
                    aria-label="Tutup panel"
                  >
                    Tutup
                  </button>
                </div>
              </div>
              {pembelianValidasiMeta.validated && (
                <div className={`small fw-semibold mb-2 ${Number(pembelianValidasiMeta.invalidCount || 0) > 0 ? "text-danger" : "text-success"}`}>
                  {Number(pembelianValidasiMeta.invalidCount || 0) > 0
                    ? `Ditemukan ${pembelianValidasiMeta.invalidCount} baris tidak valid.`
                    : (pembelianValidasiMeta.confirmed
                      ? "Semua baris valid dan sudah dikonfirmasi."
                      : "Semua baris valid. Klik 'Konfirmasi Valid' untuk melanjutkan.")}
                </div>
              )}

              <div className="card page16-soft-card">
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-sm align-middle table-theme-uniform">
                      <thead>
                        <tr>
                          <th style={{ width: 56 }}>No.</th>
                          <th>Seri Ban</th>
                          <th>Status</th>
                          <th>Merk</th>
                          <th>Ukuran</th>
                          <th>TD</th>
                          <th>Cabang Penerima</th>
                          <th>Suplier</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pembelianBaruRows.map((row, idx) => {
                          const rowNo = Number(row?.no || idx + 1);
                          const rowErrors = pembelianValidasiMeta.invalidByRowNo?.[rowNo] || [];
                          const isInvalidRow = rowErrors.length > 0;
                          return (
                          <tr
                            key={`buy-row-${idx + 1}`}
                            style={
                              isInvalidRow
                                ? { backgroundColor: "#fbe9eb", color: "#7f1d1d" }
                                : undefined
                            }
                          >
                            <td>{row.no}</td>
                            <td>
                              <div>{row.seriBan || "-"}</div>
                              {isInvalidRow && (
                                <div className="small fw-semibold mt-1">{rowErrors.join(" ")}</div>
                              )}
                            </td>
                            <td>{row.status || "-"}</td>
                            <td>{row.merk || "-"}</td>
                            <td>{row.ukuran || "-"}</td>
                            <td>{row.td || "-"}</td>
                            <td>{row.cabangPenerima || "-"}</td>
                            <td>{row.suplier || "-"}</td>
                          </tr>
                        )})}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : showPengirimanCasingTableScreen && selectedAction?.value === "pengiriman_casing" ? (
          <div className="col-12">
            <div className="page16-panel-form panel-accent-default">
              <div className="d-flex justify-content-between align-items-start mb-3 border-bottom pb-3">
                <div>
                  <p className="page16-panel-label mb-1">Detail Aktivitas</p>
                  <h4 className="page16-panel-title mb-1">Tabel Ban Untuk Repair dan Vulkanisir</h4>
                  <p className="text-muted small mb-0">Pilih ban dan tentukan jenis repair sebelum dikirim ke pabrik.</p>
                </div>
                <div className="d-flex gap-2">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary page16-panel-close"
                    onClick={() => setShowPengirimanCasingTableScreen(false)}
                    aria-label="Tutup panel"
                  >
                    Tutup
                  </button>
                </div>
              </div>

              <div className="card page16-soft-card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center gap-2 mb-2">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Filter teks..."
                      value={filterTextPengirimanCasing}
                      onChange={(e) => setFilterTextPengirimanCasing(e.target.value)}
                      style={{ width: 260 }}
                    />
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary ms-auto"
                      onClick={clearPengirimanCasingTable}
                    >
                      Clear
                    </button>
                    <button
                      type="button"
                      className={`btn btn-sm ${showOnlySelectedPengirimanCasing ? "btn-info" : "btn-outline-info"}`}
                      onClick={() => setShowOnlySelectedPengirimanCasing((prev) => !prev)}
                      aria-pressed={showOnlySelectedPengirimanCasing}
                    >
                      {showOnlySelectedPengirimanCasing ? "Tampilkan Semua" : "Filter Terpilih"}
                    </button>
                    <button type="button" className="btn btn-sm btn-primary" onClick={handlePilihPengirimanCasing}>
                      Selesai
                    </button>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-sm align-middle table-theme-uniform">
                      <thead>
                        <tr>
                          <th style={{ width: 56 }}>No.</th>
                          <th style={{ width: 100 }}>ID Ban</th>
                          <th>Seri Ban</th>
                          <th style={{ width: 120 }}>Status</th>
                          <th style={{ width: 180 }}>Merk</th>
                          <th style={{ width: 140 }}>Ukuran</th>
                          <th style={{ width: 180 }}>Cabang</th>
                          <th style={{ width: 190 }}>Jenis Repair</th>
                          <th className="text-center" style={{ width: 92 }}>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={isAllPengirimanCasingRowsChecked}
                              onChange={(e) => toggleCheckAllPengirimanCasingRows(e.target.checked)}
                            />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {loadingPengirimanCasingRows && (
                          <tr>
                            <td colSpan={9} className="text-center text-muted">Memuat data ban...</td>
                          </tr>
                        )}
                        {!loadingPengirimanCasingRows && filteredPengirimanCasingRows.length === 0 && (
                          <tr>
                            <td colSpan={9} className="text-center text-muted">
                              {showOnlySelectedPengirimanCasing ? "Belum ada ban terpilih pada hasil filter." : "Data ban tidak ditemukan."}
                            </td>
                          </tr>
                        )}
                        {!loadingPengirimanCasingRows && filteredPengirimanCasingRows.map(({ row, index }) => (
                          <PengirimanCasingTableRow
                            key={`casing-row-${row.idBan || index + 1}`}
                            row={row}
                            index={index}
                            checked={checkedPengirimanCasingIndexes.has(index)}
                            cabangLabel={resolveNamaCabang(row.kodeCabang, row.cabang || row.kodeCabang || "-") || "-"}
                            onRepairChange={updatePengirimanCasingRepair}
                            onCheckedChange={updatePengirimanCasingRowChecked}
                          />
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : showTerimaBanVulkanisirTableScreen && selectedAction?.value === "terima_ban_vulkanisir" ? (
          <div className="col-12">
            <div className="page16-panel-form panel-accent-default">
              <div className="d-flex justify-content-between align-items-start mb-3 border-bottom pb-3">
                <div>
                  <p className="page16-panel-label mb-1">Detail Aktivitas</p>
                  <h4 className="page16-panel-title mb-1">
                    {`Tabel Ban Retread Dari ${terimaBanVulkanisirVendorLabel} Untuk Cabang ${terimaBanVulkanisirCabangLabel}`}
                  </h4>
                  <p className="text-muted small mb-0">
                    Pilih ban stok pabrik yang akan dikirim ke gudang cabang.
                  </p>
                </div>
                <div className="d-flex gap-2">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary page16-panel-close"
                    onClick={() => setShowTerimaBanVulkanisirTableScreen(false)}
                    aria-label="Tutup panel"
                  >
                    Tutup
                  </button>
                </div>
              </div>

              <div className="card page16-soft-card">
                <div className="card-body">
                  <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
                    <div className="d-flex align-items-center">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        style={{ minWidth: 240 }}
                        placeholder="Filter teks tabel..."
                        value={terimaBanVulkanisirFilterText}
                        onChange={(e) => setTerimaBanVulkanisirFilterText(e.target.value)}
                      />
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => samakanTerimaBanVulkanisir("telapak")}
                      >
                        Samakan Telapak
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => samakanTerimaBanVulkanisir("td")}
                      >
                        Samakan TD
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary"
                        onClick={clearTerimaBanVulkanisirTable}
                      >
                        Clear
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm ${showOnlySelectedTerimaBanVulkanisir ? "btn-info" : "btn-outline-info"}`}
                        onClick={() => setShowOnlySelectedTerimaBanVulkanisir((prev) => !prev)}
                        aria-pressed={showOnlySelectedTerimaBanVulkanisir}
                      >
                        {showOnlySelectedTerimaBanVulkanisir ? "Tampilkan Semua" : "Filter Terpilih"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        onClick={handleSelesaiPilihTerimaBanVulkanisir}
                      >
                        Selesai
                      </button>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-sm align-middle table-theme-uniform">
                      <thead>
                        <tr>
                          <th style={{ width: 100 }}>Id_ban</th>
                          <th>Seri Ban</th>
                          <th style={{ width: 140 }}>Jenis Repair</th>
                          <th style={{ width: 170 }}>Status</th>
                          <th style={{ width: 180 }}>Jenis Telapak</th>
                          <th style={{ width: 120 }}>Ukuran</th>
                          <th style={{ width: 140 }}>TD</th>
                          <th style={{ width: 180 }}>Merk</th>
                          <th style={{ width: 220 }}>Catatan Ban</th>
                          <th className="text-center" style={{ width: 92 }}>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={isAllTerimaBanVulkanisirRowsChecked}
                              onChange={(e) => toggleCheckAllTerimaBanVulkanisirRows(e.target.checked)}
                            />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {loadingTerimaBanVulkanisirRows && (
                          <tr>
                            <td colSpan={9} className="text-center text-muted">Memuat data ban retread...</td>
                          </tr>
                        )}
                        {!loadingTerimaBanVulkanisirRows && terimaBanVulkanisirRows.length === 0 && (
                          <tr>
                            <td colSpan={9} className="text-center text-muted">Data ban retread tidak ditemukan.</td>
                          </tr>
                        )}
                        {!loadingTerimaBanVulkanisirRows && terimaBanVulkanisirRows.length > 0 && filteredTerimaBanVulkanisirRows.length === 0 && (
                          <tr>
                            <td colSpan={9} className="text-center text-muted">
                              {showOnlySelectedTerimaBanVulkanisir ? "Belum ada ban terpilih pada hasil filter." : "Tidak ada baris yang cocok dengan filter."}
                            </td>
                          </tr>
                        )}
                        {!loadingTerimaBanVulkanisirRows && filteredTerimaBanVulkanisirRows.map(({ row, originalIndex }, idx) => (
                          <TerimaBanVulkanisirTableRow
                            key={`terima-vulkanisir-row-${row.idBan || idx + 1}`}
                            row={row}
                            originalIndex={originalIndex}
                            checked={checkedTerimaBanVulkanisirIndexes.has(originalIndex)}
                            telapakOptions={opsiTelapakTerimaVendorSelect}
                            onRowChange={updateTerimaBanVulkanisirRow}
                            onTelapakAdd={openAddTelapakRetreadModal}
                          />
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className={isUbahProfilBanExpanded ? "d-none" : "col-12 col-md-4"}>
              <div className="page16-action-grid">
                <div className="row g-2">
                  {visibleActions.map((action) => (
                    <div key={action.value} className="col-12">
                      <button
                        type="button"
                        className={`page15-odotd-action ${activeAction === action.value ? "is-active" : ""}`}
                        onClick={() => handlePilihAction(action.value)}
                      >
                        <div className="d-flex justify-content-between align-items-start gap-2">
                          <div>
                            <h5 className="mb-1 text-white">{action.title}</h5>
                            <p className="mb-0 text-white-80 small">{action.description}</p>
                          </div>
                          <span className="page16-action-state text-white">
                            {activeAction === action.value ? "Aktif" : "Pilih"}
                          </span>
                        </div>
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className={isUbahProfilBanExpanded ? "col-12" : "col-12 col-md-8"}>
          <div className={selectedAction ? "page16-panel-form panel-accent-default" : ""}>
            {!selectedAction && (
              <div className="page16-panel-placeholder d-flex flex-column justify-content-center align-items-center text-center h-100">
                <p className="fw-semibold mb-1">Belum ada menu dipilih.</p>
                <p className="text-muted small mb-0">Klik salah satu menu di sebelah kiri untuk membuka panel.</p>
              </div>
            )}

            {selectedAction && (
              <div>
                <div className="d-flex justify-content-between align-items-start mb-3 border-bottom pb-3">
                  <div>
                    <p className="page16-panel-label mb-1">Detail Aktivitas</p>
                    <h4 className="page16-panel-title mb-1">{selectedAction.title}</h4>
                    <p className="text-muted small mb-0">{selectedAction.description}</p>
                  </div>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary page16-panel-close"
                    onClick={() => setActiveAction("")}
                    aria-label="Tutup panel"
                  >
                    <i className="fa fa-times" aria-hidden="true" />
                  </button>
                </div>

                {selectedAction.value === "pembelian_baru" && (
                  <div className="row g-3">
                    <div className="col-12">
                          <div className="row g-3">
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Cabang Penerima</label>
                              <select
                                className={`form-select ${invalidPembelianCabang ? "field-required-invalid" : ""}`}
                                value={pembelianBaru.kodeCabang}
                                onChange={(e) => setPembelianBaru((prev) => ({ ...prev, kodeCabang: e.target.value }))}
                              >
                                <option value="">Pilih cabang</option>
                                {opsiCabang.map((item) => (
                                  <option key={item.kode_cabang} value={item.kode_cabang}>
                                    {item.nama_cabang}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Nomor Transaksi</label>
                              <input className="form-control" value={pembelianBaru.nomor || "-"} readOnly />
                            </div>
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Tanggal</label>
                              <input
                                type="date"
                                className="form-control"
                                value={pembelianBaru.tanggal}
                                readOnly
                              />
                            </div>
                          </div>
                    </div>

                    <div className="col-12">
                          <div className="row g-3 align-items-end">
                            <div className="col-12 col-lg-4">
                              <label className="form-label">No. Dokumen (SJ)</label>
                              <input
                                type="text"
                                className={`form-control ${invalidPembelianNoDok ? "field-required-invalid" : ""}`}
                                value={pembelianBaru.noDokumen}
                                onChange={(e) => setPembelianBaru((prev) => ({ ...prev, noDokumen: sanitizeNoDokumenInput(e.target.value) }))}
                              />
                            </div>
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Tgl. Dokumen</label>
                              <input
                                type="date"
                                className={`form-control ${invalidPembelianTglDok ? "field-required-invalid" : ""}`}
                                value={pembelianBaru.tglDokumen}
                                onChange={(e) => setPembelianBaru((prev) => ({ ...prev, tglDokumen: e.target.value }))}
                              />
                            </div>
                            <div className="col-12 col-lg-2">
                              <label className="form-label">Qty</label>
                              <input
                                type="number"
                                min="1"
                                className={`form-control ${invalidPembelianQty ? "field-required-invalid" : ""}`}
                                value={pembelianBaru.qty}
                                onChange={(e) => setPembelianBaru((prev) => ({ ...prev, qty: e.target.value }))}
                              />
                            </div>
                            <div className="col-12 col-lg-2 d-grid">
                              <button type="button" className="btn btn-outline-primary" onClick={handleDownloadFormOrder}>
                                Form Order
                              </button>
                            </div>
                          </div>
                          <div className="row g-3 align-items-center mt-1">
                            <div className="col-12 col-lg-10">
                              <label className="form-label">Upload Form Order</label>
                              <input
                                ref={formOrderFileRef}
                                type="file"
                                className={`form-control ${invalidPembelianFormOrder ? "field-required-invalid" : ""}`}
                                accept=".xlsx,.xls"
                                onChange={handleUploadFormOrderFile}
                              />
                              <small className={`d-block mt-1 ${pembelianFormOrderMeta.error ? "text-danger" : "text-muted"}`}>
                                {pembelianFormOrderMeta.error
                                  ? pembelianFormOrderMeta.error
                                  : (pembelianFormOrderMeta.fileName
                                    ? `${pembelianFormOrderMeta.fileName} (${pembelianFormOrderMeta.totalRows} baris)`
                                    : "Upload file Form Order untuk validasi data pembelian.")}
                              </small>
                            </div>
                            <div className="col-12 col-lg-2 d-flex align-items-center">
                              <button
                                type="button"
                                className="btn btn-outline-primary w-100 page30-validasi-btn"
                                onClick={handleLihatFormOrder}
                                disabled={!canKlikValidasiPembelian}
                                style={
                                  canKlikValidasiPembelian
                                    ? {
                                      backgroundColor: "#0d6efd",
                                      borderColor: "#0d6efd",
                                      color: "#ffffff",
                                    }
                                    : {
                                      backgroundColor: "#d4e1f8",
                                      borderColor: "#d4e1f8",
                                      color: "#8fa0c5",
                                    }
                                }
                              >
                                Validasi
                              </button>
                            </div>
                          </div>
                    </div>

                    <div className="col-12 col-lg-6">
                      <div className="card page16-soft-card h-100">
                        <div className="card-body">
                          <label className="form-label">Catatan</label>
                          <textarea
                            rows={5}
                            className="form-control"
                            placeholder="Catatan pembelian ban baru..."
                            value={pembelianBaru.catatan}
                            onChange={(e) => setPembelianBaru((prev) => ({ ...prev, catatan: e.target.value }))}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-lg-6">
                      <div className="card page16-soft-card h-100">
                        <div className="card-body">
                          <div className="d-flex justify-content-center mb-2">
                            <span>Upload Dokumen</span>
                          </div>
                          <PageKonten9_Pict
                            attachments={attachmentsPembelianBaru}
                            setAttachments={setAttachmentsPembelianBaru}
                            bisaInput={true}
                            uploadInputClassName={invalidPembelianLampiran ? "field-required-invalid" : ""}
                            invalidCaptionIndexes={invalidCaptionIndexesPembelianBaru}
                            onCaptionChange={() => setInvalidCaptionIndexesPembelianBaru([])}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 d-flex justify-content-end gap-2">
                      {readySimpanPembelian && (
                        <div className="me-auto align-self-center text-success small fw-semibold">
                          {`Sebanyak ${pembelianBaruRows.length} baris data ban valid dan siap disimpan.`}
                        </div>
                      )}
                      <button type="button" className="btn btn-outline-secondary" onClick={() => setActiveAction("")}>
                        Batal
                      </button>
                      <button
                        type="button"
                        className="btn page16-gradient-btn text-white"
                        onClick={submitPembelianBaru}
                        disabled={
                          !readySimpanPembelian
                          || !pembelianBaruStep1Ready
                          || !pembelianBaruRowsComplete
                          || isSubmittingPembelianBaru
                        }
                      >
                        {isSubmittingPembelianBaru ? "Memproses..." : "Simpan"}
                      </button>
                    </div>
                  </div>
                )}

                {selectedAction.value === "konfirmasi_terima_ban" && (
                  <div className="row g-3">
                    <div className="col-12 col-lg-4">
                      <label className="form-label">Cabang</label>
                      {!isPusat ? (
                        <input className="form-control" value={namaCabangUser || "-"} readOnly />
                      ) : (
                        <select
                          className={`form-select ${invalidKonfirmasiTerimaCabang ? "field-required-invalid" : ""}`}
                          value={konfirmasiTerimaBan.kodeCabang}
                          onChange={(e) =>
                            setKonfirmasiTerimaBan((prev) => ({ ...prev, kodeCabang: e.target.value }))
                          }
                        >
                          <option value="">Pilih Cabang</option>
                          <option value={CABANG_ALL_VALUE}>Semua Cabang</option>
                          {opsiCabang.map((x) => (
                            <option key={x.kode_cabang} value={x.kode_cabang}>
                              {x.nama_cabang}
                            </option>
                          ))}
                        </select>
                      )}
                    </div>
                    <div className="col-12">
                      <div className="card page16-soft-card">
                        <div className="card-body page30-persetujuan-body">
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div className="fw-semibold">Surat Jalan / Dokumen Pembelian yang belum tuntas</div>
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-primary"
                              onClick={handleLihatKonfirmasiTerima}
                              disabled={loadingKonfirmasiTerima || konfirmasiTerimaRows.length === 0}
                            >
                              Lihat
                            </button>
                          </div>
                          <div className="table-responsive page30-persetujuan-table-wrap">
                            <table className="table table-sm align-middle page30-persetujuan-table table-theme-uniform">
                              <thead>
                                <tr>
                                  <th style={{ width: 64 }}>No.</th>
                                  <th style={{ width: 170 }}>Cabang</th>
                                  <th>No. Dokumen</th>
                                  <th style={{ width: 140 }}>Tgl</th>
                                  <th style={{ width: 100 }}>Qty</th>
                                  <th style={{ width: 120 }} className="text-center">Pengirim</th>
                                  <th style={{ width: 90 }} className="text-center">Pilih</th>
                                </tr>
                              </thead>
                              <tbody>
                                {loadingKonfirmasiTerima && (
                                  <tr>
                                    <td colSpan={7} className="text-center text-muted">
                                      Memuat data...
                                    </td>
                                  </tr>
                                )}
                                {!loadingKonfirmasiTerima && konfirmasiTerimaRows.length === 0 && (
                                  <tr>
                                    <td colSpan={7} className="text-center text-muted">
                                      Belum ada data ditampilkan.
                                    </td>
                                  </tr>
                                )}
                                {!loadingKonfirmasiTerima && konfirmasiTerimaRows.map((row, idx) => (
                                  <tr key={`konfirmasi-row-${row.id || idx + 1}`}>
                                    <td>{idx + 1}</td>
                                    <td>
                                      {cabangPenerimaMapByKodeUpper.get(String(row.kodeCabang || "").trim().toUpperCase())?.nama
                                        || row.kodeCabang
                                        || "-"}
                                    </td>
                                    <td>{row.noDokumen || "-"}</td>
                                    <td>{row.tglDokumen || "-"}</td>
                                    <td>{Number(row.qtyPending || 0)}</td>
                                    <td className="text-center">
                                      {(() => {
                                        const base = String(row?.pengirim || "").trim();
                                        if (!base) return "-";
                                        return `${base}${row?.pengirimHasMore ? "++" : ""}`;
                                      })()}
                                    </td>
                                    <td className="text-center">
                                      <input
                                        type="radio"
                                        className="form-check-input"
                                        name="konfirmasi-terima-radio"
                                        checked={Number(selectedKonfirmasiRowId) === Number(row.id)}
                                        onChange={() => updateKonfirmasiRowRadio(row.id)}
                                      />
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {selectedAction.value === "ubah_data_massal" && (
                  <div className="row g-3">
                    <div className="col-12">
                          <div className="row g-3">
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Cabang Input</label>
                              <input className="form-control" value={ubahDataMassalCabangInputLabel || "-"} readOnly />
                            </div>
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Nomor Transaksi</label>
                              <input className="form-control" value={ubahDataMassal.nomor || "-"} readOnly />
                            </div>
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Tanggal Input</label>
                              <input
                                type="date"
                                className="form-control"
                                value={ubahDataMassal.tanggal}
                                onChange={(e) => setUbahDataMassal((prev) => ({ ...prev, tanggal: e.target.value }))}
                              />
                            </div>
                          </div>
                    </div>

                    <div className="col-12">
                      <div className="card page16-soft-card">
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                            <div className="fw-semibold">Daftar Ban Ubah Status Massal</div>
                            <div className="d-flex gap-2 align-items-end flex-wrap">
                              <div>
                                <label className="form-label mb-1">Filter Cabang</label>
                                {isPusat ? (
                                  <select
                                    className="form-select form-select-sm"
                                    value={ubahDataMassal.filterCabang}
                                    onChange={(e) => setUbahDataMassal((prev) => ({ ...prev, filterCabang: e.target.value }))}
                                  >
                                    <option value="">Semua Cabang</option>
                                    {opsiCabang.map((x) => (
                                      <option key={`bulk-cabang-${x.kode_cabang}`} value={x.kode_cabang}>
                                        {x.nama_cabang}
                                      </option>
                                    ))}
                                  </select>
                                ) : (
                                  <input className="form-control form-control-sm" value={namaCabangUser || actorKodeCabang || "-"} readOnly />
                                )}
                              </div>
                              <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                disabled={!ubahDataMassalStep1Ready}
                                onClick={handleOpenPilihBanUbahDataMassal}
                              >
                                Pilih Ban
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="card page16-soft-card">
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                            <div className="small fw-semibold">
                              {`Sebanyak ${selectedUbahDataMassalIds.length} ban dipilih untuk perubahan data secara massal`}
                            </div>
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm"
                              disabled={selectedUbahDataMassalIds.length === 0}
                              onClick={handleDownloadTemplateUbahDataMassal}
                            >
                              Download File Excel
                            </button>
                          </div>
                          <div className="row g-2 mt-1 align-items-center">
                            <div className="col-12 col-lg-10">
                              <label className="form-label">Upload File Excel</label>
                              <input
                                type="file"
                                className="form-control"
                                accept=".xlsx,.xls"
                                onChange={handleUploadFileUbahDataMassal}
                              />
                              <small className="text-muted d-block mt-1">
                                {bulkUbahDataMassalFile
                                  ? bulkUbahDataMassalFile.name
                                  : "Upload file excel untuk proses ubah data massal."}
                              </small>
                            </div>
                            <div className="col-12 col-lg-2 d-flex align-items-end">
                              <button
                                type="button"
                                className="btn btn-success w-100"
                                disabled={!bulkUbahDataMassalFile || isSubmittingUbahDataMassal}
                                onClick={handleSubmitUbahStatusMassal}
                              >
                                {isSubmittingUbahDataMassal ? "Memproses..." : "Upload"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="card page16-soft-card">
                        <div className="card-body">
                          <div className="d-flex justify-content-center mb-2">
                            <span>Upload Dokumen</span>
                          </div>
                          <PageKonten9_Pict
                            attachments={attachmentsUbahDataMassal}
                            setAttachments={setAttachmentsUbahDataMassal}
                            bisaInput={true}
                            invalidCaptionIndexes={invalidCaptionIndexesUbahDataMassal}
                            onCaptionChange={() => setInvalidCaptionIndexesUbahDataMassal([])}
                          />
                          <small className="text-muted d-block mt-1">
                            Opsional. Jika upload dokumen, caption wajib diisi.
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {selectedAction.value === "ubah_profil_ban" && (
                  <div className="row g-3">
                    <div className="col-12">
                      <div className="row g-3">
                        <div className="col-12 col-lg-4">
                          <label className="form-label">Cabang</label>
                          {isPusat ? (
                            <select
                              className={`form-select ${!ubahProfilBanKodeCabangEfektif ? "field-required-invalid" : ""}`}
                              value={ubahProfilBan.kodeCabang}
                              onChange={(e) => {
                                setUbahProfilBan((prev) => ({ ...prev, kodeCabang: e.target.value }));
                                setSelectedUbahProfilBanIds([]);
                                setSelectedUbahProfilBanRows([]);
                              }}
                            >
                              <option value="">-Pilih Cabang-</option>
                              {opsiCabang.map((x) => (
                                <option key={`profil-ban-cabang-${x.kode_cabang}`} value={x.kode_cabang}>
                                  {x.nama_cabang}
                                </option>
                              ))}
                            </select>
                          ) : (
                            <input className="form-control" value={namaCabangUser || actorKodeCabang || "-"} readOnly />
                          )}
                        </div>
                        <div className="col-12 col-lg-4">
                          <label className="form-label">Nomor Transaksi</label>
                          <input className="form-control" value={ubahProfilBan.nomor || buildUbahProfilBanNomorPreview()} readOnly />
                        </div>
                        <div className="col-12 col-lg-4">
                          <label className="form-label">Tanggal Input</label>
                          <input
                            type="date"
                            className="form-control"
                            value={ubahProfilBan.tanggal}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="card page16-soft-card">
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                            <div>
                              <div className="fw-semibold">Daftar Ban Diubah Profil</div>
                              <small className="text-muted">
                                {`${selectedUbahProfilBanRows.length} ban dipilih${ubahProfilBanCabangInputLabel ? ` | ${ubahProfilBanCabangInputLabel}` : ""}`}
                              </small>
                            </div>
                            <button
                              type="button"
                              className="btn btn-primary btn-sm"
                              disabled={!ubahProfilBanKodeCabangEfektif}
                              onClick={handleOpenPilihBanUbahProfilBan}
                            >
                              Pilih Ban
                            </button>
                          </div>
                          {selectedUbahProfilBanRows.length > 0 && (
                            <>
                              <div className="table-responsive mt-3">
                            <table className="table table-sm table-bordered align-middle mb-0">
                              <thead className="table-light">
                                <tr>
                                  <th style={{ width: 90 }}>ID_BAN</th>
                                  <th style={{ minWidth: 160 }}>NO SERI</th>
                                  <th style={{ minWidth: 150 }}>MERK</th>
                                  <th style={{ minWidth: 150 }}>UKURAN</th>
                                  <th style={{ minWidth: 170 }}>TELAPAK</th>
                                  <th style={{ minWidth: 170 }}>SUPLIER</th>
                                  <th style={{ minWidth: 220 }}>CATATAN</th>
                                </tr>
                              </thead>
                              <tbody>
                                {selectedUbahProfilBanRows.map((row) => {
                                  const idBan = Number(row?.id_ban || 0);
                                  const suplierValue = String(row?.suplier || "").trim();
                                  const telapakOptions = getUbahProfilTelapakOptions(suplierValue);
                                  return (
                                    <tr key={`ubah-profil-ban-row-${idBan}`}>
                                      <td>{idBan || "-"}</td>
                                      <td>{String(row?.seri_ban || "-")}</td>
                                      <td>
                                        <select
                                          className="form-select form-select-sm"
                                          value={String(row?.merk || "")}
                                          onChange={(e) => updateUbahProfilBanRow(idBan, "merk", e.target.value)}
                                        >
                                          <option value="">-Pilih Merk-</option>
                                          {opsiMerkValues.map((value) => (
                                            <option key={`ubah-profil-merk-${idBan}-${value}`} value={value}>
                                              {value}
                                            </option>
                                          ))}
                                        </select>
                                      </td>
                                      <td>
                                        <select
                                          className="form-select form-select-sm"
                                          value={String(row?.ukuran || "")}
                                          onChange={(e) => updateUbahProfilBanRow(idBan, "ukuran", e.target.value)}
                                        >
                                          <option value="">-Pilih Ukuran-</option>
                                          {opsiUkuranValues.map((value) => (
                                            <option key={`ubah-profil-ukuran-${idBan}-${value}`} value={value}>
                                              {value}
                                            </option>
                                          ))}
                                        </select>
                                      </td>
                                      <td>
                                        <select
                                          className="form-select form-select-sm"
                                          value={String(row?.telapak || TELAPAK_DEFAULT).trim() || TELAPAK_DEFAULT}
                                          disabled={!suplierValue}
                                          onChange={(e) => updateUbahProfilBanRow(idBan, "telapak", e.target.value)}
                                        >
                                          {telapakOptions.map((value) => (
                                            <option key={`ubah-profil-telapak-${idBan}-${value}`} value={value}>
                                              {value}
                                            </option>
                                          ))}
                                        </select>
                                      </td>
                                      <td>
                                        <select
                                          className="form-select form-select-sm"
                                          value={suplierValue}
                                          onChange={(e) => updateUbahProfilBanRow(idBan, "suplier", e.target.value)}
                                        >
                                          <option value="">-Pilih Suplier-</option>
                                          {opsiSuplier.map((value) => (
                                            <option key={`ubah-profil-suplier-${idBan}-${value}`} value={value}>
                                              {value}
                                            </option>
                                          ))}
                                        </select>
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          className="form-control form-control-sm"
                                          defaultValue={String(row?.catatan || "")}
                                          onBlur={(e) => updateUbahProfilBanRow(idBan, "catatan", e.target.value)}
                                          placeholder="Catatan"
                                        />
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    {selectedUbahProfilBanRows.length > 0 && (
                      <>
                        <div className="col-12">
                          <div className="row g-3 align-items-stretch">
                            <div className="col-12 col-lg-6">
                              <div className="card page16-soft-card h-100">
                                <div className="card-body">
                                  <div className="d-flex justify-content-center mb-2">
                                    <span>Upload Dokumen</span>
                                  </div>
                                  <PageKonten9_Pict
                                    attachments={attachmentsUbahProfilBan}
                                    setAttachments={setAttachmentsUbahProfilBan}
                                    bisaInput={true}
                                    invalidCaptionIndexes={invalidCaptionIndexesUbahProfilBan}
                                    onCaptionChange={() => setInvalidCaptionIndexesUbahProfilBan([])}
                                  />
                                  <small className="text-muted d-block mt-1">
                                    Opsional. Jika upload dokumen, caption wajib diisi.
                                  </small>
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-lg-6 d-flex flex-column gap-3">
                              <div className="card page16-soft-card">
                                <div className="card-body">
                                  <div className="row g-2 justify-content-between align-items-center">
                                    <div className="col-12 col-md-6">
                                      <span className="fw-semibold">Petugas Input</span>
                                    </div>
                                    <div className="col-12 col-md-6">
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={String(actorNama)}
                                        readOnly
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="flex-grow-1" />
                              <div className="d-flex justify-content-end gap-2">
                                <button
                                  type="button"
                                  className="btn btn-outline-secondary"
                                  disabled={isSubmittingUbahProfilBan}
                                  onClick={() => {
                                    setSelectedUbahProfilBanRows([]);
                                    setSelectedUbahProfilBanIds([]);
                                    setAttachmentsUbahProfilBan([]);
                                    setInvalidCaptionIndexesUbahProfilBan([]);
                                  }}
                                >
                                  Batal
                                </button>
                                <button
                                  type="button"
                                  className="btn page16-gradient-btn text-white"
                                  disabled={isSubmittingUbahProfilBan}
                                  onClick={handleSubmitUbahProfilBan}
                                >
                                  {isSubmittingUbahProfilBan ? "Memproses..." : "Simpan Ubah Profil Ban"}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                )}

                {selectedAction.value === "persetujuan_ubah_status" && (
                  <div className="row g-3">
                    <div className="col-12 col-lg-4">
                      <label className="form-label">Cabang</label>
                      {!isPusat ? (
                        <input className="form-control" value={namaCabangUser || "-"} readOnly />
                      ) : (
                        <select
                          className="form-select"
                          value={persetujuanUbahStatus.kodeCabang}
                          onChange={(e) =>
                            setPersetujuanUbahStatus((prev) => ({ ...prev, kodeCabang: e.target.value }))
                          }
                        >
                          <option value="">Semua Cabang</option>
                          {opsiCabang.map((x) => (
                            <option key={x.kode_cabang} value={x.kode_cabang}>
                              {x.nama_cabang}
                            </option>
                          ))}
                        </select>
                      )}
                    </div>
                    <div className="col-12">
                      <div className="card page16-soft-card">
                        <div className="card-body page30-persetujuan-body">
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div className="fw-semibold">Daftar Usulan Perubahan Status Menunggu Persetujuan</div>
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-primary"
                              onClick={handleLihatPersetujuanUbahStatus}
                              disabled={loadingPersetujuanUbahStatus || persetujuanUbahStatusRows.length === 0}
                            >
                              Lihat
                            </button>
                          </div>
                          <div className="table-responsive page30-persetujuan-table-wrap">
                            <table className="table table-sm align-middle page30-persetujuan-table table-theme-uniform">
                              <thead>
                                <tr>
                                  <th style={{ width: 64 }}>No.</th>
                                  <th style={{ whiteSpace: "nowrap" }}>No. Memo</th>
                                  <th style={{ width: 140, whiteSpace: "nowrap" }}>Tanggal</th>
                                  <th>Cabang</th>
                                  <th style={{ width: 220 }}>Event</th>
                                  <th style={{ width: 90 }} className="text-center">Qty</th>
                                  <th style={{ width: 90 }} className="text-center">Pilih</th>
                                </tr>
                              </thead>
                              <tbody>
                                {loadingPersetujuanUbahStatus && (
                                  <tr>
                                    <td colSpan={7} className="text-center text-muted">
                                      Memuat data...
                                    </td>
                                  </tr>
                                )}
                                {!loadingPersetujuanUbahStatus && persetujuanUbahStatusRows.length === 0 && (
                                  <tr>
                                    <td colSpan={7} className="text-center text-muted">
                                      Belum ada data ditampilkan.
                                    </td>
                                  </tr>
                                )}
                                {!loadingPersetujuanUbahStatus && persetujuanUbahStatusRows.map((row, idx) => (
                                  <tr
                                    key={`persetujuan-row-${row.id || idx + 1}`}
                                    role="button"
                                    style={{ cursor: "pointer" }}
                                    className={Number(selectedPersetujuanUbahStatusRowId) === Number(row.id) ? "table-primary" : ""}
                                    onClick={() => updatePersetujuanUbahStatusRowRadio(row.id)}
                                  >
                                    <td>{idx + 1}</td>
                                    <td style={{ whiteSpace: "nowrap" }}>{row.nomor || "-"}</td>
                                    <td style={{ whiteSpace: "nowrap" }}>{formatDateDDMMYYYY(row.tanggal)}</td>
                                    <td>{row.cabangPengusul || "-"}</td>
                                    <td>{row.event || "-"}</td>
                                    <td className="text-center">{Number(row?.qty || 0)}</td>
                                    <td className="text-center">
                                      <input
                                        type="radio"
                                        className="form-check-input"
                                        name="persetujuan-ubah-status-radio"
                                        checked={Number(selectedPersetujuanUbahStatusRowId) === Number(row.id)}
                                        onChange={() => updatePersetujuanUbahStatusRowRadio(row.id)}
                                      />
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {selectedAction.value === "pengiriman_casing" && (
                  <div className="row g-3">
                    <div className="col-12">
                          <div className="row g-3">
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Cabang Pengirim</label>
                              {!isPusat ? (
                                <input className="form-control" value={namaCabangUser || "-"} readOnly />
                              ) : (
                                <select
                                  className={`form-select ${invalidPengirimanCabang ? "field-required-invalid" : ""}`}
                                  value={pengirimanCasing.kodeCabang}
                                  onChange={(e) => setPengirimanCasing((prev) => ({ ...prev, kodeCabang: e.target.value }))}
                                >
                                  <option value="">Pilih Cabang</option>
                                  {opsiCabang.map((x) => (
                                    <option key={x.kode_cabang} value={x.kode_cabang}>
                                      {x.nama_cabang}
                                    </option>
                                  ))}
                                </select>
                              )}
                            </div>
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Nomor Transaksi</label>
                              <input className="form-control" value={pengirimanCasing.nomor || "-"} readOnly />
                            </div>
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Tanggal Input</label>
                              <input
                                type="date"
                                className="form-control"
                                value={pengirimanCasing.tanggal}
                                readOnly
                              />
                            </div>

                            <div className="col-12 col-lg-4">
                              <label className="form-label">No. Dokumen (SJ)</label>
                              <input
                                type="text"
                                className={`form-control ${invalidPengirimanNoDok ? "field-required-invalid" : ""}`}
                                value={pengirimanCasing.noDokumen}
                                onChange={(e) => setPengirimanCasing((prev) => ({ ...prev, noDokumen: sanitizeNoDokumenInput(e.target.value) }))}
                              />
                            </div>
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Tgl. Dokumen</label>
                              <input
                                type="date"
                                className={`form-control ${invalidPengirimanTglDok ? "field-required-invalid" : ""}`}
                                value={pengirimanCasing.tglDokumen}
                                onChange={(e) => setPengirimanCasing((prev) => ({ ...prev, tglDokumen: e.target.value }))}
                              />
                            </div>
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Vendor</label>
                              <select
                                className={`form-select ${invalidPengirimanVendor ? "field-required-invalid" : ""}`}
                                value={pengirimanCasing.vendor}
                                onChange={(e) => setPengirimanCasing((prev) => ({ ...prev, vendor: e.target.value }))}
                              >
                                <option value="">- Pilih -</option>
                                {opsiSuplier.map((v) => (
                                  <option key={v} value={v}>
                                    {v}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                    </div>

                    <div className="col-12 col-lg-6">
                      <div className="card page16-soft-card h-100">
                        <div className="card-body">
                          <label className="form-label">Catatan</label>
                          <textarea
                            rows={5}
                            className="form-control"
                            placeholder="Catatan pengiriman ban ke pabrik..."
                            value={pengirimanCasing.catatan}
                            onChange={(e) => setPengirimanCasing((prev) => ({ ...prev, catatan: e.target.value }))}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-lg-6">
                      <div className="card page16-soft-card h-100">
                        <div className="card-body">
                          <div className="d-flex justify-content-center mb-2">
                            <span>Upload Dokumen</span>
                          </div>
                          <PageKonten9_Pict
                            attachments={attachmentsPengirimanCasing}
                            setAttachments={setAttachmentsPengirimanCasing}
                            bisaInput={true}
                            uploadInputClassName={invalidPengirimanLampiran ? "field-required-invalid" : ""}
                            invalidCaptionIndexes={invalidCaptionIndexesPengirimanCasing}
                            onCaptionChange={() => setInvalidCaptionIndexesPengirimanCasing([])}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 d-flex justify-content-end gap-2">
                      {readySimpanPengirimanCasing && (
                        <div className="me-auto align-self-center text-success small fw-semibold">
                          {`Sebanyak ${selectedPengirimanCasingRows.length} data ban telah di input, lanjutkan simpan data ke server.`}
                        </div>
                      )}
                      <button type="button" className="btn btn-outline-secondary" onClick={() => setActiveAction("")}>
                        Batal
                      </button>
                      {readySimpanPengirimanCasing && (
                        <button
                          type="button"
                          className="btn btn-outline-primary"
                          onClick={() => setShowPengirimanCasingTableScreen(true)}
                        >
                          Edit
                        </button>
                      )}
                      <button
                        type="button"
                        className="btn page16-gradient-btn text-white"
                        onClick={readySimpanPengirimanCasing ? submitPengirimanCasing : handleLanjutkanPengirimanCasing}
                        disabled={
                          (!readySimpanPengirimanCasing && (!pengirimanCasingStep1Ready || loadingPengirimanCasingRows))
                          || (readySimpanPengirimanCasing && (!pengirimanCasingStep1Ready || selectedPengirimanCasingRows.length === 0 || attachmentsPengirimanCasing.length === 0 || isSubmittingPengirimanCasing))
                        }
                      >
                        {readySimpanPengirimanCasing
                          ? (isSubmittingPengirimanCasing ? "Memproses..." : "Simpan Pengiriman Casing")
                          : (loadingPengirimanCasingRows ? "Memuat..." : "Lanjutkan")}
                      </button>
                    </div>
                  </div>
                )}

                {selectedAction.value === "perintah_pemindahan_stock" && (
                  <div className="row g-3">
                    <div className="col-12">
                          <div className="row g-3">
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Cabang Pengirim</label>
                              {!isPusat ? (
                                <input className="form-control" value={namaCabangUser || "-"} readOnly />
                              ) : (
                                <select
                                  className={`form-select ${invalidPerintahPemindahanStockCabang ? "field-required-invalid" : ""}`}
                                  value={perintahPemindahanStock.kodeCabang}
                                  onChange={(e) => setPerintahPemindahanStock((prev) => ({ ...prev, kodeCabang: e.target.value }))}
                                >
                                  <option value="">Pilih Cabang</option>
                                  {opsiCabang.map((x) => (
                                    <option key={`pindah-stock-cabang-${x.kode_cabang}`} value={x.kode_cabang}>
                                      {x.nama_cabang}
                                    </option>
                                  ))}
                                </select>
                              )}
                            </div>
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Nomor Transaksi</label>
                              <input className="form-control" value={perintahPemindahanStock.nomor || "-"} readOnly />
                            </div>
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Tanggal Input</label>
                              <input
                                type="date"
                                className="form-control"
                                value={perintahPemindahanStock.tanggal}
                                readOnly
                              />
                            </div>

                            <div className="col-12 col-lg-4">
                              <label className="form-label">Cabang Penerima</label>
                              <select
                                className={`form-select ${invalidPerintahPemindahanStockCabangPenerima ? "field-required-invalid" : ""}`}
                                value={perintahPemindahanStock.kodeCabangPenerima}
                                onChange={(e) => setPerintahPemindahanStock((prev) => ({ ...prev, kodeCabangPenerima: e.target.value }))}
                              >
                                <option value="">- Pilih -</option>
                                {opsiCabang
                                  .filter((x) => String(x?.kode_cabang || "").trim() !== String(perintahPemindahanStock.kodeCabang || "").trim())
                                  .map((x) => (
                                  <option key={`pindah-stock-cabang-penerima-${x.kode_cabang}`} value={x.kode_cabang}>
                                    {x.nama_cabang}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="col-12 col-lg-4">
                              <label className="form-label">No. Dokumen (SJ)</label>
                              <input
                                type="text"
                                className={`form-control ${invalidPerintahPemindahanStockNoDok ? "field-required-invalid" : ""}`}
                                value={perintahPemindahanStock.noDokumen}
                                onChange={(e) => setPerintahPemindahanStock((prev) => ({ ...prev, noDokumen: sanitizeNoDokumenInput(e.target.value) }))}
                              />
                            </div>
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Tgl. Dokumen</label>
                              <input
                                type="date"
                                className={`form-control ${invalidPerintahPemindahanStockTglDok ? "field-required-invalid" : ""}`}
                                value={perintahPemindahanStock.tglDokumen}
                                onChange={(e) => setPerintahPemindahanStock((prev) => ({ ...prev, tglDokumen: e.target.value }))}
                              />
                            </div>
                          </div>
                    </div>

                    <div className="col-12">
                      <div className="card page16-soft-card mt-3">
                        <div className="card-body d-flex justify-content-between align-items-center flex-wrap gap-2">
                          <div>
                            <div className="fw-semibold">Daftar Ban Pindah Cabang</div>
                          </div>
                          <div className="d-flex align-items-center gap-2">
                            {selectedPerintahPemindahanStockIds.length > 0 && (
                              <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => {
                                  setSelectedPerintahPemindahanStockRows([]);
                                  setSelectedPerintahPemindahanStockIds([]);
                                }}
                              >
                                Clear
                              </button>
                            )}
                            <button
                              type="button"
                              className="btn btn-primary"
                              disabled={!perintahPemindahanStockStep1Ready}
                              onClick={handleOpenPilihBanPerintahPemindahanStock}
                            >
                              Pilih Ban
                            </button>
                          </div>
                        </div>
                        {selectedPerintahPemindahanStockIds.length > 0 && (
                          <div className="table-responsive">
                            <table className="table table-sm table-bordered table-hover align-middle table-theme-uniform">
                              <thead className="table-light">
                                <tr>
                                  <th style={{ width: 70 }} className="text-center">NO</th>
                                  <th>NO SERI</th>
                                  <th style={{ width: 180 }}>STATUS</th>
                                  <th style={{ width: 220 }}>CABANG PENGIRIM</th>
                                  <th style={{ width: 220 }}>CABANG PENERIMA</th>
                                  <th style={{ width: 110 }} className="text-center">LIHAT</th>
                                </tr>
                              </thead>
                              <tbody>
                                {selectedPerintahPemindahanStockRows.map((row, idx) => (
                                  <tr key={`picked-pindah-stock-ban-${row.id_ban}`}>
                                    <td className="text-center">{idx + 1}</td>
                                    <td>
                                      <span
                                        style={{
                                          display: "inline-block",
                                          maxWidth: 360,
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap",
                                        }}
                                        title={row.seri_ban || "-"}
                                      >
                                        {row.seri_ban || "-"}
                                      </span>
                                    </td>
                                    <td>{row.status || "-"}</td>
                                    <td>
                                      {opsiCabang.find((x) => String(x?.kode_cabang || "").trim() === String(perintahPemindahanStock.kodeCabang || "").trim())?.nama_cabang
                                        || perintahPemindahanStock.kodeCabang
                                        || "-"}
                                    </td>
                                    <td>
                                      {opsiCabang.find((x) => String(x?.kode_cabang || "").trim() === String(perintahPemindahanStock.kodeCabangPenerima || "").trim())?.nama_cabang
                                        || perintahPemindahanStock.kodeCabangPenerima
                                        || "-"}
                                    </td>
                                    <td className="text-center">
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-outline-secondary"
                                        onClick={() => {
                                          setBanShowTargetId(Number(row.id_ban || 0));
                                          setOpenBanShowModal(true);
                                        }}
                                      >
                                        Lihat
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-12 col-lg-6">
                      <div className="card page16-soft-card h-100">
                        <div className="card-body">
                          <label className="form-label">Catatan</label>
                          <textarea
                            rows={5}
                            className="form-control"
                            placeholder="Catatan perintah pemindahan stock..."
                            value={perintahPemindahanStock.catatan}
                            onChange={(e) => setPerintahPemindahanStock((prev) => ({ ...prev, catatan: e.target.value }))}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-lg-6">
                      <div className="card page16-soft-card h-100">
                        <div className="card-body">
                          <div className="d-flex justify-content-center mb-2">
                            <span>Upload Dokumen</span>
                          </div>
                          <PageKonten9_Pict
                            attachments={attachmentsPerintahPemindahanStock}
                            setAttachments={setAttachmentsPerintahPemindahanStock}
                            bisaInput={true}
                            uploadInputClassName={invalidPerintahPemindahanStockLampiran ? "field-required-invalid" : ""}
                            invalidCaptionIndexes={invalidCaptionIndexesPerintahPemindahanStock}
                            onCaptionChange={() => setInvalidCaptionIndexesPerintahPemindahanStock([])}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 d-flex justify-content-end gap-2">
                      {readySimpanPerintahPemindahanStock && (
                        <div className="me-auto align-self-center text-success small fw-semibold">
                          {`Sebanyak ${selectedPerintahPemindahanStockIds.length} data ban telah dipilih, lanjutkan simpan data ke server.`}
                        </div>
                      )}
                      <button type="button" className="btn btn-outline-secondary" onClick={() => setActiveAction("")}>
                        Batal
                      </button>
                      <button
                        type="button"
                        className="btn page16-gradient-btn text-white"
                        onClick={submitPerintahPemindahanStock}
                        disabled={
                          !readySimpanPerintahPemindahanStock
                          || !perintahPemindahanStockStep1Ready
                          || selectedPerintahPemindahanStockIds.length === 0
                          || attachmentsPerintahPemindahanStock.length === 0
                          || isSubmittingPerintahPemindahanStock
                        }
                      >
                        {isSubmittingPerintahPemindahanStock ? "Memproses..." : "Simpan Perintah Pemindahan"}
                      </button>
                    </div>
                  </div>
                )}

                {selectedAction.value === "pengiriman_ban_ke_cabang_lain" && (
                  <div className="row g-3">
                    <div className="col-12">
                      <div className="row g-3">
                        <div className="col-12 col-lg-4">
                          <label className="form-label">Cabang Pengirim</label>
                          {!isPusat ? (
                            <input className="form-control" value={namaCabangUser || "-"} readOnly />
                          ) : (
                            <select
                              className={`form-select ${invalidPengirimanBanKeCabangLainCabang ? "field-required-invalid" : ""}`}
                              value={pengirimanBanKeCabangLain.kodeCabang}
                              onChange={(e) => setPengirimanBanKeCabangLain((prev) => ({ ...prev, kodeCabang: e.target.value }))}
                            >
                              <option value="">Pilih Cabang</option>
                              <option value={CABANG_ALL_VALUE}>Semua Cabang</option>
                              {opsiCabang
                                .filter((x) => String(x?.kode_cabang || "").trim() !== "C-1")
                                .map((x) => (
                                  <option key={`kirim-cabang-lain-pengirim-${x.kode_cabang}`} value={x.kode_cabang}>
                                    {x.nama_cabang}
                                  </option>
                                ))}
                            </select>
                          )}
                        </div>
                        <div className="col-12 col-lg-4">
                          <label className="form-label">No. Pending Pemindahan Ban</label>
                          <select
                            className={`form-select ${invalidPengirimanBanKeCabangLainNomor ? "field-required-invalid" : ""}`}
                            value={pengirimanBanKeCabangLain.nomor || ""}
                            onChange={(e) => setPengirimanBanKeCabangLain((prev) => ({ ...prev, nomor: e.target.value }))}
                            disabled={!String(pengirimanBanKeCabangLain.kodeCabang || "").trim() || pendingNomorPengirimanBanKeCabangLainOptions.length === 0}
                          >
                            {pendingNomorPengirimanBanKeCabangLainOptions.length === 0 && (
                              <option value="">-Tidak ada Pending-</option>
                            )}
                            {pendingNomorPengirimanBanKeCabangLainOptions.map((item) => (
                              <option key={`pending-kirim-cabang-lain-${item.id}-${item.nomor}`} value={item.nomor}>
                                {item.nomor}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-12 col-lg-4">
                          <label className="form-label">Tanggal Input</label>
                          <input
                            type="date"
                            className={`form-control ${invalidPengirimanBanKeCabangLainTanggal ? "field-required-invalid" : ""}`}
                            value={pengirimanBanKeCabangLain.tanggal}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>

                    {pengirimanBanKeCabangLainStep1Ready && (
                      <>
                    <div className="col-12 col-lg-6">
                      <div className="card page16-soft-card h-100">
                        <div className="card-body">
                          <label className="form-label">Catatan Pusat</label>
                          <textarea
                            rows={1}
                            className="form-control"
                            value={String(pengirimanBanKeCabangLain.catatanPusat || "").trim() || "-"}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-lg-6">
                      <div className="card page16-soft-card h-100">
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <span className="fw-semibold">Dokumen Lampiran</span>
                          </div>
                          <div className="d-grid gap-2">
                            {attachmentsPengirimanBanKeCabangLainReadOnly.length === 0 && (
                              <div className="text-muted small">Belum ada lampiran.</div>
                            )}
                            {attachmentsPengirimanBanKeCabangLainReadOnly.length > 0 && (
                              <button
                                type="button"
                                className="btn btn-sm page16-gradient-btn text-white"
                                width="auto"
                                onClick={() => openLampiranPreviewStandarModal({
                                  nomor: pengirimanBanKeCabangLain.nomor,
                                  lampiran: attachmentsPengirimanBanKeCabangLainReadOnly,
                                })}
                              >
                                Lihat Lampiran
                              </button>
                            )}
                            {/*attachmentsPengirimanBanKeCabangLainReadOnly.map((item, idx) => {
                              const caption = String(item?.caption || item?.name || "").trim() || `Lampiran ${idx + 1}`;
                              const fileName = String(item?.name || item?.file || "").trim() || `Lampiran ${idx + 1}`;
                              const fileRow = {
                                nomor: pengirimanBanKeCabangLain.nomor,
                                lampiran: [item],
                              };
                              return (
                                <button
                                  key={`preview-lampiran-kirim-cabang-${idx}`}
                                  type="button"
                                  className="btn btn-outline-secondary text-start"
                                  onClick={() => openLampiran(fileRow)}
                                >
                                  <div className="small fw-semibold">{caption}</div>
                                  <div className="small text-muted">{fileName}</div>
                                </button>
                              );
                            })*/}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="card page16-soft-card">
                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-sm table-bordered table-hover align-middle table-theme-uniform">
                              <thead className="table-light">
                                <tr>
                                  <th style={{ width: 70 }} className="text-center">NO</th>
                                  <th style={{ width: 220 }}>NOMOR</th>
                                  <th>NO SERI</th>
                                  <th style={{ width: 180 }}>STATUS</th>
                                  <th style={{ width: 220 }}>CABANG PENERIMA</th>
                                  {!isCabangC1 && (
                                    <th style={{ width: 90 }} className="text-center">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={
                                          pengirimanBanKeCabangLainRows.length > 0
                                          && pengirimanBanKeCabangLainRows.every((x) => Boolean(x?.checked))
                                        }
                                        onChange={(e) => toggleAllCheckedPengirimanBanKeCabangLain(e.target.checked)}
                                        aria-label="Pilih semua baris"
                                      />
                                    </th>
                                  )}
                                  <th style={{ width: 110 }} className="text-center">{isCabangC1 ? "HAPUS" : "LIHAT"}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {loadingPengirimanBanKeCabangLainRows && (
                                  <tr>
                                    <td colSpan={isCabangC1 ? 6 : 7} className="text-center text-muted">Memuat data...</td>
                                  </tr>
                                )}
                                {!loadingPengirimanBanKeCabangLainRows && pengirimanBanKeCabangLainRows.length === 0 && (
                                  <tr>
                                    <td colSpan={isCabangC1 ? 6 : 7} className="text-center text-muted">Belum ada data ditampilkan.</td>
                                  </tr>
                                )}
                                {!loadingPengirimanBanKeCabangLainRows && pengirimanBanKeCabangLainRows.map((row, idx) => (
                                  <tr key={`kirim-cabang-lain-${row.recordId}-${row.id_ban}-${idx}`}>
                                    <td className="text-center">{idx + 1}</td>
                                    <td>{row.nomor_dokumen || "-"}</td>
                                    <td>{row.seri_ban || "-"}</td>
                                    <td>{row.status || "-"}</td>
                                    <td>{row.cabang_penerima || "-"}</td>
                                    {!isCabangC1 && (
                                      <td className="text-center">
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={Boolean(row.checked)}
                                          onChange={(e) => toggleCheckedPengirimanBanKeCabangLain(idx, e.target.checked)}
                                        />
                                      </td>
                                    )}
                                    <td className="text-center">
                                      {isCabangC1 ? (
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-outline-danger"
                                          onClick={() => askDeletePengirimanMutasiRow(row)}
                                        >
                                          Hapus
                                        </button>
                                      ) : (
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-outline-secondary"
                                          onClick={() => {
                                            setBanShowTargetId(Number(row.id_ban || 0));
                                            setOpenBanShowModal(true);
                                          }}
                                        >
                                          Lihat
                                        </button>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>

                    {!isCabangC1 && (
                      <>
                        <div className="col-12 col-lg-6">
                          <div className="card page16-soft-card h-100">
                            <div className="card-body">
                              <label className="form-label">
                                {isPengirimanBanKeCabangLainSebagian ? "Catatan (Wajib)" : "Catatan"}
                              </label>
                              <textarea
                                ref={catatanPengirimanSebagianRef}
                                rows={5}
                                className={`form-control ${
                                  isPengirimanBanKeCabangLainSebagian
                                  && !String(pengirimanBanKeCabangLain.catatan || "").trim()
                                    ? "field-required-invalid"
                                    : ""
                                }`}
                                placeholder={
                                  isPengirimanBanKeCabangLainSebagian
                                    ? "Alasan pengiriman sebagian (wajib)..."
                                    : "Catatan pengiriman ban ke cabang lain..."
                                }
                                value={pengirimanBanKeCabangLain.catatan}
                                onChange={(e) => setPengirimanBanKeCabangLain((prev) => ({ ...prev, catatan: e.target.value }))}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-lg-6">
                          <div className="card page16-soft-card h-100">
                            <div className="card-body">
                              <div className="d-flex justify-content-center mb-2">
                                <span>Upload Dokumen</span>
                              </div>
                              <PageKonten9_Pict
                                attachments={attachmentsPengirimanBanKeCabangLain}
                                setAttachments={setAttachmentsPengirimanBanKeCabangLain}
                                bisaInput={true}
                                uploadInputClassName=""
                                invalidCaptionIndexes={invalidCaptionIndexesPengirimanBanKeCabangLain}
                                onCaptionChange={() => setInvalidCaptionIndexesPengirimanBanKeCabangLain([])}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="card page16-verify-card page16-soft-card">
                            <div className="card-body">
                              <div className="row g-2 align-items-center">
                                <div className="col-12 col-md-8">
                                  <span className="fw-semibold">Petugas Input</span>
                                </div>
                                <div className="col-12 col-md-4 ms-md-auto">
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={actorNama || '-'}
                                    readOnly
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    <div className="col-12 d-flex justify-content-end gap-2">
                      <button type="button" className="btn btn-outline-secondary" onClick={() => setActiveAction("")}>
                        Batal
                      </button>
                      {!isCabangC1 && (
                        <button
                          type="button"
                          className="btn page16-gradient-btn text-white"
                          onClick={submitPengirimanBanKeCabangLain}
                          disabled={
                            !pengirimanBanKeCabangLainStep1Ready
                            || pengirimanBanKeCabangLainRows.filter((x) => Boolean(x?.checked)).length === 0
                            || isSubmittingPengirimanBanKeCabangLain
                          }
                        >
                          {isSubmittingPengirimanBanKeCabangLain ? "Memproses..." : "Simpan Pengiriman"}
                        </button>
                      )}
                    </div>
                      </>
                    )}
                  </div>
                )}

                {selectedAction.value === "terima_ban_vulkanisir" && (
                  <div className="row g-3">
                    <div className="col-12">
                          <div className="row g-3">
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Cabang Penerima</label>
                              {!isPusat ? (
                                <input className="form-control" value={namaCabangUser || "-"} readOnly />
                              ) : (
                                <select
                                  className={`form-select ${invalidTerimaCabang ? "field-required-invalid" : ""}`}
                                  value={terimaBanVulkanisir.kodeCabang}
                                  onChange={(e) => setTerimaBanVulkanisir((prev) => ({ ...prev, kodeCabang: e.target.value }))}
                                >
                                  <option value="">Pilih Cabang</option>
                                  {opsiCabang.map((x) => (
                                    <option key={`terima-panel-cabang-${x.kode_cabang}`} value={x.kode_cabang}>
                                      {x.nama_cabang}
                                    </option>
                                  ))}
                                </select>
                              )}
                            </div>
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Nomor Transaksi</label>
                              <input className="form-control" value={terimaBanVulkanisir.nomor || "-"} readOnly />
                            </div>
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Tanggal Input</label>
                              <input
                                type="date"
                                className="form-control"
                                value={terimaBanVulkanisir.tanggal}
                                readOnly
                              />
                            </div>
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Vendor</label>
                              <select
                                className={`form-select ${invalidTerimaVendor ? "field-required-invalid" : ""}`}
                                value={terimaBanVulkanisir.vendor}
                                onChange={(e) => setTerimaBanVulkanisir((prev) => ({ ...prev, vendor: e.target.value }))}
                              >
                                <option value="">- Pilih -</option>
                                {opsiSuplier.map((v) => (
                                  <option key={`terima-vendor-${v}`} value={v}>
                                    {v}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="col-12 col-lg-4">
                              <label className="form-label">No. Dokumen (SJ)</label>
                              <input
                                type="text"
                                className={`form-control ${invalidTerimaNoDok ? "field-required-invalid" : ""}`}
                                value={terimaBanVulkanisir.noDokumen}
                                onChange={(e) => setTerimaBanVulkanisir((prev) => ({ ...prev, noDokumen: sanitizeNoDokumenInput(e.target.value) }))}
                              />
                            </div>
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Tgl. Dokumen</label>
                              <input
                                type="date"
                                className={`form-control ${invalidTerimaTglDok ? "field-required-invalid" : ""}`}
                                value={terimaBanVulkanisir.tglDokumen}
                                onChange={(e) => setTerimaBanVulkanisir((prev) => ({ ...prev, tglDokumen: e.target.value }))}
                              />
                            </div>
                          </div>
                    </div>

                    <div className="col-12 col-lg-6">
                      <div className="card page16-soft-card h-100">
                        <div className="card-body">
                          <label className="form-label">Catatan</label>
                          <textarea
                            rows={5}
                            className="form-control"
                            placeholder="Catatan pengiriman ban retread ke gudang..."
                            value={terimaBanVulkanisir.catatan}
                            onChange={(e) => setTerimaBanVulkanisir((prev) => ({ ...prev, catatan: e.target.value }))}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-lg-6">
                      <div className="card page16-soft-card h-100">
                        <div className="card-body">
                          <div className="d-flex justify-content-center mb-2">
                            <span>Upload Dokumen</span>
                          </div>
                          <PageKonten9_Pict
                            attachments={attachmentsTerimaBanVulkanisir}
                            setAttachments={setAttachmentsTerimaBanVulkanisir}
                            bisaInput={true}
                            uploadInputClassName={invalidTerimaLampiran ? "field-required-invalid" : ""}
                            invalidCaptionIndexes={invalidCaptionIndexesTerimaBanVulkanisir}
                            onCaptionChange={() => setInvalidCaptionIndexesTerimaBanVulkanisir([])}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 d-flex justify-content-end gap-2">
                      {readySimpanTerimaBanVulkanisir && (
                        <div className="me-auto align-self-center text-success small fw-semibold">
                          {`Sebanyak ${selectedTerimaBanVulkanisirRows.length} data ban retread telah di input, lanjutkan simpan data.`}
                        </div>
                      )}
                      <button type="button" className="btn btn-outline-secondary" onClick={() => setActiveAction("")}>
                        Batal
                      </button>
                      {readySimpanTerimaBanVulkanisir && (
                        <button
                          type="button"
                          className="btn btn-outline-primary"
                          onClick={() => setShowTerimaBanVulkanisirTableScreen(true)}
                        >
                          Edit
                        </button>
                      )}
                      <button
                        type="button"
                        className="btn page16-gradient-btn text-white"
                        onClick={readySimpanTerimaBanVulkanisir ? handleSimpanDataTerimaBanVulkanisir : handleLanjutkanTerimaBanVulkanisir}
                        disabled={
                          (!readySimpanTerimaBanVulkanisir && (!terimaBanVulkanisirStep1Ready || loadingTerimaBanVulkanisirRows))
                          || (readySimpanTerimaBanVulkanisir && (!terimaBanVulkanisirStep1Ready || selectedTerimaBanVulkanisirRows.length === 0 || attachmentsTerimaBanVulkanisir.length === 0 || isSubmittingTerimaBanVulkanisir))
                        }
                      >
                        {readySimpanTerimaBanVulkanisir
                          ? (isSubmittingTerimaBanVulkanisir ? "Memproses..." : "SIMPAN PENGIRIMAN RETREAD")
                          : (loadingTerimaBanVulkanisirRows ? "Memuat..." : "Lanjutkan")}
                      </button>
                    </div>
                  </div>
                )}
                {selectedAction.value === "perubahan_status_ban" && (
                  <div className="row g-3">
                    <div className="col-12">
                          <div className="row g-3">
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Cabang</label>
                              {!isPusat ? (
                                <input className="form-control" value={namaCabangUser || "-"} readOnly />
                              ) : (
                                <select
                                  className={`form-select ${invalidPerubahanStatusCabang ? "field-required-invalid" : ""}`}
                                  value={perubahanStatusBan.kodeCabang}
                                  onChange={(e) =>
                                    setPerubahanStatusBan((prev) => ({ ...prev, kodeCabang: e.target.value }))
                                  }
                                >
                                  <option value="">Pilih Cabang</option>
                                  {opsiCabang.map((x) => (
                                    <option key={x.kode_cabang} value={x.kode_cabang}>
                                      {x.nama_cabang}
                                    </option>
                                  ))}
                                </select>
                              )}
                            </div>
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Nomor Transaksi</label>
                              <input className="form-control" value={perubahanStatusBan.nomor || "-"} readOnly />
                            </div>
                            <div className="col-12 col-lg-4">
                              <label className="form-label">Tanggal Input</label>
                              <input
                                type="date"
                                className="form-control"
                                value={perubahanStatusBan.tanggal}
                                readOnly
                                onChange={(e) =>
                                  setPerubahanStatusBan((prev) => ({ ...prev, tanggal: e.target.value }))
                                }
                              />
                            </div>
                          </div>
                    

                    <div className="col-12">
                      <div className="card page16-soft-card mt-3">
                        <div className="card-body d-flex justify-content-between align-items-center flex-wrap gap-2">
                          <div>
                            <div className="fw-semibold">Daftar Ban Berubah Status</div>
                          </div>
                          <div className="d-flex align-items-center gap-2">
                            {selectedPerubahanStatusBanIds.length > 0 && (
                              <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => {
                                  setSelectedPerubahanStatusBanRows([]);
                                  setSelectedPerubahanStatusBanIds([]);
                                  setStatusChangeByBanId({});
                                  setAttachmentsPerubahanStatusBan([]);
                                  setInvalidCaptionIndexesPerubahanStatusBan([]);
                                  setStatusLampiranPerubahanByBanId({});
                                  setInvalidStatusLampiranPerubahanByBanId({});
                                  setStatusBanTarget(null);
                                }}
                              >
                                Clear
                              </button>
                            )}
                            <button
                              type="button"
                              className="btn btn-primary"
                              disabled={!perubahanStatusBanStep1Ready}
                              onClick={handleOpenPilihBanPerubahanStatus}
                            >
                              Pilih Ban
                            </button>
                          </div>
                        </div>
                         {selectedPerubahanStatusBanIds.length > 0 && (
                        <div className="table-responsive">
                              <table className="table table-sm table-bordered table-hover align-middle table-theme-uniform">
                                <thead className="table-light">
                                  <tr>
                                    <th style={{ width: 100 }} className="text-center">ID_BAN</th>
                                    <th>NO SERI</th>
                                    <th style={{ width: 200 }}>MERK</th>
                                    <th style={{ width: 240 }}>STATUS</th>
                                    <th style={{ width: 110 }} className="text-center">LIHAT</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {selectedPerubahanStatusDisplayRows.map((row) => (
                                    <tr key={`picked-status-ban-${row.id_ban}`}>
                                      <td className="text-center">{row.id_ban}</td>
                                      <td>
                                        <div className="d-flex align-items-center gap-1 flex-nowrap" style={{ minWidth: 0 }}>
                                          <span
                                            style={{
                                              display: "inline-block",
                                              maxWidth: 360,
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              whiteSpace: "nowrap",
                                            }}
                                            title={row.seri_ban || "-"}
                                          >
                                            {row.seri_ban || "-"}
                                          </span>
                                          <span
                                            aria-hidden="true"
                                            style={{ width: 18, height: 18, display: "inline-flex", alignItems: "center", justifyContent: "center", visibility: row.done ? "visible" : "hidden" }}
                                          >
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18">
                                              <path fill="#0d6efd" d="M12 2a10 10 0 1 0 10 10A10.01 10.01 0 0 0 12 2Zm-1 14-4-4 1.41-1.41L11 13.17l4.59-4.58L17 10Z" />
                                            </svg>
                                          </span>
                                        </div>
                                      </td>
                                      <td style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 200 }}>
                                        <span title={row.merk || "-"}>{row.merk || "-"}</span>
                                      </td>
                                      <td>
                                        <button
                                          type="button"
                                          className={`btn btn-sm w-100 text-start ${row.done ? "btn-primary" : "btn-outline-primary"}`}
                                          onClick={() => handleOpenStatusPerubahanModal(row)}
                                        >
                                          {row.statusBaru ? `${row.statusSaatIni} -> ${row.statusBaru}` : row.statusSaatIni}
                                        </button>
                                      </td>
                                      <td className="text-center">
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-outline-secondary"
                                          onClick={() => {
                                            setBanShowTargetId(Number(row.id_ban || 0));
                                            setOpenBanShowModal(true);
                                          }}
                                        >
                                          Lihat
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>)}      
                      </div>
                        {selectedPerubahanStatusBanIds.length > 0 && (
                          <div className="row g-3 mt-1">
                            <div className="col-12 col-lg-12">
                              <div className="card page16-soft-card h-100">
                                <div className="card-body">
                                  <div className="d-flex justify-content-center mb-2">
                                    <span>Upload Dokumen</span>
                                  </div>
                                  <PageKonten9_Pict
                                    attachments={attachmentsPerubahanStatusBan}
                                    setAttachments={setAttachmentsPerubahanStatusBan}
                                    bisaInput={true}
                                    uploadInputClassName={invalidPerubahanStatusLampiran ? "bg-warning-subtle border-warning" : ""}
                                    invalidCaptionIndexes={invalidCaptionIndexesPerubahanStatusBan}
                                    onCaptionChange={() => setInvalidCaptionIndexesPerubahanStatusBan([])}
                                  />
                                  {isPerubahanStatusNeedMemoLampiran && (
                                    <small className="text-muted d-block mt-2">
                                      Wajib upload dokumen karena terdapat status yang memerlukan persetujuan.
                                    </small>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {selectedPerubahanStatusBanIds.length > 0 && (
                      <div className="card page16-soft-card mt-3">
                            <div className="card page16-verify-card page16-soft-card">
                              <div className="card-body">
                                <div className="row g-2 justify-content-between align-items-center">
                                  <div className="col-12 col-md-8">
                                    <span className="fw-semibold">Petugas Input</span>
                                  </div>
                                  <div className="col-12 col-md-4 ms-md-auto">
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={String(actorNama)}
                                      readOnly
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                        </div>
                        )}
                        </div>
                      {/**TOMBOL AKSI */}
                      <div className="d-flex justify-content-end gap-2 mt-3">
                              <button
                                type="button"
                                className="btn btn-outline-secondary"
                                disabled={isSubmittingPerubahanStatusBan}
                                onClick={() => {
                                  setSelectedPerubahanStatusBanRows([]);
                                  setSelectedPerubahanStatusBanIds([]);
                                  setStatusChangeByBanId({});
                                  setAttachmentsPerubahanStatusBan([]);
                                  setInvalidCaptionIndexesPerubahanStatusBan([]);
                                  setStatusLampiranPerubahanByBanId({});
                                  setInvalidStatusLampiranPerubahanByBanId({});
                                  setStatusBanTarget(null);
                                }}
                              >
                                Batal
                              </button>
                              <button
                                type="button"
                                className="btn page16-gradient-btn text-white"
                                disabled={!canSubmitPerubahanStatusBan || invalidPerubahanStatusLampiran}
                                onClick={handleSimpanPerubahanStatusBan}
                              >
                                {isSubmittingPerubahanStatusBan ? "Menyimpan..." : "Simpan Perubahan"}
                              </button>
                        </div>
                      </div>
                  </div>
                  
                )}
              </div>
            )}
          </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
